import _ from "lodash";
// DS
import { colors, NoChecklistIllustration } from "@toddle-edu/ds-theme";
import {
  Avatar,
  AvatarGroup,
  Badge,
  Button,
  ButtonDisclosure,
  Dropdown,
  DropdownMenu,
  IconButton,
  SplitButtonDropdown,
  TextAreaInput,
  Tag,
  Alert,
  Modal,
  MediaCard,
  EmptyState,
  Tooltip,
  useKeyboardShortcutsContext,
  DSProvider,
} from "@toddle-edu/ds-web";

import {
  AddCircleOutlined,
  CaretRightFilled,
  DeleteOutlined,
  GoalsOutlined,
  PencilLineOutlined,
  PublishOutlined,
  StudentAddOutlined,
  CopyOutlined,
  ScopeAndSequenceOutlined,
  CalendarScheduleOutlined,
  ChevronDownOutlined,
  TeacherShareOutlined,
  LearningExperienceColored,
  UnitPlanOutlined,
  ChevronRightOutlined,
  AssessmentApplicableOutlined,
  ApprovalTickOutlined,
  SettingsOutlined,
  CommentAddOutlined,
  RefreshArrowOutlined,
  TickCircleFilled,
  DownloadOutlined,
  FolderFilled,
  LeOutlined,
  PostOneOutlined,
  OpenBookTextOutlined,
  CaretClosedFilled,
  CaretOpenedFilled,
  AiOutlined,
} from "@toddle-edu/ds-icons";
import { updatePostStatus } from "Journal/modules/JournalModule";
// Network and support utilities
import { getSettingValue } from "modules/PermissionModule";
import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";
import { compose, graphql } from "lib/apolloClient";
import { useQuery } from "@apollo/client";
import { connect } from "react-redux";
import Accordian from "UIComponents/Accordian";
import I18nHOC from "UIComponents/I18nHOC";
import MoreItemWithToolTip from "UIComponents/MoreItemWithToolTip";
import PYPElements from "UIComponents/PYPElements";
import withLoader from "UIComponents/GqlWithLoader";
import AudioWaveformPlayer from "UIComponents/AudioWaveformPlayer";

import Note from "UIComponents/Note";
import ScrollableCarousel from "UIComponents/ScrollableCarousel";
import UIBaseContentEditable from "UIComponents/UIBaseContentEditable";
import DialogueBoxV3 from "UIComponents/DialogueBoxV3";
import LinkWithTooltip from "UIComponents/LinkWithTooltip";
import KeyboardShortcuts from "UIComponents/KeyboardShortcuts";
import CreatePost from "Post/routes/CreatePost/CreatePost";
import { getCourseFoldersFromCache } from "Journal/modules/JournalGraphqlHelpers";
import { getCourseFolders } from "Journal/modules/JournalQuery";
import { getLearnerPortfolioTagsQuery } from "LearnerPortfolio/modules/LearnerPortfolioQuery";
import { getLearnerPortfolioTagsFromCache } from "LearnerPortfolio/modules/LearnerPortfolioGraphqlHelpers";
import {
  deleteAttachments,
  COLORS_MAPPING_FOR_TAG,
  COLORS_MAPPING_FOR_CHIP,
  updatePostStatusV2,
} from "AppComponents/Post/modules/PostModule";
import {
  getTaggableElements,
  getFieldList,
} from "modules/TaggableElementsUtils";
import { getUserBasicDetailsFromCache } from "modules/CommonGraphqlHelpers";
import { getCurrentProjectGroupDetails } from "routes/routes/Teacher/routes/Projects/modules/ProjectModules";
import {
  PROJECT_TEMPLATE_FIELD_OBJECTS,
  TAGGABLE_PROJECT_ELEMENTS,
} from "routes/routes/Teacher/routes/Projects/routes/ProjectDetails/routes/ProcessJournal/modules/Module";
import {
  TEMPLATE_FIELD_CAS_LEARNING_OUTCOMES_DP,
  TEMPLATE_FIELD_CE_LEARNING_OUTCOMES_DP,
  TEMPLATE_FIELD_SL_LEARNING_OUTCOMES_DP,
  TEMPLATE_FIELD_SERVICE_ACTION_OUTCOMES_MYP,
  CURRICULUM_TYPE_MYP,
  ASC,
  TEMPLATE_FIELD_CE_PROCESS_STAGES,
  TEMPLATE_FIELD_CE_PROCESS_DIMENSIONS,
  TEMPLATE_FIELD_CE_PROCESS_PRINCIPLES,
  TABLET_LANDSCAPE_MEDIA_QUERY,
  CURRICULUM_TYPE_DP,
} from "Constants/stringConstants";
import { getIsTypeOfProjectPortfolioLOs } from "Projects/modules/Utils";
import {
  generateNestedSelectedData,
  getPYPElementSetFromNodes,
  isSafari,
  getCurrentTerm,
  generateRandomId,
  hashString,
  getUpdatedArchivedFilters,
  onEnterOrSpaceKeyDown,
  getMemoizedLangFunction,
  isIpad,
  isIphone,
} from "Utils";
import {
  getIsNewGoalTaggingEnabled,
  getUnitPlanFields,
  isUnitPlanOrAssessmentTagged,
  isAssessmentTagged,
  getPostEntityValues,
  isEvidencingEditRoute,
  getPostEntity,
  getTaggedGoalsCount,
  getIsNewGradingSetupEnabled,
  getIsStandardsRevampEnabled,
  getCurrentPlannerElementSetFromState,
} from "Post/utils";
import { getFormattedUserName } from "Utils/GetFormattedUserName";
import moment from "moment";
import {
  getUserInfo,
  setToastMsg,
  enableGlobalHeader,
  disableGlobalHeader,
} from "Login/modules/LoginModule";

import classnames from "classnames";
// Supoort UI components
import { CreateDropDown } from "Attachment";
import ScreenPanel from "Post/routes/CreatePost/components/ScreenPanel";
import classes from "./ManageSubjectJournalPost.scss";
import SingleUserProfile from "Post/components/SingleUserProfile";
import MultipleAttachmentsSlider from "Post/components/MultipleAttachmentsSlider";
import StudentResponseV2 from "AppComponents/Post/routes/CreatePost/components/Screens/StudentResponseV2";
import { Trans } from "react-i18next";
import FieldComponent from "UnitPlans/components/IBcomponents/FieldComponent";
import { withRouter } from "react-router";
import ProjectCreatePost from "routes/routes/Teacher/routes/Projects/routes/ProjectDetails/routes/ProcessJournal/components/CreatePost/CreatePost";
import ConditionalWrapper from "Utils/ConditionalWrapper";
import TheatreModeV2 from "UIComponents/TheatreModeV2";
import {
  getCombinedDateAndTimeMoment,
  isPortfolioParityEnabled,
  getSharedWithString,
  enableTermRestriction,
  isDPSubjectJournalEnabled,
  isPortfolioAIEnabledAndIsJournalRoute,
  isPortfolioParityEnabledAndIsJournalRoute,
  getPostTranslationFilter,
  hasTranslationPermission,
  isGlobalHeaderOnMultipleScreensEnabled,
  getFormattedUserNameWithoutPronoun,
  isPortfolioReviewSetupEnabled,
  isPortfolioReviewSetupEnabledAndIsReviewRoute,
  isPortfolioReviewSetupEnabledAndIsJournalRoute,
  isPortfolioAIEnabled,
  TRIGGER_EVENT_TYPES,
  getIsMultipleUnitTaggingEnabled,
} from "Post/utils";
import {
  TaggedPracticesV2,
  UnitDetails,
  ManageFoldersModal,
} from "Post/components";
import SchedulePostModal from "Post/components/SchedulePostModal";
import { hasIncludeGivenPathInCurrentRoute } from "Teacher/routes/Courses/routes/Course/routes/UnitPlans/routes/UnitPlanDetails/routes/EditUnitPlan/routes/IBPlanner/modules/IBPlannerModule";
import TagPost from "../TagPost/TagPost";
import { ShareWithIconSvg } from "SvgComponents";
import DualProfile from "Post/components/DualProfile";
import {
  getCourseUnitQuery,
  getCourseUnitQueryV2,
  getOrganizationAcademicYearsQuery,
  getPostsHavingTaggedGoalsQuery,
  getCourseFilteredStudentQuery,
} from "AppComponents/Post/modules/PostQuery";
import {
  getCourseUnitFromCache,
  getOrganizationAcademicYearsFromCache,
  getPostsHavingTaggedGoalsQueryFromCache,
  getPostDetailsFromCache,
  getCourseFilteredStudentFromCache,
} from "AppComponents/Post/modules/PostGraphqlHelpers";
import { downloadFromUrl, removeProgressElement } from "modules/Services";
import { getElementData } from "modules/ElementValueUtils";
import {
  pypElementMapping,
  plannerElementFieldUidMap,
} from "Constants/plannerElementMappings";
import { STANDARD_UIDS } from "modules/Services/ServicesConstants";
import PostRateonLearningGoals from "../PostRateonLearningGoals";
import TaggedFoldersV2 from "Post/components/TaggedFolders/TaggedFoldersV2";
import { ArrowContainer, Popover } from "@toddle-edu/react-tiny-popover";
import StandardSetSelectionModal from "./components/StandardSetSelectionModal";
import EditAttachmentModal from "./components/EditAttachmentModal";

import ReorderAttachment from "./components/ReorderAttachment";
import { AVATAR_COLORS } from "Constants/colorConstants";
import {
  getDefaultNameSortPreference,
  getDefaultStudentNameOrderPreference,
  getSelectedAcademicYearId,
  getCurrentAcademicYear,
} from "modules/CommonSelectors";

import { PROJECTS_JOURNALS_AND_INTERVIEWS_UPLOAD_OPTIONS } from "Projects/Constants/stringConstants";
import { getCourseDetailsFromCache } from "Course/modules/CourseGraphqlHelpers";

import { createConfigurationFilters } from "Login/routes/Administrator/routes/Settings/routes/PortfolioManager/routes/TeacherPortfolio/modules/TeacherPortfolioModule";
import { getConfigurationQuery } from "Login/routes/Administrator/routes/Settings/routes/PortfolioManager/routes/TeacherPortfolio/modules/TeacherPortfolioQueries";

import AIInputBox from "../AddPostDetails/AIInputBox";
import {
  aiGenerateActionsMapping,
  cleanupMessage,
  isEmptyHtmlV2,
} from "../AddPostDetails/AIInputBox/utils";

import { isWindows, isTabletByUserAgent } from "Utils/DeviceDetectHelpers";
import NoteV2 from "../AddPostDetails/NoteV2";

import { getStudentAssignmentDetailsQuery } from "ClassRoom/modules/ClassRoomQuery";
import { getStudentAssignmentDetailsFromCache } from "ClassRoom/modules/ClassRoomGraphqlHelpers";
import {
  getToolResponseUserFilter,
  getIsSubjectStandard,
} from "Teacher/routes/Courses/routes/Course/routes/ClassRoom/modules/utils";

import { isAIModuleMarketingEnabled } from "Platform/modules/PlatformUtils";
import { AI_MODULES_FOR_MARKETING } from "ChildrenPage/components/AIModuleMarketingModal/AIModuleMarketingUtils";
import { setAiModuleMarketingKey } from "Platform/modules/PlatformModule";
import { getIsGradingPeriodUnlocked } from "GradingSetup/modules/Utils";
import { getNextUnlockedTerm } from "Teacher/routes/Courses/routes/Course/routes/UnitPlans/components/IBcomponents/AssessmentCategory/utils";

import { getSelectedLearningCourseId } from "Teacher/routes/LearningCourse/modules/Utils";
import { getIsLearningCoursesEnabled } from "Teacher/routes/LearningCourses/modules/Utils";
import { flushSync } from "react-dom";
import { CURRICULUM_TYPE_PYP } from "Constants/stringConstants";
import { useMediaQuery } from "Hooks";
import { enableGooglePhotosPicker } from "UIComponents/GooglePhotosPicker/modules/utils";

const {
  ASK_AI_ATTACHMENT_CAPTION,
  ASK_AI_ATTACHMENT_CAPTION_FILLED,
  ASK_AI_WITHOUT_IMAGE,
} = aiGenerateActionsMapping;

const style = {
  containerStyle: {
    width: "auto",
    maxWidth: "100%",
    alignSelf: "flex-start",
    paddingBottom: "16px",
    margin: "16px 0",
    borderWidth: 1,
    borderColor: colors.borderDefault,
    borderRadius: "16px",
    overflow: "hidden",
    display: "flex",
    justifyContent: "center",
    height: "fit-content",
    alignItems: "center",
  },
  mediaPlaceholderContainerStyle: {
    width: "194px",
    height: "150px",
  },
  evaluationCardStyle: {
    minWidth: "194px",
    minHeight: "150px",
    maxHeight: "150px",
  },
  scrollButtonsContainerStyle: {
    height: "175px",
  },
  screenPanelContainerStyle: { padding: "0", height: "100%" },
  screenPanelContainerStyleV2: {
    padding: "0",
    height: "100%",
    maxWidth: "632px",
  },
  footerContainerStyle: {
    borderTop: `1px solid ${colors.borderSubtle}`,
  },
  titleTextContainerStyle: { marginLeft: "12px" },
  scrollContainerStyle: { backgroundColor: colors.surfaceSubtle },
  assessmentToolTextStyle: {
    fontSize: "1.4rem",
    marginTop: "4px",
  },
  usernameStyle: {
    fontWeight: "500",
  },
  modalTitleHeaderStyle: {
    fontSize: "1.6rem",
    lineHeight: "2.4rem",
    fontWeight: "600",
    paddingBottom: "24px",
  },
  noGradesConfiguredModalHeader: {
    borderTop: `1px solid ${colors.strokeOne}`,
  },
  noGradesConfiguredModalCancelStyle: { float: "right" },
  noteTextAreaStyles: {
    borderWidth: 0,
    padding: 0,
    overflowY: "hidden",
  },
  noteLinesContainerStyles: {
    height: "fit-content",
  },
  scrollableCarouselWrapperStyle: {
    overflowY: "hidden",
  },
  audioCardStyle: isJuniorFolio => {
    return isJuniorFolio
      ? {
          marginInline: "32px",
          width: "unset",
        }
      : {};
  },
  textArea: {
    borderWidth: 0,
    flexShrink: 0,
    display: "block",
    whiteSpace: "pre-wrap",
    fontSize: "1.6rem",
    lineHeight: "2.4rem",
    fontWeight: 500,
    unicodeBidi: "plaintext",
  },
  responseStyle: {
    fontWeight: 500,
    fontSize: "1.6rem",
    lineHeight: "2.4rem",
  },
  promptIconStyles: {
    marginRight: "0px",
  },
  titleStyle: {
    fontWeight: "600",
    fontSize: "1.4rem",
    lineHeight: "2rem",
  },
  customDeleteButtonStyle: {
    top: "12px",
  },
  studentToolTipContainer: {
    color: "unset",
    textDecoration: "underline",
    fontWeight: "600",
    fontSize: "1.6rem",
  },
  learningGoalsContainer: {
    marginTop: "0",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    fontWeight: 500,
  },
  learningGoalsContainerDepth0: {
    marginTop: "0",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    fontWeight: 600,
  },
  learningGoalsContainerDepth1: {
    marginTop: "0",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    fontWeight: 600,
    marginBottom: "8px",
  },
  learningGoalsContainerDepth2: {
    marginTop: "0",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    fontWeight: 500,
    marginBottom: "8px",
  },
  customInfoIconStyle: { fill: "#FFBB33" },
  detailDataContainerStyle: {
    marginTop: "-24px",
  },
  unitSubDetailContainerStyle: {
    paddingTop: "4px",
  },
  unitSubDetailContainerStyleV2: {
    paddingTop: "8px",
  },
  unitDetailContainerStyle: {
    width: "80%",
  },
  unitSubDetailRightContainerStyle: {
    width: "48px",
    height: "48px",
  },
  resourceImagePlaceHolderStyle: {
    width: "48px",
    height: "48px",
    borderRadius: "8px",
  },
  leUnitModalDialogStyle: { paddingTop: "6px", paddingBottom: "0px" },
  tagCardLeftContainerV2Style: { paddingBottom: "16px" },
  unitDetailsWrapperStyle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "8px",
  },
  mainContentContainerStyle: { marginBottom: "0px" },
  countLabel: { marginLeft: "4px" },
  elementsWrapper: { paddingTop: "16px" },
};

const DIALOGS_INFO = {
  DELETE: {
    title: "journal:delete_dialog_title",
    message: "journal:delete_dialog_message",
    confirmButtonText: "common:delete_confirm",
    cancelButtonText: "common:cancel",
    button1Props: {
      variant: "outlined-subtle",
      size: "large",
      testId: "journal-postcreation-cancel",
    },
    button2Props: {
      variant: "destructive",
      size: "large",
      testId: "journal-postcreation-delete",
    },
    size: "auto",
  },

  APPROVE: {
    title: "journal:approve_post",
    message: "journal:approve_msg",
    confirmButtonText: "common:approve",
  },
  APPROVE_WITH_COMMENT: {
    title: "journal:approve_with_comment",
    message: "journal:approve_with_comment_msg",
    titleSubText: ({ t }) => t("journal:approve_with_comment_msg"),
    confirmButtonText: "common:approve",
    isPromptBox: true,
    size: "auto",
    promptBoxType: "TextAreaInput",
    warningTextStyles: {
      color: colors.textDefault,
      fontSize: "1.6rem",
    },
    promptDetail: ({ t }) => ({
      placeholder: t("journal:enter_comment_here"),
      checkValidation: true,
      promptText: "",
    }),
    textAreaRows: 3,
    button1Props: {
      variant: "outlined-subtle",
      size: "large",
      testId: "journal-postcreation-cancel",
    },
    button2Props: {
      size: "large",
      variant: "progressive",
      testId: "journal-postcreation-approve",
    },
    headerStyles: { alignItems: "flex-start" },
  },
  DISCARD: {
    title: "journal:discard_dialog_title",
    message: "journal:discard_dialog_message",
    confirmButtonText: "journal:publish",
  },
  APPROVE_ALL: {
    title: "journal:approve_all_posts",
    message: "journal:approve_all_posts_msg",
    confirmButtonText: "journal:approve_all",
    button1Props: {
      variant: "outlined-subtle",
      size: "large",
      testId: "journal-postcreation-cancel",
    },
    button2Props: {
      size: "large",
      variant: "progressive",
      testId: "journal-postcreation-approve",
    },
    size: "auto",
  },
  REJECT_ALL: {
    title: "journal:return_all_posts",
    message: "journal:return_all_posts_msg",
    confirmButtonText: "journal:return_all",
    button1Props: {
      variant: "outlined-subtle",
      size: "large",
      testId: "journal-postcreation-cancel",
    },
    button2Props: {
      variant: "destructive",
      size: "large",
      testId: "journal-postcreation-delete",
    },
    size: "auto",
    textAreaRows: 3,
  },
  REJECT_POST: {
    title: "journal:return_post",
    message: "common:approve",
    titleSubText: ({ t, name }) =>
      t("journal:return_with_note_msg", { label: name }),
    confirmButtonText: "common:return",
    isPromptBox: true,
    size: "auto",
    promptBoxType: "TextAreaInput",
    promptDetail: ({ t }) => ({
      label: t("journal:return_with_note"),
      placeholder: t("journal:enter_note_here"),
      checkValidation: false,
      promptText: "",
    }),
    warningTextStyles: {
      color: colors.textDefault,
      fontSize: "1.6rem",
    },
    button1Props: {
      variant: "outlined-subtle",
      size: "large",
      testId: "journal-postcreation-cancel",
    },
    button2Props: {
      variant: "destructive",
      size: "large",
      testId: "journal-postcreation-delete",
    },
    headerStyles: { alignItems: "flex-start" },
  },
};

const leOrAssessmentButtonProps = {
  button2Props: {
    variant: "primary",
    size: "large",
    testId: "journal-postcreation-delete",
  },
  button1Props: {
    variant: "neutral",
    size: "large",
    testId: "journal-postcreation-cancel",
    type: "outlined",
  },
};

const leOrAssessmentButtonPropsV2 = {
  button2Props: {
    variant: "primary",
    size: "medium",
  },
  button1Props: {
    variant: "neutral",
    size: "medium",
    testId: "journal-postcreation-cancel",
    type: "outlined",
  },
};

const BLANK_ARRAY = [];
const BLANK_OBJECT = {};

const TAG_FROM_ALL_LEARNING_GOALS = "TAG_FROM_ALL_LEARNING_GOALS";
const TAG_LEARNING_GOALS_FROM_UNIT = "TAG_LEARNING_GOALS_FROM_UNIT";
const TAG_LEARNING_GOALS_FROM_ASSESSMENTS =
  "TAG_LEARNING_GOALS_FROM_ASSESSMENTS";
const TAG_LEARNING_GOALS_FROM_POST = "TAG_LEARNING_GOALS_FROM_POST";

const getNonAudioAttachments = attachments => {
  return _.filter(attachments, attachment => attachment.type !== "AUDIO");
};

const publishShortCutsParams = { code: "Enter", shiftKey: true };

const BLANK_STRING = "";
const FooterComponent = props => {
  const {
    onPublishClick,
    onDraftClick,
    state,
    mode,
    t,
    isPost = false,
    addButtonLabel,
    userType,
    onMediaCreate,
    onClickSave, // function to be called for ProcessJournal
    onSendForApprovalClick,
    isApprovalRequiredForStudentPosts,
    isAddAllResponsesToJournal,
    onAddAllResponsesToJournal,
    onCloseClick,
    postDetails,
    postDescription,
    isStudentTagOptional,
    isUploadingInProgress,
    publishedAt,
    togglePostScheduleModal,
    setScheduleDateTimeDetails,
    updatePost,
    parentType,
    taggedCollections = [],
    showPublishIcon = false,
    scheduleDateTimeDetails,
    setToastMsg,
    showPortfolioParityCard,
    assesmentData,
    isArchivedClass,
    onPostActionClick,
    isNote,
    noteTitle,
    isProjectPost,
  } = props;

  const hideSaveAsDraftOptionForInapproval = () => {
    const { state, createdBy } = postDetails;
    if (state === "IN_APPROVAL" && createdBy?.type === "student") {
      return false;
    }
    if (
      isPortfolioParityEnabled() &&
      _.isEqual(createdBy?.type, "student") &&
      _.isEqual(userType, "staff")
    ) {
      return false;
    }
    return true;
  };

  const publishDropdownOptions = [
    {
      label: t(
        mode == "edit" && state !== "DRAFT"
          ? "common:update"
          : "journal:publish"
      ),
      key: "PUBLISH_POST",
      icon: <PublishOutlined />,
    },
    {
      label: t("journal:select_date_and_time"),
      key: "SCHEDULE_POST",
      icon: <CalendarScheduleOutlined />,
    },
  ];

  const scheduleDropdownOptions = isBackDate => [
    {
      label: isBackDate
        ? t("journal:edit_date_time")
        : t("common:edit_with_label", {
            label: t("common:scheduled_date"),
            lowercase: true,
          }),
      key: "EDIT_SCHEDULE_DATE",
    },
    {
      label: isBackDate ? t("common:remove") : t("common:unschedule"),
      key: "UNSCHEDULE_POST",
    },
  ];

  const onPublishDropdownOptionClick = value => {
    const isBackDatePost = !getCombinedDateAndTimeMoment(
      scheduleDateTimeDetails
    )?.isAfter(moment());
    switch (_.get(value, "key", "")) {
      case "PUBLISH_POST":
        isAddAllResponsesToJournal
          ? onAddAllResponsesToJournal()
          : onPublishClick();
        break;

      case "SCHEDULE_POST":
        if (_.isFunction(togglePostScheduleModal))
          togglePostScheduleModal(true);
        break;

      //---- Edit scheduling option

      case "EDIT_SCHEDULE_DATE":
        if (_.isFunction(togglePostScheduleModal)) {
          togglePostScheduleModal(true);
        }
        break;

      case "UNSCHEDULE_POST":
        if (_.isFunction(updatePost)) {
          setScheduleDateTimeDetails({});
          updatePost({
            state: "PUBLISHED",
            publishedAt: undefined,
          });
          setToastMsg({
            msg: isBackDatePost
              ? "toastMsgs:date_and_time_removed"
              : "toastMsgs:post_unscheduled_successfully",
            type: "success",
          });
        }

        break;
      default:
        break;
    }
  };
  //Handle Different footer for post and other media creation based on isPost prop
  //AddButtonLabel only applicable non post media creation

  // Post must have either description or minimum 1 attachment, and student must be tagged (or skip students if optional prop is set).
  const isSaveButtonsEnabled =
    !isUploadingInProgress &&
    (_.get(postDetails, "isAddLEToJournal", false) == true ||
      _.get(postDetails, "isAddAllResponsesToJournal", false) == true ||
      ((_.size(_.get(postDetails, "attachments", [])) > 0 ||
        _.size(_.trim(postDescription), 0) > 0) &&
        (parentType !== "learnerPortfolio" || _.size(taggedCollections) > 0) &&
        (isStudentTagOptional ||
          _.size(_.get(postDetails, "students.edges", [])) ||
          isProjectPost)));

  const onGenericButtonClick = e => {
    if (!_.isNil(onMediaCreate) && _.isFunction(onMediaCreate))
      onMediaCreate(e);
    if (!_.isNil(onClickSave) && _.isFunction(onClickSave)) onClickSave(e);
  };

  const handleDraftClickLocal = () => {
    updatePost({ publishedAt: undefined });
    onDraftClick();
  };

  const approveDropdownOptions = [
    {
      label: t("journal:approve_with_comment"),
      key: "APPROVE_WITH_COMMENT",
      icon: <CommentAddOutlined />,
    },
  ];

  const onApproveDropdownOptionClick = value => {
    switch (_.get(value, "key", "")) {
      case "APPROVE_WITH_COMMENT":
        onPostActionClick({
          id: _.get(postDetails, "id", null),
          action: "APPROVE_WITH_COMMENT",
          createdByName: _.get(postDetails, "createdBy.firstName", ""),
        });
        break;
    }
  };
  return (
    <div
      className={classes.footerButtonContainer}
      style={
        (
          isPost == false || isPortfolioParityEnabled()
            ? _.isEqual(state, "IN_APPROVAL") || isProjectPost
            : false
        )
          ? { flexDirection: "row-reverse" }
          : {}
      }
    >
      {isPost ? (
        <React.Fragment>
          {/* Show draft button only to teachers */}
          {(isPortfolioParityEnabled() ? true : state === "DRAFT") &&
            !isAddAllResponsesToJournal &&
            hideSaveAsDraftOptionForInapproval() && (
              <Button
                variant="outlined"
                size="large"
                disabled={
                  (isNote && isEmptyHtmlV2(noteTitle?.trim())) ||
                  !isSaveButtonsEnabled
                }
                onClick={handleDraftClickLocal}
                icon={
                  isPortfolioParityEnabled() ? <ApprovalTickOutlined /> : null
                }
                testId={"journal-postcreation-saveasdraft"}
              >
                {t("common:save_as_draft")}
              </Button>
            )}
          {isPortfolioParityEnabled() &&
          state == "IN_APPROVAL" &&
          userType === "staff" &&
          isPost ? (
            <>
              <SplitButtonDropdown
                overlay={
                  <DropdownMenu
                    options={approveDropdownOptions}
                    onClick={onApproveDropdownOptionClick}
                    testId="journal-feed-postcreation"
                  />
                }
                placement={"bottomRight"}
                variant={"progressive"}
              >
                <Button
                  variant={"progressive"}
                  size="large"
                  onClick={() =>
                    onPostActionClick({
                      id: _.get(postDetails, "id", null),
                      action: "APPROVE",
                      createdByName: _.get(
                        postDetails,
                        "createdBy.firstName",
                        ""
                      ),
                      isAddLEToJournal: _.get(!_.isEmpty(assesmentData)),
                    })
                  }
                  style={{
                    borderRadius: "8px 0px 0px 8px",
                  }}
                  disabled={isArchivedClass}
                  testId="journal-postcreation-approve"
                >
                  <TickCircleFilled variant={"on"} />
                  <div className={classes.approveText}>
                    {t("common:approve")}
                  </div>
                </Button>
              </SplitButtonDropdown>
              <Button
                variant={"outlined"}
                size="large"
                onClick={() =>
                  onPostActionClick({
                    id: _.get(postDetails, "id", null),
                    action: "REJECT_POST",
                    createdByName: _.get(
                      postDetails,
                      "createdBy.firstName",
                      ""
                    ),
                    isAddLEToJournal: _.get(!_.isEmpty(assesmentData)),
                  })
                }
                disabled={isArchivedClass}
                testId="journal-postcreation-reject"
              >
                <RefreshArrowOutlined />
                <div className={classes.approveText}>{t("common:return")}</div>
              </Button>
            </>
          ) : null}
          {/* Cancel button in case of edit post */}
          {(state == "PUBLISHED" || state == "SCHEDULED") &&
            !showPortfolioParityCard && (
              <Button
                variant="outlined-subtle"
                size={"large"}
                onClick={onCloseClick}
                testId="journal-postcreation-cancel"
              >
                {t("common:cancel")}
              </Button>
            )}
          {userType === "staff" &&
          (state == "SCHEDULED" ||
            (!_.isEmpty(scheduleDateTimeDetails?.date) &&
              !_.isEmpty(scheduleDateTimeDetails?.time))) ? (
            <div
              style={{
                margin:
                  isPortfolioParityEnabled() && mode === "edit" ? "auto" : "",
              }}
            >
              <Dropdown
                overlay={
                  <DropdownMenu
                    options={scheduleDropdownOptions(
                      !getCombinedDateAndTimeMoment(
                        scheduleDateTimeDetails
                      )?.isAfter(moment())
                    )}
                    onClick={onPublishDropdownOptionClick}
                    style={{ minWidth: "184px" }}
                    showSelection={true}
                    testId="journal-feed-postcreation"
                  />
                }
                placement={"topRight"}
                variant={"plain"}
              >
                <ButtonDisclosure
                  variant="plain"
                  style={{
                    margin: isPortfolioParityEnabled()
                      ? mode !== "edit"
                        ? "auto"
                        : ""
                      : "auto 8px auto auto",
                    padding:
                      isPortfolioParityEnabled() && mode === "create"
                        ? "8px"
                        : "",
                  }}
                  testId="journal-postcreation-schedule"
                >
                  {t(
                    getCombinedDateAndTimeMoment(
                      scheduleDateTimeDetails
                    )?.isAfter(moment())
                      ? "common:scheduled_for_with_label"
                      : "journal:set_for_with_label",
                    {
                      label:
                        scheduleDateTimeDetails?.date?.format("MMM DD YYYY") +
                        ", " +
                        scheduleDateTimeDetails?.time?.format("hh:mm A"),
                    }
                  )}
                </ButtonDisclosure>
              </Dropdown>
            </div>
          ) : null}
          {isPortfolioParityEnabled() &&
          userType == "student" &&
          isApprovalRequiredForStudentPosts ? (
            <Button
              size={"large"}
              isFullWidth={!isPortfolioParityEnabled()}
              variant="progressive"
              icon={<PublishOutlined />}
              onClick={onSendForApprovalClick}
              disabled={
                (isNote && isEmptyHtmlV2(noteTitle?.trim())) ||
                !isSaveButtonsEnabled
              }
              testId="journal-postcreation-sendforapproval"
            >
              {t("journal:send_for_approval")}
            </Button>
          ) : state !== "IN_APPROVAL" ? (
            <div
              style={{
                width: !hideSaveAsDraftOptionForInapproval() ? "100%" : "",
              }}
            >
              <ConditionalWrapper
                condition={
                  userType == "staff" &&
                  !isAddAllResponsesToJournal &&
                  _.includes(["PUBLISHED", "DRAFT"], state) &&
                  (_.isEmpty(scheduleDateTimeDetails?.date) ||
                    _.isEmpty(scheduleDateTimeDetails?.time))
                }
                wrapper={
                  <SplitButtonDropdown
                    overlay={
                      <DropdownMenu
                        options={publishDropdownOptions}
                        onClick={onPublishDropdownOptionClick}
                        style={{ minWidth: "184px" }}
                        showSelection={true}
                        testId="journal-feed-postcreation"
                      />
                    }
                    placement={"topRight"}
                    variant={"progressive"}
                    disabled={
                      (isNote && isEmptyHtmlV2(noteTitle?.trim())) ||
                      !isSaveButtonsEnabled
                    }
                  ></SplitButtonDropdown>
                }
                type="wrapperAsElement"
              >
                <Button
                  variant="progressive"
                  size={"large"}
                  icon={<PublishOutlined />}
                  onClick={
                    isAddAllResponsesToJournal
                      ? onAddAllResponsesToJournal
                      : onPublishClick
                  }
                  disabled={
                    !isSaveButtonsEnabled ||
                    (isNote && isEmptyHtmlV2(noteTitle?.trim()))
                  }
                  isFullWidth={!hideSaveAsDraftOptionForInapproval()}
                  testId={`journal-postcreation-${
                    state == "DRAFT" || mode == "create"
                      ? moment(publishedAt).isAfter(moment())
                        ? "schedule"
                        : "publish"
                      : "update"
                  }`}
                >
                  {state == "DRAFT" || mode == "create"
                    ? moment(publishedAt).isAfter(moment())
                      ? t("common:schedule")
                      : t("journal:publish")
                    : t("common:update")}
                </Button>
              </ConditionalWrapper>
            </div>
          ) : null}
        </React.Fragment>
      ) : (
        <Button
          variant="progressive"
          size={"large"}
          onClick={onGenericButtonClick}
          disabled={!isSaveButtonsEnabled}
          isFullWidth={true && !isProjectPost}
          icon={showPublishIcon ? <PublishOutlined /> : null}
          testId="journal-postcreation-publish"
        >
          {mode === "edit" ? t("common:update") : t(addButtonLabel)}
        </Button>
      )}
    </div>
  );
};
FooterComponent.displayName = "Footer";

const HeaderRightComponent = props => {
  const {
    onPublishClick,
    onDraftClick,
    state,
    mode,
    t,
    isPost = false,
    addButtonLabel,
    userType,
    onMediaCreate,
    onClickSave, // function to be called for ProcessJournal
    onSendForApprovalClick,
    isApprovalRequiredForStudentPosts,
    isAddAllResponsesToJournal,
    onAddAllResponsesToJournal,
    onCloseClick,
    postDetails,
    postDescription,
    isStudentTagOptional,
    isUploadingInProgress,
    publishedAt,
    canScheduleAPost = false,
    postServerObject,
    togglePostScheduleModal,
    setScheduleDateTimeDetails,
    updatePost,
    parentType,
    taggedCollections = [],
    showPublishIcon = false,
    scheduleDateTimeDetails,
    setToastMsg,
    showPortfolioParityCard,
    assesmentData,
    isArchivedClass,
    onPostActionClick,
    isNote,
    noteTitle,
    isProjectPost,
    isUserAllowedToPublishPost,
    isPostCtaDisabled = false,
    formatAttachments,
    isGlobalHeaderEnabled,
    userId,
  } = props;

  const hideSaveAsDraftOptionForInapproval = () => {
    const { state, createdBy } = postDetails;
    if (state === "IN_APPROVAL" && createdBy?.type === "student") {
      return false;
    }
    if (
      isPortfolioParityEnabled() &&
      _.isEqual(createdBy?.type, "student") &&
      _.isEqual(userType, "staff")
    ) {
      return false;
    }
    return true;
  };

  const publishDropdownOptions = [
    {
      label: t(
        mode == "edit" && state !== "DRAFT"
          ? "common:update"
          : "journal:publish"
      ),
      key: "PUBLISH_POST",
      icon: <PublishOutlined />,
    },
    {
      label: t("journal:select_date_and_time"),
      key: "SCHEDULE_POST",
      icon: <CalendarScheduleOutlined />,
    },
  ];

  const scheduleDropdownOptions = isBackDate => [
    {
      label: isBackDate
        ? t("journal:edit_date_time")
        : t("common:edit_with_label", {
            label: t("common:scheduled_date"),
            lowercase: true,
          }),
      key: "EDIT_SCHEDULE_DATE",
    },
    {
      label: isBackDate ? t("common:remove") : t("common:unschedule"),
      key: "UNSCHEDULE_POST",
    },
  ];

  const onPublishDropdownOptionClick = value => {
    const isBackDatePost = !getCombinedDateAndTimeMoment(
      scheduleDateTimeDetails
    )?.isAfter(moment());
    switch (_.get(value, "key", "")) {
      case "PUBLISH_POST":
        isAddAllResponsesToJournal
          ? onAddAllResponsesToJournal()
          : onPublishClick();
        break;

      case "SCHEDULE_POST":
        if (_.isFunction(togglePostScheduleModal))
          togglePostScheduleModal(true);
        break;

      //---- Edit scheduling option

      case "EDIT_SCHEDULE_DATE":
        if (_.isFunction(togglePostScheduleModal)) {
          togglePostScheduleModal(true);
        }
        break;

      case "UNSCHEDULE_POST":
        updatePost({
          state: isPortfolioReviewSetupEnabledAndIsReviewRoute()
            ? "IN_APPROVAL"
            : "PUBLISHED",
          publishedAt: null,
        });
        if (_.isFunction(updatePost)) {
          if (isPortfolioReviewSetupEnabledAndIsReviewRoute()) {
            setScheduleDateTimeDetails({});
            setToastMsg({
              msg: isBackDatePost
                ? "toastMsgs:date_and_time_removed"
                : "toastMsgs:post_unscheduled_successfully",
              type: "success",
            });
          } else {
            setScheduleDateTimeDetails({});
            setToastMsg({
              msg: isBackDatePost
                ? "toastMsgs:date_and_time_removed"
                : "toastMsgs:post_unscheduled_successfully",
              type: "success",
            });
          }
        }

        break;
      default:
        break;
    }
  };
  //Handle Different footer for post and other media creation based on isPost prop
  //AddButtonLabel only applicable non post media creation

  // Post must have either description or minimum 1 attachment, and student must be tagged (or skip students if optional prop is set).
  const isSaveButtonsEnabled =
    !isUploadingInProgress &&
    (_.get(postDetails, "isAddLEToJournal", false) == true ||
      _.get(postDetails, "isAddAllResponsesToJournal", false) == true ||
      ((_.size(_.get(postDetails, "attachments", [])) > 0 ||
        _.size(_.trim(postDescription), 0) > 0) &&
        (parentType !== "learnerPortfolio" || _.size(taggedCollections) > 0) &&
        (isStudentTagOptional ||
          _.size(_.get(postDetails, "students.edges", [])) ||
          isProjectPost)));

  const onGenericButtonClick = e => {
    formatAttachments();
    if (!_.isNil(onMediaCreate) && _.isFunction(onMediaCreate))
      onMediaCreate(e);
    if (!_.isNil(onClickSave) && _.isFunction(onClickSave)) onClickSave(e);
  };

  const handleDraftClickLocal = () => {
    updatePost({ publishedAt: undefined });
    onDraftClick();
  };

  const approveDropdownOptions = [
    {
      label: t("journal:approve_with_comment"),
      key: "APPROVE_WITH_COMMENT",
      icon: <CommentAddOutlined />,
    },
    ...(isPortfolioReviewSetupEnabledAndIsReviewRoute()
      ? [
          {
            label: t("journal:select_date_and_time"),
            key: "SCHEDULE_POST",
            icon: <CalendarScheduleOutlined />,
          },
        ]
      : []),
  ];

  const onApproveDropdownOptionClick = value => {
    switch (_.get(value, "key", "")) {
      case "APPROVE_WITH_COMMENT":
        onPostActionClick({
          id: _.get(postDetails, "id", null),
          action: "APPROVE_WITH_COMMENT",
          createdByName: _.get(postDetails, "createdBy.firstName", ""),
        });
        break;
      case "SCHEDULE_POST":
        if (_.isFunction(togglePostScheduleModal))
          togglePostScheduleModal(true);
        break;
    }
  };

  const onPublishButtonClick = () => {
    if (isAddAllResponsesToJournal) {
      _.isFunction(onAddAllResponsesToJournal) && onAddAllResponsesToJournal();
    } else {
      _.isFunction(onPublishClick) && onPublishClick();
    }
  };

  const onSendForApprovalButtonClick = () => {
    onSendForApprovalClick();
  };
  const { createdBy } = postDetails;

  const isButtonDisabled =
    (isNote && isEmptyHtmlV2(noteTitle?.trim())) || !isSaveButtonsEnabled;

  const canUserEditPost =
    createdBy?.id === userId || mode !== "edit"
      ? true
      : isUserAllowedToPublishPost;
  return (
    <div
      className={classes.footerButtonContainer}
      style={
        (
          isPost == false || isPortfolioParityEnabled()
            ? (_.isEqual(state, "IN_APPROVAL") || isProjectPost) &&
              (isPortfolioReviewSetupEnabled()
                ? createdBy?.type !== "staff"
                : true)
            : false
        )
          ? { gap: "12px" }
          : { gap: "12px" }
      }
    >
      {isPost ? (
        <React.Fragment>
          {userType === "staff" &&
          (isPortfolioReviewSetupEnabledAndIsJournalRoute()
            ? isUserAllowedToPublishPost
            : true) &&
          (state == "SCHEDULED" ||
            (!_.isEmpty(scheduleDateTimeDetails?.date) &&
              !_.isEmpty(scheduleDateTimeDetails?.time))) ? (
            <div
              style={{
                margin:
                  isPortfolioParityEnabled() && mode === "edit" ? "auto" : "",
              }}
            >
              <Dropdown
                overlay={
                  <DropdownMenu
                    options={scheduleDropdownOptions(
                      !getCombinedDateAndTimeMoment(
                        scheduleDateTimeDetails
                      )?.isAfter(moment())
                    )}
                    onClick={onPublishDropdownOptionClick}
                    style={{ minWidth: "184px" }}
                    showSelection={true}
                    testId="journal-feed-postcreation"
                  />
                }
                placement={"topRight"}
                variant={"plain"}
              >
                <ButtonDisclosure
                  variant="plain"
                  style={{
                    margin: isPortfolioParityEnabled()
                      ? mode !== "edit"
                        ? "auto"
                        : ""
                      : "auto 8px auto auto",
                    padding: "8px",
                  }}
                  testId="journal-postcreation-schedule"
                  size={isGlobalHeaderEnabled ? "small" : ""}
                >
                  {t(
                    getCombinedDateAndTimeMoment(
                      scheduleDateTimeDetails
                    )?.isAfter(moment())
                      ? "common:scheduled_for_with_label"
                      : "journal:set_for_with_label",
                    {
                      label:
                        scheduleDateTimeDetails?.date?.format("MMM DD YYYY") +
                        ", " +
                        scheduleDateTimeDetails?.time?.format("hh:mm A"),
                    }
                  )}
                </ButtonDisclosure>
              </Dropdown>
            </div>
          ) : null}

          {(isPortfolioParityEnabled()
            ? isPortfolioReviewSetupEnabledAndIsReviewRoute()
              ? false
              : true
            : state === "DRAFT") &&
            !isAddAllResponsesToJournal &&
            hideSaveAsDraftOptionForInapproval() && (
              <Button
                variant={"neutral"}
                type={!isButtonDisabled ? "outlined" : "fill"}
                dsVersion={"2.0"}
                size="medium"
                disabled={
                  (isNote && isEmptyHtmlV2(noteTitle?.trim())) ||
                  !isSaveButtonsEnabled
                }
                onClick={handleDraftClickLocal}
                icon={
                  isPortfolioParityEnabled() ? (
                    <ApprovalTickOutlined variant={"warning"} />
                  ) : null
                }
                testId={"journal-postcreation-saveasdraft"}
              >
                {t("common:save_as_draft")}
              </Button>
            )}

          {isPortfolioParityEnabled() &&
          state == "IN_APPROVAL" &&
          userType === "staff" &&
          (isPortfolioReviewSetupEnabledAndIsJournalRoute()
            ? createdBy?.type === "student"
            : true) &&
          isPost ? (
            <>
              <Button
                variant={isGlobalHeaderEnabled ? "neutral" : "outlined"}
                type={isGlobalHeaderEnabled ? "outlined" : "fill"}
                dsVersion={isGlobalHeaderEnabled ? "2.0" : "1.0"}
                size="medium"
                onClick={() =>
                  onPostActionClick({
                    id: _.get(postDetails, "id", null),
                    action: "REJECT_POST",
                    createdByName: _.get(
                      postDetails,
                      "createdBy.firstName",
                      ""
                    ),
                    isAddLEToJournal: _.get(!_.isEmpty(assesmentData)),
                  })
                }
                disabled={
                  isArchivedClass ||
                  (isNote && isEmptyHtmlV2(noteTitle?.trim()))
                }
                testId="journal-postcreation-reject"
              >
                <RefreshArrowOutlined />
                <div className={classes.approveText}>{t("common:return")}</div>
              </Button>
              <SplitButtonDropdown
                overlay={
                  <DropdownMenu
                    options={approveDropdownOptions}
                    onClick={onApproveDropdownOptionClick}
                    testId="journal-feed-postcreation"
                  />
                }
                placement={"bottomRight"}
                variant={isGlobalHeaderEnabled ? "primary" : "progressive"}
                disabled={isNote && isEmptyHtmlV2(noteTitle?.trim())}
              >
                <Button
                  variant={"progressive"}
                  size={"medium"}
                  dsVersion={isGlobalHeaderEnabled ? "2.0" : "1.0"}
                  type={isGlobalHeaderEnabled ? "fill" : ""}
                  onClick={() =>
                    onPostActionClick({
                      id: _.get(postDetails, "id", null),
                      action: "APPROVE",
                      createdByName: _.get(
                        postDetails,
                        "createdBy.firstName",
                        ""
                      ),
                      isAddLEToJournal: _.get(!_.isEmpty(assesmentData)),
                    })
                  }
                  style={{
                    borderRadius: "8px 0px 0px 8px",
                  }}
                  testId="journal-postcreation-approve"
                  disabled={
                    isArchivedClass ||
                    (isNote && isEmptyHtmlV2(noteTitle?.trim()))
                  }
                >
                  <TickCircleFilled variant={"on"} />
                  <div className={classes.approveText}>
                    {t("common:approve")}
                  </div>
                </Button>
              </SplitButtonDropdown>
            </>
          ) : null}
          {/* Cancel button in case of edit post */}
          {(state == "PUBLISHED" || state == "SCHEDULED") &&
            !showPortfolioParityCard && (
              <Button
                variant="outlined-subtle"
                size={"medium"}
                onClick={onCloseClick}
                testId="journal-postcreation-cancel"
              >
                {t("common:cancel")}
              </Button>
            )}
          {isPortfolioParityEnabled() &&
          ((userType == "student" && isApprovalRequiredForStudentPosts) ||
            (isPortfolioReviewSetupEnabledAndIsJournalRoute() &&
              !isUserAllowedToPublishPost &&
              userType === "staff" &&
              createdBy?.type !== "student")) ? (
            <ConditionalWrapper
              type="wrapperAsElement"
              wrapper={
                <Tooltip
                  dsVersion="2.0"
                  showArrow="true"
                  placement={"bottomRight"}
                  tooltip={
                    isPortfolioReviewSetupEnabled() && !canUserEditPost
                      ? t("journal:you_dont_have_permission_publish_post")
                      : t("journal:reviewer_removed_tooltip")
                  }
                />
              }
              condition={
                isPostCtaDisabled ||
                (isPortfolioReviewSetupEnabled() && !canUserEditPost)
              }
              testId="journal-postcreation-sendforapproval"
            >
              <Button
                size={"medium"}
                dsVersion={"2.0"}
                type={"fill"}
                isFullWidth={!isPortfolioParityEnabled()}
                variant="progressive"
                icon={<PublishOutlined />}
                onClick={onSendForApprovalButtonClick}
                disabled={
                  (isNote && isEmptyHtmlV2(noteTitle?.trim())) ||
                  !isSaveButtonsEnabled ||
                  isPostCtaDisabled ||
                  (isPortfolioReviewSetupEnabled() && !canUserEditPost)
                }
              >
                {t("journal:send_for_approval")}
              </Button>
            </ConditionalWrapper>
          ) : state !== "IN_APPROVAL" ||
            (isUserAllowedToPublishPost &&
              state === "IN_APPROVAL" &&
              userType === "staff" &&
              isPortfolioReviewSetupEnabledAndIsJournalRoute() &&
              createdBy?.type !== "student") ? (
            <div
              style={{
                width: !hideSaveAsDraftOptionForInapproval() ? "100%" : "",
              }}
            >
              <ConditionalWrapper
                condition={
                  userType == "staff" &&
                  // !isAddAllResponsesToJournal &&
                  _.includes(["PUBLISHED", "DRAFT"], state) &&
                  (_.isEmpty(scheduleDateTimeDetails?.date) ||
                    _.isEmpty(scheduleDateTimeDetails?.time))
                }
                wrapper={
                  <SplitButtonDropdown
                    overlay={
                      <DropdownMenu
                        options={publishDropdownOptions}
                        onClick={onPublishDropdownOptionClick}
                        style={{ minWidth: "184px" }}
                        showSelection={true}
                      />
                    }
                    placement={"topRight"}
                    variant={isGlobalHeaderEnabled ? "primary" : "progressive"}
                    disabled={
                      (isNote && isEmptyHtmlV2(noteTitle?.trim())) ||
                      !isSaveButtonsEnabled
                    }
                  ></SplitButtonDropdown>
                }
                type="wrapperAsElement"
              >
                <Button
                  variant={"primary"}
                  size={"medium"}
                  dsVersion={"2.0"}
                  type={"fill"}
                  icon={<PublishOutlined />}
                  onClick={onPublishButtonClick}
                  disabled={
                    !isSaveButtonsEnabled ||
                    (isNote && isEmptyHtmlV2(noteTitle?.trim()))
                  }
                  isFullWidth={!hideSaveAsDraftOptionForInapproval()}
                  testId={`journal-postcreation-${
                    state == "DRAFT" || mode == "create"
                      ? moment(publishedAt).isAfter(moment())
                        ? "schedule"
                        : "publish"
                      : "update"
                  }`}
                >
                  {state == "DRAFT" ||
                  mode == "create" ||
                  (state == "IN_APPROVAL" &&
                    userType === "staff" &&
                    createdBy?.type === "staff" &&
                    isPortfolioReviewSetupEnabledAndIsJournalRoute())
                    ? moment(publishedAt).isAfter(moment())
                      ? t("common:schedule")
                      : t("journal:publish")
                    : t("common:update")}
                </Button>
              </ConditionalWrapper>
            </div>
          ) : null}
        </React.Fragment>
      ) : (
        <Button
          variant={isGlobalHeaderEnabled ? "primary" : "progressive"}
          size={"medium"}
          dsVersion={isGlobalHeaderEnabled ? "2.0" : "1.0"}
          type={isGlobalHeaderEnabled ? "fill" : ""}
          onClick={onGenericButtonClick}
          disabled={!isSaveButtonsEnabled}
          isFullWidth={true && !isProjectPost}
          icon={showPublishIcon ? <PublishOutlined /> : null}
          testId={`journal-postcreation-${
            mode === "edit" ? "update" : "publish"
          }`}
          shortcut={publishShortCutsParams}
        >
          {mode === "edit" ? t("common:update") : t(addButtonLabel)}
        </Button>
      )}
    </div>
  );
};
HeaderRightComponent.displayName = "HeaderRightComponent";

// GENERIC CARD

const TagCardDetailsV2 = props => {
  const {
    items,
    leftIcon,
    leftTitle,
    taggedDetails, // this can be used to show tagged items or item count on the right side of card.
    taggedDetailsStyle = {},
    leftContainerStyle = {},
    rightContainerStyle = {},
    onAddClick,
    onEditClick,
    hideActionButtons = false,
    showCountBadge = true,
    showDeleteIcon = false,
    onDeleteClick,
    disabled,
    onTagLearningGoalClick,
    isTagLearningGoalsModalOpen,
    showTagLearningGoalsModal,
    setShowTagLearningGoalsModal,
    tagLearningGoalsOptions,
    postsWithGoals,
    t,
    goToStep,
    isRecentPost,
    updatePost,
    dataLength,
    showRateOnLearningGoals = false,
    rateOnLearningGoals,
    count,
    showTaggedDetails = true,
    isDeleteDisabled,
    isExpanded,
    showPypElements = false,
    showCardActionButtons = true,
    isCurrentAcademicYearSelected = false,
    isArchivedClass = false,
    showLearningGoalsDataOutSideAccordion = false,
    expandedContent,
    testId,
    curriculumProgramId,
    showEditIcon = true,
    postTaggedEntity,
    isNewGradingSetupEnabled,
    showStandardsModal,
    setShowStandardsModal,
    isStandardsRevampEnabled = false,
    standardLabel = "Standards",
    showNewStandardsUIInV1,
  } = props;
  const tagCardTitleClasses = classnames("text-label-l", {
    disabled,
  });

  const isTablet = isTabletByUserAgent();

  const onOptionClick = (e, option) => {
    e?.stopPropagation();
    onTagLearningGoalClick(option.key);
    setShowTagLearningGoalsModal(false);
    updatePost({ showTagLearningGoalsModal: false });
  };

  useEffect(() => {
    if (isTagLearningGoalsModalOpen !== showTagLearningGoalsModal)
      setShowTagLearningGoalsModal(showTagLearningGoalsModal);
  }, [showTagLearningGoalsModal]);

  const TagLearningGoalsModal = () => (
    <Modal
      dsVersion={isPortfolioParityEnabled() ? "2.0" : "1.0"}
      hasOverlay={true}
      isOpen={isTagLearningGoalsModalOpen || showTagLearningGoalsModal}
      onClose={e => {
        e?.stopPropagation();
        setShowTagLearningGoalsModal(false);
        updatePost({ showTagLearningGoalsModal: false });
      }}
      shouldCloseOnEsc={true}
      width="480px"
      height="600px"
    >
      <Modal.Header title={`${t("journal:tag_pyp_elements")}`} />
      <Modal.Body style={{ paddingTop: "0px", overflowX: "hidden" }}>
        <div style={style.modalTitleHeaderStyle}>
          {t("journal:select_goals_from")}
        </div>
        {_.map(tagLearningGoalsOptions, (option, index) => (
          <div>
            <div
              className={classes.learningGoals}
              style={{
                borderBottom:
                  index === _.size(tagLearningGoalsOptions) - 1
                    ? "none"
                    : `1px solid ${colors.borderSubtle}`,
                paddingBottom:
                  isRecentPost && index == _.size(tagLearningGoalsOptions) - 1
                    ? "none"
                    : "16px",
                cursor: "pointer",
              }}
              onClick={e => {
                onOptionClick(e, option);
              }}
              onKeyDown={e =>
                onEnterOrSpaceKeyDown(e, () => onOptionClick(e, option))
              }
              role="button"
              tabIndex={0}
              aria-label={option.label}
            >
              <div className={classes.learningGoalsTitle}>
                <div
                  className={classes.customHeaderIcon}
                  style={{ backgroundColor: option.background }}
                >
                  {option.icon}
                </div>
                <div className={classes.learningGoalsTitle}>{option.label}</div>
              </div>
              <div style={{ paddingRight: "8px", alignSelf: "end" }}>
                <IconButton
                  icon={<ChevronRightOutlined size={"x-small"} />}
                  variant={"plain"}
                  size={"x-small"}
                  disabled={false}
                  onClick={e => {
                    onOptionClick(e, option);
                  }}
                />
              </div>
            </div>
            {isRecentPost && index === _.size(tagLearningGoalsOptions) - 1 ? (
              <TagPost
                postsWithGoals={postsWithGoals}
                t={t}
                goToStep={goToStep}
              />
            ) : null}
          </div>
        ))}
      </Modal.Body>
    </Modal>
  );

  const learningElementOptionClick = useCallback(value => {
    const { key } = value;
    switch (key) {
      case "learninggoals":
        updatePost({
          selectFromAllPYP: true,
          unitPlan: null,
          resourceId: null,
          resourceType: null,
          resourceItem: undefined,
          postTaggedEntity: null,
        });

        goToStep("TAG_FROM_ALL_LEARNING_GOALS");
        break;
      case "standards":
        setShowStandardsModal(!showStandardsModal);
        break;
    }
  }, []);

  const learningElementDropdownOptions = useMemo(
    () => [
      {
        label: standardLabel,
        key: "standards",
        customTestId: "journal-feed-option-selection-standards",
      },
      {
        label: "Learning goals",
        key: "learninggoals",
        customTestId: "journal-feed-option-selection-learninggoals",
      },
    ],
    []
  );
  const isStandardsRevamp =
    isStandardsRevampEnabled && isNewGradingSetupEnabled;

  const DropdownOptionComponent = (
    <DropdownMenu
      options={learningElementDropdownOptions}
      showSelection={true}
      onClick={learningElementOptionClick}
      testId="journal-feed-option-selection"
    />
  );

  const handleGoalsClick = e => {
    e?.stopPropagation();
    updatePost({
      selectFromAllPYP: true,
      unitPlan: null,
      resourceId: null,
      resourceType: null,
      resourceItem: undefined,
      postTaggedEntity: null,
    });
    if (!isStandardsRevamp && !showNewStandardsUIInV1) {
      goToStep("TAG_FROM_ALL_LEARNING_GOALS");
    }
  };

  return (
    <>
      <div
        className={classes.tagCardContainer}
        style={{ height: "72px", opacity: disabled ? 0.5 : 1 }}
        // onClick={onCardClick} Tag learning goals revamp change
      >
        <div
          className={classes.tagCardLeftContainerV2}
          style={{
            ...leftContainerStyle,
            ...(!_.isEmpty(postTaggedEntity) && getIsNewGoalTaggingEnabled()
              ? style.tagCardLeftContainerV2Style
              : BLANK_OBJECT),
          }}
        >
          <div className={classes.tagCardIcon}>{leftIcon}</div>
          <h6 className={tagCardTitleClasses}>{leftTitle}</h6>
          {hideActionButtons == false && showCardActionButtons ? (
            <React.Fragment>
              {(!_.isEmpty(items) || dataLength) && showEditIcon ? (
                <IconButton
                  variant={"plain"}
                  size="small"
                  shouldStopPropagation={true}
                  icon={<PencilLineOutlined size="xx-small" />}
                  onClick={onEditClick}
                  style={{ marginLeft: "8px" }}
                  testId={`${testId}edit`}
                />
              ) : null}
              {showDeleteIcon == true && (_.size(items, 0) || dataLength) > 0 && (
                <ConditionalWrapper
                  type="wrapperAsElement"
                  wrapper={
                    <Tooltip tooltip={t("journal:delete_student_tooltip")} />
                  }
                  condition={isDeleteDisabled && !isTablet}
                >
                  <IconButton
                    variant={"plain"}
                    size="small"
                    icon={<DeleteOutlined size="xx-small" />}
                    onClick={onDeleteClick}
                    shouldStopPropagation={true}
                    disabled={isDeleteDisabled}
                    testId={`${testId}delete`}
                  />
                </ConditionalWrapper>
              )}
            </React.Fragment>
          ) : null}
        </div>

        <div
          className={classes.tagCardRightContainerV2}
          style={{ ...rightContainerStyle }}
        >
          {showTaggedDetails ? (
            <div
              className={classes.taggedDetails}
              style={{ ...taggedDetailsStyle }}
            >
              {taggedDetails}
            </div>
          ) : null}
          {showCountBadge && count > 0 && isExpanded && (
            <div
              className={classes.countBadge}
              style={{ paddingRight: "2px" }}
              data-test-id={`${testId}count`}
            >
              <Badge
                value={count}
                variant={"filter"}
                type={"numeric"}
                size={"large"}
              />
            </div>
          )}

          {hideActionButtons == false ? (
            _.isEmpty(items) && !dataLength ? (
              showPypElements ? (
                <div
                  style={{
                    paddingRight: "16px",
                    display: "flex",
                    alignItems: "center",
                    ...(disabled ? { display: "flex" } : {}),
                  }}
                >
                  <ConditionalWrapper
                    condition={!isTablet}
                    type="wrapperAsElement"
                    wrapper={
                      <Tooltip
                        dsVersion="2.0"
                        showArrow="true"
                        tooltip={t("journal:le_assessment")}
                      />
                    }
                  >
                    <IconButton
                      dsVersion="2.0"
                      type="plain"
                      size="medium"
                      icon={<LeOutlined />}
                      onClick={e => {
                        e?.stopPropagation();
                        goToStep("TAG_LEARNING_GOALS_FROM_ASSESSMENTS");
                      }}
                      disabled={
                        !isCurrentAcademicYearSelected || isArchivedClass
                      }
                      testId="journal-postcreation-tagle"
                    />
                  </ConditionalWrapper>
                  <ConditionalWrapper
                    condition={!isTablet}
                    type="wrapperAsElement"
                    wrapper={
                      <Tooltip
                        dsVersion="2.0"
                        showArrow="true"
                        tooltip={t("common:unit_plural")}
                      />
                    }
                  >
                    <IconButton
                      dsVersion="2.0"
                      type="plain"
                      size="medium"
                      icon={<UnitPlanOutlined />}
                      onClick={e => {
                        e?.stopPropagation();
                        goToStep("TAG_LEARNING_GOALS_FROM_UNIT");
                      }}
                      testId="journal-postcreation-tagunit"
                    />
                  </ConditionalWrapper>
                  <ConditionalWrapper
                    condition={
                      isStandardsRevamp || showNewStandardsUIInV1
                        ? true
                        : !isTablet
                    }
                    wrapper={
                      !isStandardsRevamp && !showNewStandardsUIInV1 ? (
                        <Tooltip
                          dsVersion="2.0"
                          showArrow="true"
                          tooltip={t("journal:edit_post_pyp_elements")}
                        />
                      ) : (
                        <Dropdown
                          overlay={DropdownOptionComponent}
                          placement={"topRight"}
                          variant={"plain"}
                        />
                      )
                    }
                    type={"wrapperAsElement"}
                  >
                    <IconButton
                      dsVersion="2.0"
                      type="plain"
                      size="medium"
                      icon={<GoalsOutlined />}
                      onClick={handleGoalsClick}
                      disabled={
                        !isCurrentAcademicYearSelected || isArchivedClass
                      }
                      testId="journal-postcreation-tagallgoals"
                    />
                  </ConditionalWrapper>

                  <div
                    style={{
                      borderLeft: `1px solid ${colors.borderSubtle}`,
                      marginLeft: "8px",
                      marginRight: "8px",
                      height: "20px",
                      display: "inline-block",
                      ...(disabled ? { marginTop: "8px" } : {}),
                    }}
                  ></div>
                  <ConditionalWrapper
                    condition={!isTablet}
                    type="wrapperAsElement"
                    wrapper={
                      <Tooltip
                        dsVersion="2.0"
                        showArrow="true"
                        tooltip={t("journal:from_recent_post")}
                      />
                    }
                  >
                    <IconButton
                      dsVersion="2.0"
                      type="plain"
                      size="medium"
                      icon={<PostOneOutlined />}
                      onClick={e => {
                        e?.stopPropagation();
                        updatePost({
                          selectFromAllPYP: false,
                          unitPlan: null,
                          resourceId: null,
                          resourceType: null,
                          resourceItem: undefined,
                          postsWithGoals: postsWithGoals,
                        });
                        goToStep("TAG_LEARNING_GOALS_FROM_POST");
                      }}
                      disabled={
                        !isCurrentAcademicYearSelected || isArchivedClass
                      }
                      testId="journal-postcreation-taggoalfrompost"
                    />
                  </ConditionalWrapper>
                </div>
              ) : (
                <div style={{ paddingRight: "16px" }}>
                  <IconButton
                    dsVersion="2.0"
                    type="plain"
                    size="medium"
                    icon={<AddCircleOutlined />}
                    onClick={onAddClick}
                    testId={`${testId}add`}
                  />
                </div>
              )
            ) : null
          ) : null}

          {showTagLearningGoalsModal ? (
            <TagLearningGoalsModal
              isRecentPost={isRecentPost}
              postsWithGoals={postsWithGoals}
            />
          ) : null}
        </div>
      </div>
      {showRateOnLearningGoals ? rateOnLearningGoals : null}
      {showLearningGoalsDataOutSideAccordion ? (
        <div className={classes.postLearningGoalsMediaCard}>
          {expandedContent}
        </div>
      ) : null}
    </>
  );
};

const TagCardDetails = props => {
  const {
    items,
    leftIcon,
    leftTitle,
    taggedDetails, // this can be used to show tagged items or item count on the right side of card.
    taggedDetailsStyle = {},
    leftContainerStyle = {},
    rightContainerStyle = {},
    onAddClick,
    onEditClick,
    hideActionButtons = false,
    showCountBadge = true,
    showDeleteIcon = false,
    onDeleteClick,
    testId,
  } = props;

  const tagCardTitleClasses = classnames({
    [classes.tagCardTitle]: true,
  });

  return (
    <div className={classes.tagCardContainer}>
      <div
        className={classes.tagCardLeftContainer}
        style={{ ...leftContainerStyle }}
      >
        <div className={classes.tagCardIcon}>{leftIcon}</div>
        <div className={"text-label-l"}>{leftTitle}</div>
        {showCountBadge && _.size(items, 0) > 0 && (
          <div className={classes.countBadge}>
            <Badge
              value={_.size(items, 0)}
              variant={"filter"}
              type={"numeric"}
            />
          </div>
        )}
      </div>

      <div
        className={classes.tagCardRightContainer}
        style={{ ...rightContainerStyle }}
      >
        <div
          className={classes.taggedDetails}
          style={{ ...taggedDetailsStyle }}
        >
          {taggedDetails}
        </div>
        {hideActionButtons == false ? (
          <React.Fragment>
            {_.isEmpty(items) ? (
              <IconButton
                dsVersion="2.0"
                type="plain"
                size="medium"
                icon={<AddCircleOutlined />}
                onClick={onAddClick}
                testId={`${testId}-add`}
              />
            ) : (
              <IconButton
                dsVersion="2.0"
                type="plain"
                size="medium"
                shouldStopPropagation={true}
                icon={<PencilLineOutlined />}
                onClick={onEditClick}
              />
            )}
            {showDeleteIcon == true && _.size(items, 0) > 0 && (
              <IconButton
                dsVersion="2.0"
                type="plain"
                size="medium"
                icon={<DeleteOutlined />}
                onClick={onDeleteClick}
                shouldStopPropagation={true}
                style={{ marginLeft: "8px" }}
              />
            )}
          </React.Fragment>
        ) : null}
      </div>
    </div>
  );
};
const TagCard = props => {
  const {
    items = [],
    allowClickOnCard = true,
    onCardClick,
    expandedContent,
    leftContainerStyle = {},
    showAccordian = true,
    dataLength = 0,
    isAddLEToJournal = false,
    isAddStudentAttachmentToJournal,
    isExpanded,
    id,
    isAddAllResponsesToJournal,
    testId,
    isShareEvaluation,
    isStandardsRevampEnabled,
  } = props;

  const isJournalRoute = hasIncludeGivenPathInCurrentRoute({
    path: "/journal",
  });

  const isEvidencing = isEvidencingEditRoute();

  const [isDetailsOpen, setDetailsOpen] = useState(true);
  const showPortfolioParityCard =
    (isPortfolioParityEnabled() &&
      (isJournalRoute ||
        isAddLEToJournal ||
        isAddStudentAttachmentToJournal ||
        isAddAllResponsesToJournal ||
        isShareEvaluation ||
        isEvidencing)) ||
    isPortfolioReviewSetupEnabledAndIsReviewRoute();

  return (
    <div
      className={isPortfolioParityEnabled() ? classes.cardV2 : classes.card}
      onClick={allowClickOnCard ? onCardClick : undefined}
      onKeyDown={
        allowClickOnCard
          ? e => onEnterOrSpaceKeyDown(e, onCardClick)
          : undefined
      }
      role="button"
      tabIndex={allowClickOnCard ? 0 : -1}
      aria-disabled={!allowClickOnCard}
      style={allowClickOnCard ? { cursor: "pointer" } : {}}
      id={id}
      data-test-id={testId}
    >
      {
        _.size(items, 0) == 0 && !dataLength ? (
          showPortfolioParityCard ? (
            <TagCardDetailsV2 {...props} />
          ) : (
            <TagCardDetails {...props} />
          )
        ) : showAccordian ? (
          <Accordian
            hideContainerBorder={true}
            showLabelBorder={false}
            customTitleComponent={
              showPortfolioParityCard ? (
                <TagCardDetailsV2
                  {...props}
                  leftContainerStyle={{
                    ...leftContainerStyle,
                    paddingLeft: "0px",
                  }}
                  isExpanded={isDetailsOpen}
                />
              ) : (
                <TagCardDetails
                  {...props}
                  leftContainerStyle={{
                    ...leftContainerStyle,
                    paddingLeft: "0px",
                  }}
                />
              )
            }
            isExpanded={isExpanded}
            expandedContent={!_.isNil(expandedContent) ? expandedContent : null}
            showLeftArrow={showPortfolioParityCard ? false : true}
            mainContentContainerStyle={
              showPortfolioParityCard
                ? { padding: "0px 24px" }
                : { padding: "0px 42px 16px" }
            }
            headerStyle={
              showPortfolioParityCard
                ? { padding: "0  24px" }
                : { padding: "0 0 0 16px" }
            }
            customLeftIcon={<CaretRightFilled variant="subtle" />}
            shouldStopPropagation={true}
            customRightArrow={
              showPortfolioParityCard ? (
                <IconButton
                  dsVersion="2.0"
                  icon={<ChevronDownOutlined />}
                  variant="neutral"
                  type="plain"
                  size="medium"
                  isCompact={true}
                />
              ) : null
            }
            getIsExpanded={value => {
              setDetailsOpen(value);
            }}
          />
        ) : showPortfolioParityCard ? (
          <TagCardDetailsV2 {...props} />
        ) : (
          <TagCardDetails {...props} />
        ) // Show the normal card, If we don't want to show the accordian.
      }
    </div>
  );
};

// TAG STUDENTS CARD

const TagStudentCard = props => {
  const {
    students: studentsFromProps,
    t,
    goToStep,
    studentSelectionMode,
    customOnTagStudentClick,
    updatePost,
    excludeSelfFromStudentDetails = false,
    user,
    isAIResponseGenerating,
    isPromptBoxContentPresent,
    isPromptBoxTextPresent,
    createdBy,
    isAddLEToJournal,
    isAddStudentAttachmentToJournal,
    isShareEvaluation,
  } = props;

  const students = excludeSelfFromStudentDetails
    ? _.filter(
        studentsFromProps,
        student => _.get(student, "node.id", _.get(student, "id")) != user?.id
      )
    : studentsFromProps;
  const onAddOrEditClick = () => {
    if (
      isPortfolioAIEnabledAndIsJournalRoute(user.user_type) &&
      (isAIResponseGenerating ||
        isPromptBoxContentPresent ||
        isPromptBoxTextPresent)
    ) {
      return;
    }
    if (
      !_.isNil(customOnTagStudentClick) &&
      _.isFunction(customOnTagStudentClick)
    )
      customOnTagStudentClick();
    else
      goToStep(
        studentSelectionMode == "SINGLE" ? "TAG_SINGLE_STUDENT" : "TAG_STUDENT"
      );
  };
  const isMultipleSelectionMode =
    studentSelectionMode == "MULTIPLE" && _.size(students, 0) > 0;

  const renderStudentVertically = () => {
    const { students } = props;
    const studentAvatarStyle = {
      display: "flex",
      alignItems: "center",
    };
    return (
      <div className={classes.multipleStudentsAvatarContainerVertical}>
        {_.map(students, (student, index) => {
          const studentName = getFormattedUserName({
            user: _.get(student, "node"),
          });
          return (
            <div
              style={{
                marginTop: index !== 0 ? "16px" : "0px",
                ...studentAvatarStyle,
              }}
            >
              <Avatar
                id={_.get(student, "node.id")}
                key={_.get(student, "node.id")}
                shade={"light"}
                name={studentName}
                src={_.get(student, "node.profileImage")}
                color={
                  _.get(student, "node.isArchived")
                    ? "neutral"
                    : AVATAR_COLORS[
                        hashString(_.get(student, "node.id")) %
                          AVATAR_COLORS.length
                      ]
                }
              />
              <span
                className={classes.studentName}
                data-test-id="journal-postcreation-taggedstudentdetails"
              >
                {studentName}
              </span>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <TagCard
      items={students}
      leftIcon={<StudentAddOutlined size="xx-small" />}
      leftTitle={
        studentSelectionMode == "SINGLE"
          ? t("journal:tag_student")
          : t("journal:tag_students")
      }
      showCountBadge={isMultipleSelectionMode}
      showAccordian={
        (isMultipleSelectionMode
          ? _.size(students, 0) > (isPortfolioParityEnabled() ? 0 : 1)
          : true) && isMultipleSelectionMode
      }
      count={_.size(students)}
      showDeleteIcon={isMultipleSelectionMode}
      onDeleteClick={() => {
        if (user?.user_type === "staff")
          updatePost({ students: { edges: [] } });
        else {
          updatePost({
            students: {
              edges: _.filter(students, student => {
                return _.isEqual(
                  _.get(student, "node.id"),
                  _.size(_.keys(createdBy)) ? createdBy?.id : user?.id
                );
              }),
            },
          });
        }
      }}
      isDeleteDisabled={
        (_.size(students, 0) == 1 &&
          _.get(students, "0.node.id") == createdBy?.id) ||
        (_.size(students, 0) == 1 &&
          _.get(students, "0.node.id") == _.get(user, "id") &&
          _.get(user, "user_type") === "student")
      }
      expandedContent={
        _.size(students, 0) > (isPortfolioParityEnabled() ? 0 : 1) ? (
          isPortfolioParityEnabled() ? (
            renderStudentVertically()
          ) : (
            <div className={classes.multipleStudentsAvatarContainer}>
              <AvatarGroup size="small">
                {_.map(students, student => (
                  <Avatar
                    id={_.get(student, "node.id")}
                    key={_.get(student, "node.id")}
                    name={`${_.get(student, "node.firstName")} ${_.get(
                      student,
                      "node.lastName"
                    )}`}
                    src={_.get(student, "node.profileImage")}
                  />
                ))}
              </AvatarGroup>
              <span style={{ padding: "4px" }}>
                <MoreItemWithToolTip
                  items={_.map(
                    students,
                    student =>
                      `${_.get(student, "node.firstName")} ${_.get(
                        student,
                        "node.lastName"
                      )}`
                  )}
                  length={1}
                />
              </span>
            </div>
          )
        ) : null
      }
      taggedDetails={
        //Note:Show user profile only when there is only one student tagged
        _.size(_.keys(_.get(students, "0.node", BLANK_OBJECT)), 0) > 0 &&
        _.size(students) === 1 ? (
          <DSProvider dsVersion="2.0">
            <SingleUserProfile
              username={getFormattedUserName({
                user: _.get(students, "0.node", BLANK_OBJECT),
              })}
              id={_.get(students, "0.node.id", "")}
              profileImageSrc={_.get(students, "0.node.profileImage", "")}
              avatarSize={"x-small"}
            />
          </DSProvider>
        ) : null
      }
      onAddClick={onAddOrEditClick}
      onEditClick={onAddOrEditClick}
      onCardClick={onAddOrEditClick}
      showTaggedDetails={false}
      isAddLEToJournal={isAddLEToJournal}
      isAddStudentAttachmentToJournal={isAddStudentAttachmentToJournal}
      t={t}
      isShareEvaluation={isShareEvaluation}
      testId="journal-postcreation-tagstudent"
    />
  );
};

// TAG COLLECTIONS CARD

const TagCollectionsCard = ({
  t,
  taggedCollections,
  customOnTagCollectionsClick,
}) => {
  const onAddOrEditClick = () => {
    if (
      !_.isNil(customOnTagCollectionsClick) &&
      _.isFunction(customOnTagCollectionsClick)
    )
      customOnTagCollectionsClick();
  };

  return (
    <TagCard
      items={taggedCollections}
      leftIcon={<CopyOutlined size="xx-small" />}
      leftTitle={t("common:tag_label", {
        label: _.lowerFirst(t("journal:collection_plural")),
      })}
      showCountBadge={true}
      showAccordian={true}
      showDeleteIcon={false}
      expandedContent={
        _.size(taggedCollections, 0) > 0 ? (
          <div className={classes.collectionTagsContainer}>
            {_.map(taggedCollections, collection => {
              return (
                <div className={classes.collectionTag} key={collection?.id}>
                  <Tag key={collection?.id} size={"x-small"} color={"neutral"}>
                    {collection?.label}
                  </Tag>
                </div>
              );
            })}
          </div>
        ) : null
      }
      onAddClick={onAddOrEditClick}
      onEditClick={onAddOrEditClick}
      onCardClick={onAddOrEditClick}
      testId="journal-postcreation-tagcollections"
    />
  );
};

const getSharedWithIcon = ({ isPrivate, isHiddenFromStudents }) => {
  if (!isPrivate && !isHiddenFromStudents) {
    return "everyone";
  } else if (isPrivate && !isHiddenFromStudents) {
    return "student";
  } else if (!isPrivate && isHiddenFromStudents) {
    return "parent";
  } else if (isPrivate && isHiddenFromStudents) {
    return "private";
  }
};

const SharedWithCard = props => {
  const {
    students,
    isAddAllResponsesToJournal,
    isPrivate,
    isHiddenFromStudents,
    t,
    goToStep,
    toggleAlert,
    isAddLEToJournal,
    isShareEvaluation,
  } = props;

  const isSharedWithStudents = _.size(students, 0) > 0;
  const isSharedWithEnabled =
    isSharedWithStudents || isAddAllResponsesToJournal;

  const onShareWithClick = () => {
    if (isSharedWithEnabled) {
      goToStep("SHARE_WITH");
    } else {
      toggleAlert({
        showAlert: true,
        alertMessage: t("journal:shared_with_alert_msg"),
      });
    }
  };

  const handleShareWithKeyDown = e => {
    onEnterOrSpaceKeyDown(e, () => {
      onShareWithClick();
    });
  };

  const sharedWithStyle = {
    cursor: isSharedWithEnabled ? "pointer" : "not-allowed",
    opacity: isSharedWithEnabled ? 1 : 0.5,
  };

  return (
    <TagCard
      leftIcon={
        <TeacherShareOutlined
          size={"xx-small"}
          disabled={!isSharedWithEnabled}
        />
      }
      leftTitle={t("journal:shared_with")}
      onAddClick={onShareWithClick}
      onEditClick={onShareWithClick}
      onCardClick={onShareWithClick}
      taggedDetails={
        <div
          tabIndex={isSharedWithEnabled ? 0 : -1}
          role="button"
          aria-label={t("journal:shared_with")}
          onKeyDown={handleShareWithKeyDown}
          className={classes.sharedWithContainer}
        >
          <Tag size="x-small">
            <div className={classes.sharedWith} style={sharedWithStyle}>
              <div
                data-test-id="journal-postcreation-sharedwithicon"
                className={classes.iconContainer}
              >
                <ShareWithIconSvg
                  size={"xxx-small"}
                  type={getSharedWithIcon({ isPrivate, isHiddenFromStudents })}
                />
              </div>
              <div
                data-test-id="journal-postcreation-sharedwithtext"
                className={classes.tagSubText}
              >
                {getSharedWithString({
                  isPrivate,
                  isHiddenFromStudents,
                  withPrefix: false,
                  t,
                })}
              </div>
            </div>
          </Tag>
        </div>
      }
      disabled={!isSharedWithEnabled}
      testId="journal-postcreation-sharedwith"
      {...props}
    />
  );
};

const PYPElementDetails = React.memo(props => {
  const {
    unitPlan,
    postTaggedEntity,
    resourceItem,
    resourceId,
    elementData,
    resourceType,
    selectFromAllPYP,
    t,
    taggableElements,
    showPortfolioParityCard,
    isExpanded,
    onEditClick,
    onDeleteClick,
    setChangeLEWarningModal,
    setDeleteLEWarningModal,
    goToStep,
    onConfirmDeletionOfLE,
    mode,
    elementPYP,
    userType,
    renderStandards = false,
    showStandardsLabel = false,
    canAddWorksheetResponseToPost,
    standardLabel = "Standards",
    showNewStandardsUIInV1,
    isPYPcurriculum = false,
  } = props;
  const isWorkSheetTagged = _.some(
    postTaggedEntity,
    entity => _.get(entity, "entity.assessmentType.value") === "worksheet"
  );
  const detailContainerClass = classnames({
    [classes.detailContainer]: true,
  });
  const dynamicLevelContainerStyle = {
    0: style.learningGoalsContainer,
    1: style.learningGoalsContainer,
    2: style.learningGoalsContainer,
    3: {
      color: colors.textSubtle,
      paddingLeft: "16px",
      ...style.learningGoalsContainer,
    },
  };
  const standardsDynamicLevelContainerStyle = {
    0: style.learningGoalsContainer,
    1: style.learningGoalsContainerDepth1,
    2: style.learningGoalsContainerDepth2,
    3: {
      paddingLeft: "16px",
      ...style.learningGoalsContainer,
    },
  };

  const subjectViewDynamicLevelContainerStyle = {
    0: style.learningGoalsContainerDepth0,
    1: style.learningGoalsContainerDepth1,
    2: style.learningGoalsContainerDepth2,
    3: {
      paddingLeft: "16px",
      ...style.learningGoalsContainer,
    },
  };

  const [isLearningGoalsViewOpen, setLeanringGoalsViewOpen] = useState(false);
  const detailInnerContainerStyle = {
    marginBottom: "-8px",
  };

  const accordianContainerStyle = {
    paddingTop: "2px",
    marginLeft: "4px",
    position: "absolute",
  };

  const isNewGoalTaggingEnabled = getIsNewGoalTaggingEnabled();
  const isMultipleUnitTaggingEnabled = getIsMultipleUnitTaggingEnabled(
    userType
  );
  const isTablet = isTabletByUserAgent();

  useEffect(() => {
    if (mode === "create") {
      setLeanringGoalsViewOpen(true);
    }
  }, []);

  const onAccordianDropDownClick = () => {
    setLeanringGoalsViewOpen(!isLearningGoalsViewOpen);
  };

  const handleKeyDownAccordianDropDownClick = e => {
    onEnterOrSpaceKeyDown(e, onAccordianDropDownClick);
  };

  const onClickEdit = () => {
    _.isEmpty(elementData)
      ? _.first(postTaggedEntity)?.entityType === "UNIT_PLAN"
        ? goToStep("TAG_LEARNING_GOALS_FROM_UNIT")
        : goToStep("TAG_LEARNING_GOALS_FROM_ASSESSMENTS")
      : isNewGoalTaggingEnabled && !isAssessmentTagged(postTaggedEntity)
      ? goToStep("TAG_LEARNING_GOALS_FROM_UNIT")
      : setChangeLEWarningModal(true);
  };

  const onClickDelete = () => {
    _.isEmpty(elementData)
      ? onConfirmDeletionOfLE()
      : setDeleteLEWarningModal(true);
  };

  const subjectDynamicLevelContainerStyle =
    getIsStandardsRevampEnabled() && renderStandards
      ? showNewStandardsUIInV1 && isPYPcurriculum
        ? subjectViewDynamicLevelContainerStyle
        : standardsDynamicLevelContainerStyle
      : dynamicLevelContainerStyle;

  const getUnitOrLEIcons = useMemo(() => {
    const isResourceItem = isAssessmentTagged(postTaggedEntity);
    const isSingleUnitTagged =
      _.size(getPostEntity(postTaggedEntity, "UNIT_PLAN")) === 1;
    const selectedUnitPlans = _.size(
      getPostEntity(postTaggedEntity, "UNIT_PLAN")
    );

    return (
      <div className={!isResourceItem ? classes.unitContainer : ""}>
        {!isResourceItem && isMultipleUnitTaggingEnabled ? (
          <span className={classes.unitTitle}>
            {isSingleUnitTagged ? t("common:unit") : t("journal:units")}
            {selectedUnitPlans > 1 ? (
              <span>{` (${selectedUnitPlans})`}</span>
            ) : null}
          </span>
        ) : null}
        <div className={classes.lerningElementCta}>
          {_.isEmpty(elementData) ? (
            <ConditionalWrapper
              type="wrapperAsElement"
              condition={!isTablet}
              wrapper={
                <Tooltip
                  dsVersion="2.0"
                  showArrow="true"
                  tooltip={
                    isResourceItem
                      ? t("journal:tag_learning_from_this_goals_from_le")
                      : t("journal:tag_learning_from_this_goals_from_unit")
                  }
                />
              }
            >
              <IconButton
                dsVersion="2.0"
                type="plain"
                variant="neutral"
                size="small"
                icon={<GoalsOutlined variant={"subtle"} />}
                onClick={onEditClick}
              />
            </ConditionalWrapper>
          ) : null}
          {!isResourceItem && isEvidencingEditRoute() ? null : (
            <div className={classes.lerningElementCta}>
              <ConditionalWrapper
                type="wrapperAsElement"
                condition={!isTablet}
                wrapper={
                  <Tooltip
                    dsVersion="2.0"
                    showArrow="true"
                    tooltip={
                      isResourceItem
                        ? t("journal:edit_le")
                        : t("journal:edit_unit")
                    }
                  />
                }
              >
                <IconButton
                  dsVersion="2.0"
                  type="plain"
                  variant="neutral"
                  size="small"
                  shouldStopPropagation={true}
                  icon={
                    <PencilLineOutlined size="xx-small" variant={"subtle"} />
                  }
                  onClick={onClickEdit}
                />
              </ConditionalWrapper>
              <ConditionalWrapper
                type="wrapperAsElement"
                condition={!isTablet}
                wrapper={
                  <Tooltip
                    dsVersion="2.0"
                    showArrow="true"
                    tooltip={t("common:delete")}
                  />
                }
              >
                <IconButton
                  dsVersion="2.0"
                  type="plain"
                  variant="neutral"
                  size="small"
                  icon={<DeleteOutlined size="xx-small" variant={"subtle"} />}
                  shouldStopPropagation={true}
                  onClick={onClickDelete}
                />
              </ConditionalWrapper>
            </div>
          )}
        </div>
      </div>
    );
  }, [postTaggedEntity, elementData]);
  const pypElements = (
    <div className={detailContainerClass}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          ...(!!unitPlan ||
          !!resourceItem ||
          isUnitPlanOrAssessmentTagged(postTaggedEntity)
            ? {
                borderTop: `1px solid ${colors.borderSubtle}`,
                paddingTop: "16px",
              }
            : {}),
        }}
      >
        <span
          className={"text-label-l"}
          style={{ flex: "2" }}
          onClick={onAccordianDropDownClick}
          onKeyDown={e => onEnterOrSpaceKeyDown(e, onAccordianDropDownClick)}
          role="button"
          tabIndex={0}
          data-test-id="journal-postcreation-learninggoalstoggle-button"
        >
          {showStandardsLabel
            ? standardLabel
            : t(
                showStandardsLabel
                  ? "common:standard_other"
                  : "journal:edit_post_pyp_elements"
              )}
          <span style={style.countLabel}>
            {` (${getTaggedGoalsCount(elementPYP)})`}
          </span>
          <span
            className={classes.learningGoalsDropdown}
            style={accordianContainerStyle}
            tabIndex={0}
            role="button"
            onKeyDown={handleKeyDownAccordianDropDownClick}
          >
            {isLearningGoalsViewOpen ? (
              <CaretOpenedFilled variant="subtle" size={"xxx-small"} />
            ) : (
              <CaretClosedFilled variant="subtle" size={"xxx-small"} />
            )}
          </span>
        </span>
        <div className={classes.lerningElementCta}>
          <IconButton
            dsVersion="2.0"
            type="plain"
            size="small"
            variant="neutral"
            shouldStopPropagation={true}
            icon={<PencilLineOutlined size="xx-small" variant={"subtle"} />}
            onClick={onEditClick}
            testId="journal-postcreation-editlearninggoals"
          />

          <IconButton
            dsVersion="2.0"
            type="plain"
            variant="neutral"
            size="small"
            icon={<DeleteOutlined size="xx-small" variant={"subtle"} />}
            shouldStopPropagation={true}
            onClick={onDeleteClick}
            testId="journal-postcreation-deletelearninggoals"
          />
        </div>
      </div>
      <Accordian
        hideContainerBorder={true}
        showLabelBorder={false}
        isExpanded={isLearningGoalsViewOpen}
        expandedContent={
          <PYPElements
            elementData={elementData}
            pypTemplateElements={taggableElements}
            customContainerStyle={{
              borderBottom: "none",
            }}
            dynamicLevelContainerStyle={subjectDynamicLevelContainerStyle}
            showInAccordian={false}
            customRightArrow={
              <IconButton
                dsVersion="2.0"
                icon={<ChevronDownOutlined />}
                variant="neutral"
                type="plain"
                size="medium"
                isCompact={true}
              />
            }
            showLabelBorder={false}
            showDesignV2={showPortfolioParityCard}
            customTitleStyle={style.titleStyle}
            theme={{ labelStyle: style.titleStyle }}
            defaultAccodianExpanded={isExpanded}
            addSeparators={!renderStandards}
            customTextStyle={style.learningGoalsContainer}
            showDPLpaInTextView={true}
            showStandardsLabel={true}
            skipNodeLevelCheck={
              getIsNewGradingSetupEnabled() || showNewStandardsUIInV1
            }
            showSetTitle={isPYPcurriculum && _.isEqual(mode, "create")}
            hideLabel={renderStandards}
            showDiscAtAllLevel={
              showNewStandardsUIInV1
                ? false
                : getIsStandardsRevampEnabled() && renderStandards
            }
            standardLabel={standardLabel}
          />
        }
        showLeftArrow={true}
        customTitleComponent={null}
        headerStyle={{
          display: "none",
        }}
        customLeftIcon={<CaretRightFilled variant="subtle" />}
        shouldStopPropagation={true}
        customRightArrow={
          showPortfolioParityCard ? (
            <IconButton
              icon={<ChevronDownOutlined />}
              variant="neutral"
              type="plain"
              size="medium"
              dsVersion="2.0"
              isCompact={true}
            />
          ) : null
        }
        mainContentContainerStyle={
          isNewGoalTaggingEnabled
            ? style.mainContentContainerStyle
            : BLANK_OBJECT
        }
      />
    </div>
  );
  if (
    isNewGoalTaggingEnabled &&
    isUnitPlanOrAssessmentTagged(postTaggedEntity)
  ) {
    const isResourceItem = isAssessmentTagged(postTaggedEntity);
    return (
      <div>
        {!isResourceItem && isMultipleUnitTaggingEnabled
          ? getUnitOrLEIcons
          : null}

        {!_.isEmpty(postTaggedEntity) &&
          _.isArray(postTaggedEntity) &&
          _.map(
            isAssessmentTagged(postTaggedEntity)
              ? getPostEntityValues(postTaggedEntity, "ASSESSMENT")
              : postTaggedEntity,
            (entity, i) => {
              const entityType = _.get(entity, "entityType", "");
              const isUnitPlan = _.isEqual(entityType, "UNIT_PLAN");
              const isResourceItem = _.isEqual(entityType, "ASSESSMENT");

              return (
                <div style={style.unitDetailsWrapperStyle}>
                  <UnitDetails
                    unitPlan={
                      isUnitPlan
                        ? _.get(entity, "entity", null)
                        : isResourceItem
                        ? _.get(entity, "entity.unitPlan")
                        : null
                    }
                    resourceItem={
                      !isUnitPlan ? _.get(entity, "entity", null) : null
                    }
                    resourceType={_.get(entity, "entityType")}
                    detailInnerContainerStyle={detailInnerContainerStyle}
                    showDesignV2={isPortfolioParityEnabled()}
                    showDetailsHeaderText={!isPortfolioParityEnabled()}
                    subDetailContainerStyle={
                      style.unitSubDetailContainerStyleV2
                    }
                    detailContainerStyle={style.unitDetailContainerStyle}
                    showUnitPlan={!isAssessmentTagged(postTaggedEntity)}
                    subDetailRightContainerStyle={
                      style.unitSubDetailRightContainerStyle
                    }
                    resourceImagePlaceHolderStyle={
                      style.resourceImagePlaceHolderStyle
                    }
                    userType={userType}
                    canAddWorksheetResponseToPost={
                      canAddWorksheetResponseToPost || isWorkSheetTagged
                    }
                  />
                  {isResourceItem || !isMultipleUnitTaggingEnabled
                    ? getUnitOrLEIcons
                    : null}
                </div>
              );
            }
          )}
        {!_.isEmpty(elementData) ? (
          <div style={style.elementsWrapper}>{pypElements}</div>
        ) : null}
      </div>
    );
  }
  if ((!!unitPlan || !!resourceItem) && !isNewGoalTaggingEnabled)
    return (
      <React.Fragment>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <UnitDetails
            unitPlan={unitPlan}
            resourceItem={resourceItem}
            resourceType={resourceType}
            detailInnerContainerStyle={detailInnerContainerStyle}
            showDesignV2={isPortfolioParityEnabled()}
            showDetailsHeaderText={!isPortfolioParityEnabled()}
            subDetailContainerStyle={style.unitSubDetailContainerStyle}
            detailContainerStyle={style.unitDetailContainerStyle}
            showUnitPlan={!isPortfolioParityEnabled() ? true : !resourceItem}
            subDetailRightContainerStyle={
              style.unitSubDetailRightContainerStyle
            }
            resourceImagePlaceHolderStyle={style.resourceImagePlaceHolderStyle}
            userType={userType}
          />
          <div>
            {_.isEmpty(elementData) ? (
              <Tooltip
                dsVersion="2.0"
                showArrow="true"
                tooltip={
                  resourceItem
                    ? t("journal:tag_learning_from_this_goals_from_le")
                    : t("journal:tag_learning_from_this_goals_from_unit")
                }
              >
                <IconButton
                  dsVersion="2.0"
                  variant="plain"
                  size="medium"
                  icon={<GoalsOutlined />}
                  onClick={onEditClick}
                  testId={`journal-postcreation-${
                    resourceItem ? "tagfromle" : "tagfromunit"
                  }`}
                />
              </Tooltip>
            ) : null}
            <Tooltip
              dsVersion="2.0"
              showArrow="true"
              tooltip={
                resourceItem ? t("journal:edit_le") : t("journal:edit_unit")
              }
            >
              <IconButton
                dsVersion="2.0"
                size="small"
                type="plain"
                variant="neutral"
                shouldStopPropagation={true}
                icon={<PencilLineOutlined size="xx-small" />}
                onClick={() => {
                  _.isEmpty(elementData)
                    ? !_.isNil(resourceItem)
                      ? goToStep("TAG_LEARNING_GOALS_FROM_ASSESSMENTS")
                      : goToStep("TAG_LEARNING_GOALS_FROM_UNIT")
                    : setChangeLEWarningModal(true);
                }}
                testId={`journal-postcreation-${
                  resourceItem ? "edittaggedle" : "edittaggedunit"
                }`}
              />
            </Tooltip>
            <Tooltip
              dsVersion="2.0"
              showArrow="true"
              tooltip={t("common:delete")}
            >
              <IconButton
                dsVersion="2.0"
                variant={"neutral"}
                type={"plain"}
                size="small"
                icon={<DeleteOutlined size="xx-small" />}
                shouldStopPropagation={true}
                onClick={() => {
                  _.isEmpty(elementData)
                    ? onConfirmDeletionOfLE()
                    : setDeleteLEWarningModal(true);
                }}
                testId={`journal-postcreation-${
                  resourceItem ? "deletetaggedle" : "deletetaggedunit"
                }`}
              />
            </Tooltip>
          </div>
        </div>
        {!_.isEmpty(elementData) ? (
          <div style={{ paddingTop: "16px" }}>{pypElements}</div>
        ) : null}
      </React.Fragment>
    );
  if (!_.isEmpty(elementData)) return pypElements;

  return null;
});

PYPElementDetails.displayName = "PYPElementDetails";

const PYPElementDetailsWithLoader = compose(withLoader)(PYPElementDetails);

const PYPElementTag = props => {
  const {
    onAddOrEditClick,
    elementPYP,
    t,
    unitPlan,
    postTaggedEntity,
    resourceItem,
    elementData,
    resourceType,
    isData,
    isLoading,
    selectFromAllPYP,
    taggableElements,
    learningGoalsCount,
    goToStep,
    updatePost,
    showWarningModal,
    showTagLearningGoalsModal,
    isRecentPost,
    postsWithGoals,
    isResourceSkipped,
    showPortfolioParityCard,
    isExpanded,
    onDeleteClick,
    setChangeLEWarningModal,
    setDeleteLEWarningModal,
    onConfirmDeletionOfLE,
    isShareEvaluation,
    mode,
    userType,
    isNewGradingSetupEnabled,
    setShowStandardsModal,
    showStandardsModal,
    isStandardsRevampEnabled,
    setIsStandardSelected = _.noop,
    canAddWorksheetResponseToPost,
    curriculumProgramType,
    standardLabel = "Standards",
    showNewStandardsUIInV1,
  } = props;

  const onTagLearningGoalClick = value => {
    switch (value) {
      case TAG_FROM_ALL_LEARNING_GOALS:
        updatePost({
          selectFromAllPYP: true,
          unitPlan: null,
          resourceId: null,
          resourceType: null,
          resourceItem: undefined,
        });
        break;

      case TAG_LEARNING_GOALS_FROM_UNIT:
        updatePost({
          selectFromAllPYP: false,
          unitPlan: unitPlan,
          resourceId: null,
          resourceType: null,
          resourceItem: undefined,
        });
        break;

      case TAG_LEARNING_GOALS_FROM_ASSESSMENTS:
        updatePost({
          selectFromAllPYP: false,
          unitPlan: _.get(resourceItem, "unitPlan", null),
          resourceId: _.get(resourceItem, "id", null),
          resourceType: _.get(resourceItem, "type", null),
          resourceItem: resourceItem,
        });
        break;
      case TAG_LEARNING_GOALS_FROM_POST:
        updatePost({
          selectFromAllPYP: false,
          unitPlan: null,
          resourceId: null,
          resourceType: null,
          resourceItem: undefined,
          postsWithGoals: postsWithGoals,
        });
        break;
    }
    if (!_.isEmpty(value)) {
      goToStep(value);
    }
  };
  const elementsLength = _.get(elementPYP, "length", 0);
  const tagLearningGoalsOptions = [
    {
      label: t("journal:le_and_assessments"),
      key: TAG_LEARNING_GOALS_FROM_ASSESSMENTS,
      icon: <LearningExperienceColored size={"x-small"} />,
      background: colors.decorativeSurfaceTwoL,
    },
    {
      label: t("common:unit_plural"),
      key: TAG_LEARNING_GOALS_FROM_UNIT,
      icon: <UnitPlanOutlined variant={"link"} />,
      background: colors.decorativeSurfaceOneL,
    },
    {
      label: t("journal:all_pyp_elements"),
      key: TAG_FROM_ALL_LEARNING_GOALS,
      icon: <GoalsOutlined variant="success" />,
      background: colors.surfaceSuccess,
    },
  ];
  const [isTagLearningGoalsModalOpen, setShowTagLearningGoalsModal] = useState(
    false
  );
  const isNewGoalTaggingEnabled = getIsNewGoalTaggingEnabled();
  const onAddClick = () => {
    setShowTagLearningGoalsModal(true);
    updatePost({ showTagLearningGoalsModal: true });
  };

  const getStandardSetIds = (entities, isPYPCurriculum) => {
    const nestedStandardSetIds = _.map(entities, entity => {
      const standardsWrapper = _.get(entity, "fields", null);
      const standardEntity = _.find(standardsWrapper, field =>
        getIsSubjectStandard({ type: pypElementMapping[field.uid] })
      );
      if (
        standardEntity &&
        _.isArray(standardEntity.value) &&
        !_.isEmpty(standardEntity.value)
      ) {
        return _.map(
          isPYPCurriculum
            ? _.get(standardEntity, "resolvedMinimalTree.benchmarks", [])
            : _.get(standardEntity, "resolvedMinimalTree.nodes", []),
          "standardsWrapper.standardSet.id"
        );
      }
      return [];
    });
    // Flatten and remove duplicates/nulls
    return _.uniq(_.flatten(nestedStandardSetIds));
  };

  const onEditLearningGoals = () => {
    const standardSetIds = isNewGradingSetupEnabled
      ? getStandardSetIds(
          _.map(postTaggedEntity, "entity"),
          curriculumProgramType === CURRICULUM_TYPE_PYP
        )
      : BLANK_ARRAY;

    updatePost({
      originalUnitPlan: isNewGoalTaggingEnabled ? postTaggedEntity : unitPlan,
      originalIsResourceSkipped: isResourceSkipped,
      ...(isNewGradingSetupEnabled ? { standardSetIds } : {}),
      originalResourceId: isNewGoalTaggingEnabled
        ? postTaggedEntity
        : resourceItem?.id,
      originalResourceType: resourceItem?.type,
      originalResourceItem: resourceItem,
      originalElementPYP: elementPYP,
      originalSelectFromAllPYP: selectFromAllPYP,
      selectFromAllPYP: isNewGoalTaggingEnabled
        ? isUnitPlanOrAssessmentTagged(postTaggedEntity)
          ? false
          : true
        : selectFromAllPYP, // During edit post, selectFromAllPYP might be undefined. so set before opening the modal
    });
    if (selectFromAllPYP) {
      goToStep(TAG_FROM_ALL_LEARNING_GOALS);
    } else if (!_.isNil(unitPlan) && _.isNil(resourceItem)) {
      goToStep(TAG_LEARNING_GOALS_FROM_UNIT);
    } else if (!_.isNil(unitPlan) && !_.isNil(resourceItem)) {
      goToStep(TAG_LEARNING_GOALS_FROM_ASSESSMENTS);
    } else {
      goToStep(TAG_LEARNING_GOALS_FROM_POST);
    }
  };

  const onEditClick = () => {
    onEditLearningGoals();
    goToStep("TAG_PYP_ELEMENT", 2);
  };

  const onEditClickStandards = () => {
    setShowStandardsModal(true);
  };
  const elementsCount =
    learningGoalsCount +
    _.keys(unitPlan).length +
    _.keys(resourceItem).length +
    (isNewGoalTaggingEnabled
      ? isUnitPlanOrAssessmentTagged(postTaggedEntity)
        ? _.size(postTaggedEntity)
        : 0
      : 0);

  const isEmptyElementData = elementData => {
    return _.every(elementData, data => _.isEmpty(data));
  };
  const sizeOfElementPypWithoutStandards = _.size(
    _.filter(elementPYP, item =>
      getIsSubjectStandard({ type: pypElementMapping[item.fieldUID] })
    )
  );
  const totalElementPYPSize =
    _.size(elementPYP) - sizeOfElementPypWithoutStandards;

  const onDeleteClickStandards = () => {
    setIsStandardSelected(true);
    onDeleteClick();
  };

  const onDeletedGoalsClicked = () => {
    setIsStandardSelected(false);
    onDeleteClick();
  };

  const addGoals = isStandards => () => {
    updatePost({
      selectFromAllPYP: true,
      unitPlan: null,
      resourceId: null,
      resourceType: null,
      resourceItem: undefined,
    });
    isStandards
      ? onEditClickStandards()
      : goToStep("TAG_FROM_ALL_LEARNING_GOALS");
  };

  // Add these memoized functions at the top of the component or outside the component

  const getElementsWithoutStandards = useMemo(
    () =>
      _.filter(
        taggableElements,
        item => !getIsSubjectStandard({ type: item.elementType })
      ),
    [taggableElements]
  );

  const getElementPypWithoutStandards = useMemo(
    () =>
      _.filter(
        elementPYP,
        item =>
          !getIsSubjectStandard({
            type: pypElementMapping[item.fieldUID],
          })
      ),
    [elementPYP]
  );

  const getTaggableStandardElements = useMemo(
    () =>
      _.filter(taggableElements, item =>
        getIsSubjectStandard({ type: item.elementType })
      ),
    [taggableElements]
  );

  const getStandardElementPyp = useMemo(
    () =>
      _.filter(elementPYP, item =>
        getIsSubjectStandard({
          type: pypElementMapping[item.fieldUID],
        })
      ),
    [elementPYP]
  );

  // Then use these memoized values instead of the original variables:
  const elementsWithoutStandards = getElementsWithoutStandards;
  const elementPypWithoutStandards = getElementPypWithoutStandards;
  const taggableStandardElements = getTaggableStandardElements;
  const standardElementPyp = getStandardElementPyp;
  return (
    <TagCard
      leftIcon={<OpenBookTextOutlined size={"xx-small"} />}
      leftTitle={t("journal:tag_learning_elements")}
      onTagLearningGoalClick={onTagLearningGoalClick}
      showTagLearningGoalsModal={showTagLearningGoalsModal}
      onAddClick={onAddClick}
      setShowTagLearningGoalsModal={setShowTagLearningGoalsModal}
      isTagLearningGoalsModalOpen={isTagLearningGoalsModalOpen}
      isRecentPost={isRecentPost}
      tagLearningGoalsOptions={tagLearningGoalsOptions}
      dataLength={elementsCount}
      standardLabel={standardLabel}
      showDeleteIcon={
        (elementsLength ||
          _.keys(unitPlan).length ||
          _.keys(resourceItem).length) > 0
      }
      goToStep={goToStep}
      expandedContent={
        !isStandardsRevampEnabled ||
        isUnitPlanOrAssessmentTagged(postTaggedEntity) ? (
          <PYPElementDetailsWithLoader
            t={t}
            unitPlan={unitPlan}
            postTaggedEntity={postTaggedEntity}
            resourceItem={resourceItem}
            elementData={elementData}
            resourceType={resourceType}
            isData={isData}
            isLoading={isLoading}
            selectFromAllPYP={selectFromAllPYP}
            taggableElements={taggableElements}
            showPortfolioParityCard={showPortfolioParityCard}
            isExpanded={isExpanded}
            onEditClick={onEditClick}
            onDeleteClick={onDeleteClick}
            setChangeLEWarningModal={setChangeLEWarningModal}
            setDeleteLEWarningModal={setDeleteLEWarningModal}
            goToStep={goToStep}
            onConfirmDeletionOfLE={onConfirmDeletionOfLE}
            mode={mode}
            elementPYP={elementPYP}
            userType={userType}
            // renderStandards={isStandardsRevampEnabled}
            // showStandardsLabel={
            //   (isStandardsRevampEnabled && selectFromAllPYP) ||
            //   _.size(
            //     _.filter(elementPYP, item =>
            //       getIsSubjectStandard({
            //         type: pypElementMapping[item.fieldUID],
            //       })
            //     )
            //   ) === _.size(elementPYP)
            // }
            canAddWorksheetResponseToPost={canAddWorksheetResponseToPost}
            standardLabel={standardLabel}
          />
        ) : (
          <>
            {totalElementPYPSize ? (
              <>
                <PYPElementDetailsWithLoader
                  t={t}
                  unitPlan={unitPlan}
                  postTaggedEntity={postTaggedEntity}
                  resourceItem={resourceItem}
                  elementData={elementData}
                  resourceType={resourceType}
                  isData={isData}
                  isLoading={isLoading}
                  selectFromAllPYP={selectFromAllPYP}
                  taggableElements={elementsWithoutStandards}
                  showPortfolioParityCard={showPortfolioParityCard}
                  isExpanded={isExpanded}
                  onEditClick={onEditClick}
                  onDeleteClick={onDeletedGoalsClicked}
                  setChangeLEWarningModal={setChangeLEWarningModal}
                  setDeleteLEWarningModal={setDeleteLEWarningModal}
                  goToStep={goToStep}
                  onConfirmDeletionOfLE={onConfirmDeletionOfLE}
                  mode={mode}
                  elementPYP={elementPypWithoutStandards}
                  userType={userType}
                  standardLabel={standardLabel}
                />
                {!sizeOfElementPypWithoutStandards &&
                !isUnitPlanOrAssessmentTagged(postTaggedEntity) ? (
                  <Button
                    className={classes.addGoalsButton}
                    dsVersion="2.0"
                    variant="neutral"
                    type="inline"
                    size="medium"
                    icon={<AddCircleOutlined />}
                    onClick={addGoals(true)}
                    disabled={false}
                    testId="journal-postcreation-tagfoldercreate"
                  >
                    {t("journal:add_standards")}
                  </Button>
                ) : null}
              </>
            ) : null}

            {sizeOfElementPypWithoutStandards ? (
              <>
                <PYPElementDetailsWithLoader
                  t={t}
                  unitPlan={unitPlan}
                  postTaggedEntity={postTaggedEntity}
                  resourceItem={resourceItem}
                  elementData={elementData}
                  resourceType={resourceType}
                  isData={isData}
                  isLoading={isLoading}
                  selectFromAllPYP={selectFromAllPYP}
                  taggableElements={taggableStandardElements}
                  showPortfolioParityCard={showPortfolioParityCard}
                  isExpanded={isExpanded}
                  onEditClick={onEditClickStandards}
                  onDeleteClick={onDeleteClickStandards}
                  setChangeLEWarningModal={setChangeLEWarningModal}
                  setDeleteLEWarningModal={setDeleteLEWarningModal}
                  goToStep={goToStep}
                  onConfirmDeletionOfLE={onConfirmDeletionOfLE}
                  mode={mode}
                  elementPYP={standardElementPyp}
                  userType={userType}
                  renderStandards={isStandardsRevampEnabled}
                  showStandardsLabel={true}
                  standardLabel={standardLabel}
                  showNewStandardsUIInV1={showNewStandardsUIInV1}
                  isPYPcurriculum={
                    curriculumProgramType === CURRICULUM_TYPE_PYP
                  }
                />
                {!totalElementPYPSize ? (
                  <Button
                    className={classes.addGoalsButton}
                    dsVersion="2.0"
                    variant="neutral"
                    type="inline"
                    size="medium"
                    icon={<AddCircleOutlined />}
                    onClick={addGoals()}
                    disabled={false}
                    testId="journal-postcreation-tagfoldercreate"
                  >
                    {t("journal:add_learning_goals")}
                  </Button>
                ) : null}
              </>
            ) : null}
          </>
        )
      }
      showCountBadge={learningGoalsCount > 0}
      count={learningGoalsCount}
      onEditClick={onEditClick}
      onCardClick={!learningGoalsCount ? onAddClick : _.noop}
      showLearningGoalsDataOutSideAccordion={
        (!isNewGoalTaggingEnabled &&
          (elementsLength ||
            _.keys(unitPlan).length ||
            _.keys(resourceItem).length) > 0) ||
        (isNewGoalTaggingEnabled &&
          (isUnitPlanOrAssessmentTagged(postTaggedEntity)
            ? _.size(postTaggedEntity)
            : !isEmptyElementData(elementData)))
      }
      {...props}
      showNewStandardsUIInV1={showNewStandardsUIInV1}
      isNewGradingSetupEnabled={isNewGradingSetupEnabled}
    />
  );
};

const RateonLearningGoals = React.memo(props => {
  const {
    t,
    disabled,
    openRatingEditor,
    setShowPostRatingsModal,
    postRatingsOfLearningGoals,
    onCardClick,
    isAddLEToJournal,
    isAddStudentAttachmentToJournal,
    studentsCount,
    learningGoalsCount,
    isDisabledInMyp,
    toggleAlert,
    isShareEvaluation,
  } = props;
  const onOptionClick = () => {
    if (disabled) {
      let alertMessage = t("journal:tag_student_and_rating_alert");

      if (studentsCount > 0 && learningGoalsCount == 0)
        alertMessage = t("journal:tag_goals_alert_msg");
      else if (learningGoalsCount > 0 && studentsCount == 0)
        alertMessage = t("journal:tag_student_alert_msg");
      else if (isDisabledInMyp)
        alertMessage = t(
          "toastMsgs:rating_only_available_for_atl_and_standards_lp"
        );

      toggleAlert({
        showAlert: true,
        alertMessage: alertMessage,
      });
      return;
    }
    openRatingEditor();
  };
  return (
    <TagCard
      leftIcon={
        <AssessmentApplicableOutlined size={"xx-small"} disabled={disabled} />
      }
      leftTitle={t("common:rate_on_learning_goals")}
      onAddClick={openRatingEditor}
      onEditClick={openRatingEditor}
      showRateOnLearningGoals={true}
      disabled={disabled}
      hideActionButtons={disabled}
      items={postRatingsOfLearningGoals}
      showAccordian={false}
      showCountBadge={false}
      onCardClick={!disabled ? onCardClick : onOptionClick}
      rateOnLearningGoals={
        !disabled && !_.isEmpty(postRatingsOfLearningGoals) ? (
          <div
            className={classes.postLearningGoalsMediaCard}
            style={{ opacity: disabled ? "0.5" : "1" }}
          >
            <MediaCard
              cardType="medium"
              type={"LEARNING GOALS"}
              name={t("common:rate_on_learning_goals")}
              showSubtext={true}
              subtext={t("common:teacher_evaluation_only")}
              onClick={() => {
                !disabled &&
                  !_.isEmpty(postRatingsOfLearningGoals) &&
                  setShowPostRatingsModal(true);
              }}
              isActivated={false}
            />
          </div>
        ) : null
      }
      isAddLEToJournal={isAddLEToJournal}
      isAddStudentAttachmentToJournal={isAddStudentAttachmentToJournal}
      isShareEvaluation={isShareEvaluation}
      testId="journal-postcreation-rateonlearninggoals"
    />
  );
});

const TagFolderV2Conent = ({
  position,
  childRect,
  popoverRect,
  tagsOptions,
  attachedTags,
  onTagAdd,
  onNewTagAdd,
  setShowManageFoldersModal,
  setCreateFolderOnModalOpen,
  t,
  userType,
  isCreateFolderDisabled = false,
  setTagInputFocus,
}) => {
  const onFolderCreationClick = () => {
    onNewTagAdd();
  };
  const onBlur = () => {
    setTagInputFocus(false);
  };
  return (
    <ArrowContainer
      position={position}
      childRect={childRect}
      popoverRect={popoverRect}
      arrowColor={colors.white}
      arrowStyle={{ opacity: 1, zIndex: 10, left: "24px" }}
      arrowSize={10}
      className="popover-arrow-container"
      arrowClassName="popover-arrow"
    >
      <div className={classes.folderPopoverContent}>
        <div className={classes.tagCloudContainer}>
          {_.map(tagsOptions, tag => {
            return (
              <Tooltip
                tooltip={tag?.text}
                placement="top"
                overlayStyle={{ zIndex: 2510 }}
                overlayInnerStyle={{ overflow: "hidden" }}
              >
                <div
                  onClick={e => {
                    e?.stopPropagation();
                    onTagAdd(tag);
                  }}
                  onKeyDown={e =>
                    onEnterOrSpaceKeyDown(e, () => {
                      e?.stopPropagation();
                      onTagAdd(tag);
                    })
                  }
                  role="button"
                  tabIndex={0}
                  aria-label={tag?.text}
                  className={classes.singleTagContainer}
                  data-test-id="journal-postcreation-tagfolderitem"
                >
                  <Tag
                    key={tag?.id}
                    size={"small"}
                    prefix={
                      <FolderFilled
                        data-test-id={`journal-postcreation-selectedfolderitemcolor-${tag?.color}`}
                        style={{
                          color: _.get(
                            COLORS_MAPPING_FOR_CHIP,
                            tag?.color,
                            colors.surfaceDarkActive
                          ),
                          flexShrink: 0,
                        }}
                      />
                    }
                  >
                    <span>{tag?.text}</span>
                  </Tag>
                </div>
              </Tooltip>
            );
          })}
        </div>
        {_.size(tagsOptions) > 0 && userType === "staff" ? (
          <hr className={classes.divider} />
        ) : null}
        {userType === "staff" ? (
          <div className={classes.folderPopoverFooter}>
            <Button
              dsVersion="2.0"
              variant="progressive"
              type="inline"
              size="large"
              icon={<AddCircleOutlined />}
              onClick={onFolderCreationClick}
              disabled={isCreateFolderDisabled}
              testId="journal-postcreation-tagfoldercreate"
            >
              {t("common:create_new_folder")}
            </Button>
            <IconButton
              dsVersion="2.0"
              icon={<SettingsOutlined />}
              size={"small"}
              variant="neutral"
              type="plain"
              onClick={e => {
                setShowManageFoldersModal(true);
              }}
              className={classes.settingsButton}
              testId="journal-postcreation-tagfoldersetting"
              onBlur={onBlur}
            />
          </div>
        ) : null}
      </div>
    </ArrowContainer>
  );
};
TagFolderV2Conent.displayName = "TagFolderV2Conent";

const CustomTagsCard = props => {
  const {
    tags = [],
    updateFolderArray,
    attachedTags = [],
    t,
    showManageFoldersModal,
    setShowManageFoldersModal,
    setCreateFolderOnModalOpen,
    userType,
    isTablet,
  } = props;
  const [tagInputFocus, setTagInputFocus] = useState(false);

  const tagsOptions = useMemo(
    () =>
      _.map(tags, tag => {
        return {
          text: _.get(tag, "name", ""),
          id: _.get(tag, "id", undefined),
          color: _.get(
            COLORS_MAPPING_FOR_TAG,
            _.get(tag, "color", "#686868"),
            "neutral"
          ),
          isNewTag: _.get(tag, "isNewTag", false),
        };
      }),
    [tags]
  );
  const onTagAdd = value => {
    const existingTag = _.find(tagsOptions, tag => tag?.text == value?.text);
    const isUnique = _.isUndefined(
      _.find(attachedTags, tag => tag?.name == value?.text)
    );
    if (!_.isUndefined(existingTag)) {
      if (isUnique) {
        updateFolderArray([
          ...attachedTags,
          {
            id: _.get(existingTag, "id"),
            name: _.get(existingTag, "text", ""),
            color: _.get(existingTag, "color"),
            isNewTag: _.get(existingTag, "isNewTag", true),
          },
        ]);
      }
    } else {
      if (isUnique) {
        updateFolderArray([
          ...attachedTags,
          {
            id: value?.id,
            name: value?.text,
            color: _.sample(COLORS_MAPPING_FOR_CHIP),
            isNewTag: true,
          },
        ]);
      }
    }
  };

  const onTagRemove = index => {
    if (index < _.size(attachedTags))
      updateFolderArray(
        _.filter(attachedTags, tag => tag?.id != attachedTags[index]?.id)
      );
  };

  const [folderSearchText, setFolderSearchText] = useState("");
  const popoverContainerRef = useRef();
  const popoverParentRef = useRef();
  const onFolderSearchTextChange = e => {
    setFolderSearchText(e?.target?.value);
  };

  const onFolderSearchTextKeyDown = e => {
    if (
      e?.key === "Enter" &&
      _.size(_.trim(folderSearchText)) > 0 &&
      userType === "staff"
    ) {
      onNewTagAddLocal();
    }
  };

  const filteredTagsOptions = useMemo(() => {
    const attachedTagNames = _.map(attachedTags, tag => _.toLower(tag?.name));
    return _.filter(
      tagsOptions,
      tag =>
        _.includes(_.toLower(tag?.text), _.toLower(folderSearchText)) &&
        !_.includes(attachedTagNames, _.toLower(tag?.text))
    );
  }, [folderSearchText, tagsOptions, attachedTags]);

  const tagFolderInputClass = classnames({
    [classes.customFolderInput]: true,
    ["text-body-1"]: true,
  });

  const onTagAddLocal = tag => {
    onTagAdd(tag);
    setFolderSearchText("");
    popoverContainerRef?.current?.focus();
  };

  const onNewTagAddLocal = () => {
    onTagAdd({
      id: folderSearchText,
      text: folderSearchText,
      color: _.sample(COLORS_MAPPING_FOR_TAG),
    });
    setFolderSearchText("");
    popoverContainerRef?.current?.focus();
  };

  const onInputFocus = e => {
    setTagInputFocus(true);
  };
  const onInputBlur = () => {
    setTimeout(() => {
      setTagInputFocus(false || !!attachedTags);
    });
  };
  const popoverPosition = useMemo(() => {
    if (_.isEqual(userType, "student")) {
      return ["top", "bottom"];
    } else {
      return ["bottom", "top"];
    }
  }, [userType]);

  return (
    <div
      className={classes.tagsPopoverContainer}
      style={{ padding: "24px 32px" }}
    >
      <div
        className={classes.customFolderInputContainer}
        ref={popoverParentRef}
      >
        <TaggedFoldersV2
          folders={attachedTags}
          tagSize="small"
          isClosable={true}
          onClose={({ index }) => onTagRemove(index)}
        />
        <input
          ref={popoverContainerRef}
          placeholder={
            _.isEqual(userType, "staff")
              ? t("journal:type_or_create_folders")
              : t("journal:type_here_to_add_folders")
          }
          onChange={onFolderSearchTextChange}
          onKeyDown={onFolderSearchTextKeyDown}
          value={folderSearchText}
          className={tagFolderInputClass}
          onFocus={!isTablet ? onInputFocus : undefined}
          onBlur={!isTablet ? onInputBlur : undefined}
          data-test-id="journal-postcreation-tagfolderinput"
        />
      </div>
      <Popover
        isOpen={
          (_.size(_.trim(folderSearchText)) > 0 && !showManageFoldersModal) ||
          tagInputFocus
        }
        containerClassName={classes.popoverContainer}
        containerStyle={{ zIndex: 2500 }}
        positions={popoverPosition}
        align="start"
        reposition={true}
        onClickOutside={() => {
          setFolderSearchText("");
          setTagInputFocus(false);
        }}
        content={({ position, childRect, popoverRect }) => (
          <TagFolderV2Conent
            position={position}
            popoverRect={popoverRect}
            childRect={childRect}
            tagsOptions={filteredTagsOptions}
            attachedTags={attachedTags}
            onTagAdd={onTagAddLocal}
            onNewTagAdd={onNewTagAddLocal}
            setShowManageFoldersModal={setShowManageFoldersModal}
            setCreateFolderOnModalOpen={setCreateFolderOnModalOpen}
            t={t}
            userType={userType}
            isCreateFolderDisabled={!_.size(_.trim(folderSearchText))}
            setTagInputFocus={setTagInputFocus}
          />
        )}
        childrenRef={popoverContainerRef}
        isChildrenRefPassed={true}
        containerParent={popoverParentRef?.current}
      ></Popover>
    </div>
  );
};

// CAS learning outcomes card
const TagProjectElements = props => {
  const getLabelFromNodes = ({ nodes, value }) => {
    return _.map(
      _.filter(nodes, node => _.includes(value, node.id)),
      item => {
        const { label, type } = item;
        const displayName = _.get(item, ["metadata", "display_name"], null);

        return getIsTypeOfProjectPortfolioLOs({ type }) &&
          displayName &&
          !_.includes(label, displayName)
          ? `${displayName}: ${label}`
          : label;
      }
    );
  };

  const {
    projectGroupType,
    t,
    elementPYP,
    onAddOrEditClick,
    updatePost,
  } = props;

  const projectTagOptions = _.filter(TAGGABLE_PROJECT_ELEMENTS, item =>
    _.includes(item?.projectType, projectGroupType)
  );
  return _.map(projectTagOptions, (element, index) => {
    const fieldObj = PROJECT_TEMPLATE_FIELD_OBJECTS[element?.value];

    const fieldData = _.find(elementPYP, {
      fieldUID: element?.value,
    });

    const startDepth = _.get(
      fieldObj,
      "config.fieldTypeConfig.rootNodeDepth",
      0
    );

    let value;
    switch (element.value) {
      case TEMPLATE_FIELD_SERVICE_ACTION_OUTCOMES_MYP:
      case TEMPLATE_FIELD_CAS_LEARNING_OUTCOMES_DP:
      case TEMPLATE_FIELD_SL_LEARNING_OUTCOMES_DP:
      case TEMPLATE_FIELD_CE_LEARNING_OUTCOMES_DP:
      case TEMPLATE_FIELD_CE_PROCESS_STAGES:
      case TEMPLATE_FIELD_CE_PROCESS_DIMENSIONS:
      case TEMPLATE_FIELD_CE_PROCESS_PRINCIPLES:
        value = getLabelFromNodes({
          nodes: _.get(fieldData, "resolvedMinimalTree.nodes", BLANK_ARRAY),
          value: _.get(fieldData, "value", BLANK_ARRAY),
        });
        break;
      default:
        value = generateNestedSelectedData({
          ...getPYPElementSetFromNodes({
            startDepth,
            nodes: _.get(fieldData, "resolvedMinimalTree.nodes", BLANK_ARRAY),
          }),
          value: _.get(fieldData, "value", BLANK_ARRAY),
        });
        break;
    }
    const dataLength = _.size(_.get(fieldData, "value", BLANK_ARRAY));

    const onOptionClick = () => onAddOrEditClick(element?.value);

    const onDeleteClick = () => {
      updatePost({
        elementPYP: _.filter(
          elementPYP,
          elementToRemove => elementToRemove?.fieldUID != element?.value
        ),
      });
    };

    return (
      <TagCard
        key={element?.value}
        items={_.get(fieldData, "value", BLANK_ARRAY)}
        leftIcon={<GoalsOutlined size="xx-small" />}
        leftTitle={t(element?.tagLabel)}
        onAddClick={onOptionClick}
        onEditClick={onOptionClick}
        onCardClick={onOptionClick}
        onDeleteClick={onDeleteClick}
        showDeleteIcon={true}
        expandedContent={
          <FieldComponent
            mode={"view"}
            value={value}
            type={fieldObj.viewType}
          />
        }
        testId={`journal-postcreation-tagprojectelements-${element?.value}`}
      />
    );
  });
};
const DROP_DOWN_OPTIONS = [
  { key: "upload_device", label: "common:upload_device" },
  { key: "add_google_drive", label: "common:add_google_drive" },
  { key: "add_one_drive", label: "common:add_one_drive" },
  { key: "add_link", label: "common:add_link" },
];

const DROP_DOWN_OPTIONSV2 = [
  {
    key: "upload_image",
    label: "journal:upload_photo_video_from_device",
    accept: [
      "image/jpeg",
      "image/png",
      "image/jpg",
      "image/heic",
      "image/heif",
      "video/mp4",
      "video/avi",
      "video/wmv",
    ],
    perm: "MEDIA",
  },
  {
    key: "capture_voice",
    label: "journal:add_audio",
    reloadText: "journal:restart",
    submitText: "journal:add_to_post",
    perm: "VOICE",
  },
  { key: "capture_image", label: "common:capture_image", perm: "PHOTO" },
  { key: "capture_video", label: "common:capture_video", perm: "VIDEO" },
  { key: "add_link", label: "common:add_link", perm: "LINK" },
  { key: "upload_device", label: "common:upload_device", perm: "FILE" },
  { key: "add_google_drive", label: "common:add_google_drive", perm: "FILE" },
  { key: "add_google_photos", label: "common:google_photos", perm: "FILE" },
  { key: "add_one_drive", label: "common:add_one_drive", perm: "FILE" },
];

const WORKBOOK_DROPDOWNOPTIONS = [
  {
    key: "capture_voice",
    label: "journal:add_audio",
    reloadText: "journal:restart",
    submitText: "journal:add_to_post",
  },
];

const WORKBOOK_DROPDOWNOPTIONS_DISABLED = [
  {
    key: "capture_voice",
    label: "journal:max_audio_limit_warning",
    disabled: true,
  },
];

const DROP_DOWN_OPTIONS_AUDIO_DISABLED = _.map(DROP_DOWN_OPTIONSV2, function (
  option
) {
  if (option.key === "capture_voice") {
    return _.assign({}, option, {
      label: "journal:max_audio_limit_warning",
      disabled: true,
    });
  } else return option;
});

const DROP_DOWN_OPTIONSV2_DISABLED = label => {
  return _.map(DROP_DOWN_OPTIONSV2, function (option) {
    return _.assign({}, option, {
      label: label,
      disabled: true,
      isLabelLocalized: true,
    });
  });
};

// ---- MAIN COMPONENT ----
const ManageSubjectJournalPost = React.memo(props => {
  const {
    screenPanelProps,
    t,
    userType,
    isApprovalRequiredForStudentPosts,
    user,
    courseTags,
    deleteAttachments,
    isAddLEToJournal = false,
    showTagStudent = true,
    showTagProjectElements = false,
    showPostTags = true,
    isStudentTagOptional = true,
    excludeSelfFromStudentDetails = false,
    canScheduleAPost = false,
    showTagCollections = false,
    selectFromAllPYP,
    postRatingsOfLearningGoals,
    originalibPYPElementRatings,
    currentActiveTerms,
    currentActiveTerm,
    isJuniorFolio,
    subjectNames,
    isUploadingInProgress,
    isAIResponseGenerating,
    isPromptBoxContentPresent,
    isPromptBoxTextPresent,
    createdBy,
    isArchivedClass,
    updatePostStatus,
    courseUnitPlans: courseUnitPlansFromCourseHOC,
    showRateonLearingGoals,
    showTagPYPElements,
    showTagFolder,
    defaultNameSortPreference,
    oldPostDetails,
    isStudentTaggingAllowed,
    curriculumProgramType,
    updatePostStatusV2,
    progressOfUploads,
    defaultStudentNameOrderPreference,
    isCurrentAcademicYearSelected,
    postPermissionMediaOptions,
    portfolioType,
    enableGlobalHeader,
    disableGlobalHeader,
    isGlobalHeaderVisible,
    courseId,
    maxAttachmentCount,
    selectedStudentIdsFromFilter,
    studentEdges,
    toolResponses,
    ibPYPElementRatings,
    userId,
    isAIModuleMarketingEnabled,
    setAiModuleMarketingKey,
    isNewGradingSetupEnabled,
    isStandardsRevampEnabled,
    standardLabel = "Standards",
    showNewStandardsUIInV1,
  } = props;

  const learningCourseId = props.learningCourseId;
  const isLearningCourseEnabled = props.isLearningCourseEnabled;
  const couseId = props.couseId;
  const shouldSkipLearningCourseUnits =
    !isLearningCourseEnabled ||
    _.isNil(learningCourseId) ||
    _.isNil(couseId) ||
    _.isEmpty(learningCourseId) ||
    _.isEmpty(couseId) ||
    (!isPortfolioParityEnabledAndIsJournalRoute() &&
      !isPortfolioReviewSetupEnabledAndIsReviewRoute());
  const learningCourseUnitsQueryResult = useQuery(getCourseUnitQueryV2, {
    variables: {
      filters: { searchText: "" },
      id: learningCourseId,
    },
    fetchPolicy: "cache-and-network",
    skip: shouldSkipLearningCourseUnits,
  });
  const learningCourseUnitsData = _.get(learningCourseUnitsQueryResult, "data");
  const courseUnitPlans = useMemo(() => {
    if (shouldSkipLearningCourseUnits) return courseUnitPlansFromCourseHOC;
    const courseDetail = _.get(learningCourseUnitsData, "node", BLANK_OBJECT);
    return getUnitPlans({
      courseUnitPlans: _.get(courseDetail, "unitPlans.edges", BLANK_ARRAY),
    });
  }, [
    shouldSkipLearningCourseUnits,
    learningCourseUnitsData,
    courseUnitPlansFromCourseHOC,
  ]);

  const {
    postDetails: {
      id,
      title,
      students: { edges: students = [] } = {},
      attachments = [],
      resourceItem,
      state,
      isAddAllResponsesToJournal = false,
      items,
      studentsWithResponsePendingToPublish,
      folders: attachedTags,
      studentSelectionMode = "MULTIPLE",
      addedFolders: addedTags = [], // Used when new tags are added during POST EDIT operation
      removedFolders: removedTags = [], // Used when exsiting tags are removed
      createdAt = moment().toISOString(),
      publishedAt,
      taggedPractices,
      isPrivate = true,
      isHiddenFromStudents = true,
      showTagLearningGoalsModal,
      elementPYP = [],
      unitPlan,
      resourceType,
      isResourceSkipped,
      isAddStudentAttachmentToJournal,
      isShareEvaluation,
      postTaggedEntity,
      isWorksheetSelected,
    } = {},
    onPublishClick,
    onDraftClick,
    onMediaCreate,
    onClickSave, // Save function for ProcessJournal
    onSendForApprovalClick,
    onAddAllResponsesToJournal,
    mode,
    mediaCreationOptions,
    onCloseClick,
    updatePost,
    updateFolderArray,
    updateFolderInArrayByName,
    LETitle,
    selectedStudentFromFeedFilter,
    parentType = "post",
    customOnTagStudentClick = null, // specifically given to override tag student card click with given prop function (ref. AddEditActionModalV2.js)
    postServerObject,
    customOnTagCollectionsClick = null,
    taggedCollections,
    isSnpV2Enabled,
    totalNewSnpCycles,
    isRecentPost,
    elementData,
    setWorkbookMode,
    isUserAllowedToPublishPost,
    isPostCtaDisabled = false,
    goToPreviousStep,
  } = screenPanelProps;
  const isProjectPost = parentType == "projects";
  const nonAudioAttachments = getNonAudioAttachments(attachments);
  const [uploadingStatus, setUploadingStatus] = useState(false);
  const [showPostScheduleModal, setShowPostScheduleModal] = useState(false);
  const [scheduleDateTimeDetails, setScheduleDateTimeDetails] = useState({});
  const [showAttachmentPreview, setShowAttachmentPreview] = useState(false);
  const isTablet =
    useMediaQuery(TABLET_LANDSCAPE_MEDIA_QUERY) ||
    isIpad() ||
    isIphone() ||
    isTabletByUserAgent();

  const [showStandardsModal, setShowStandardsModal] = useState(false);
  const [showAlert, setAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [showGoalsRemovalWarningModal, setGoalsRemovalWarningModal] = useState(
    false
  );
  const [showChangeLEWarningModal, setChangeLEWarningModal] = useState(false);
  const [showDeleteLEWarningModal, setDeleteLEWarningModal] = useState(false);
  const [showManageFoldersModal, setShowManageFoldersModal] = useState(false);
  const [createFolderOnModalOpen, setCreateFolderOnModalOpen] = useState(false);
  const [showLearningGoalsEditor, setShowLearningGoalsEditor] = useState(false);
  const [showPostRatingsModal, setShowPostRatingsModal] = useState(false);
  const [showMediaModal, setShowMediaModal] = useState(false);
  const [currentAttachmentIndex, setCurrentAttachmentIndex] = useState(0);
  const isGlobalHeaderVisiblePrevRef = useRef(isGlobalHeaderVisible);
  const prevAttachmentCount = useRef(_.size(attachments));

  const isStandardSelected = useRef(false);
  const setIsStandardSelected = useCallback(value => {
    isStandardSelected.current = value;
  }, []);
  const toggleMediaModal = value => {
    setShowMediaModal(value);
    setCurrentAttachmentIndex(0);
  };
  const toggleMediaModalWithIndex = ({ value, attachmentIndex = 0 }) => {
    setShowMediaModal(value);
    setCurrentAttachmentIndex(attachmentIndex);
  };
  const isJournalRoute = hasIncludeGivenPathInCurrentRoute({
    path: "/journal",
  });
  const [showEditAttachmentModal, setEditAttachmentModal] = useState(false);
  const [currentDialogAction, setCurrentDialogAction] = useState("");
  const [currentDialogPostId, setCurrentDialogPostId] = useState("");
  const [
    currentDialogPostCreatorName,
    setCurrentDialogPostCreatorName,
  ] = useState("");

  const onDialogActionClick = ({ id, action, createdByName }) => {
    setCurrentDialogAction(action);
    setCurrentDialogPostId(id);
    setCurrentDialogPostCreatorName(createdByName);
  };

  const OnToggleDialogueClick = () => {
    setCurrentDialogAction("");
    setCurrentDialogPostId("");
    setCurrentDialogPostCreatorName("");
  };
  const onPostActionClick = async ({
    id,
    action,
    createdByName = "",
    isAddLEToJournal,
  }) => {
    switch (action) {
      case "APPROVE":
        updatePostStatusV2("PUBLISHED");
        _.isFunction(onCloseClick) && onCloseClick();
        break;
      case "APPROVE_ALL":
      case "APPROVE_WITH_COMMENT":
      case "REJECT_POST":
        onDialogActionClick({ id, action, createdByName });
        break;
    }
  };
  const onDialogConfirmClick = comment => {
    const commentText = _.trim(comment);
    switch (currentDialogAction) {
      case "APPROVE_WITH_COMMENT":
        updatePostStatusV2("PUBLISHED", {
          approveComment: commentText,
        });
        onCloseClick();
        break;
      case "REJECT_POST":
        updatePostStatusV2("REJECTED", {
          rejectComment: commentText,
        });
        onCloseClick();
        break;
      case "IN_APPROVAL":
        updatePostStatus(currentDialogPostId, currentDialogAction);
        onCloseClick();
        break;
    }
  };
  const learningGoalsCount = _.reduce(
    elementPYP,
    (acc, goal) => {
      return acc + goal.value.length;
    },
    0
  );

  const standardsCount =
    isNewGradingSetupEnabled && isStandardsRevampEnabled
      ? _.reduce(
          _.filter(elementPYP, item =>
            getIsSubjectStandard({
              type: _.get(pypElementMapping, item.fieldUID),
            })
          ),
          (acc, goal) => {
            return acc + goal.value.length;
          },
          0
        )
      : 0;
  const prevLearningGoalsCount = _.reduce(
    _.get(oldPostDetails, "elementPYP"),
    (acc, goal) => {
      return acc + goal.value.length;
    },
    0
  );

  const fetchAudioAttachment = () => {
    return _.filter(attachments, { type: "AUDIO" });
  };
  const NoGradesConfiguredModal = props => {
    const { onClose } = props;
    return (
      <Modal width="100%" height="100%" isOpen={true} onClose={onClose}>
        <Modal.Header title={t("common:rate_on_learning_goals")} isClosable />
        <Modal.Body style={style.noGradesConfiguredModalHeader}>
          <div className={classes.noGradesConfiguredModal}>
            <EmptyState
              illustration={NoChecklistIllustration}
              title={t("journal:no_grades_configured")}
              subtitle={t("journal:no_grades_configured_subtext")}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outlined-subtle"
            size={"large"}
            onClick={onClose}
            style={style.noGradesConfiguredModalCancelStyle}
          >
            {t("common:cancel")}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  const toggleAlert = ({
    showAlert = false,
    alertMessage = "",
    params = {},
  }) => {
    props.setToastMsg({
      msg: alertMessage,
      type: "info",
      theme: "dark",
      customInfoIconStyle: style.customInfoIconStyle,
      locale_params: [
        {
          isPlainText: true,
          theme: "dark",
          ...params,
        },
      ],
    });
  };

  const isDisabledInMyp =
    curriculumProgramType === CURRICULUM_TYPE_MYP &&
    !_.some(
      elementPYP,
      element =>
        _.includes(
          ["atlsMYP", "learningStandardMYP", "lpMYP"],
          element.fieldUID
        ) && !_.isEmpty(element.value)
    );
  const [showPromptBox, setShowPromptBox] = useState(false);
  const [showPromptBoxOverOptions, setShowPromptBoxOverOptions] = useState(
    false
  );
  const [isFocussedRef, setFocusRef] = useState(false);
  const [textInputRef, setTextInputRef] = useState(null);
  const aiInputRef = useRef(null);
  const contentEditableRef = useRef(null);
  const descriptionRef = useRef(null);
  const parentContainerRef = useRef(null);

  const configureAIVoiceProps = useMemo(
    () => ({
      entityType: "PORTFOLIO",
      promptSetEntityType: "PORTFOLIO",
      size: "small",
      showLanguageDropdown: false,
    }),
    []
  );

  const isNewGoalTaggingEnabled = getIsNewGoalTaggingEnabled();
  useEffect(() => {
    if (
      parentType === "post" &&
      mode === "edit" &&
      _.get(postServerObject, "state") === "SCHEDULED" &&
      userType === "staff"
    ) {
      setScheduleDateTimeDetails({
        date: moment(_.get(postServerObject, "publishedAt")),
        time: moment(_.get(postServerObject, "publishedAt")),
      });
    }
    parentType !== "post" &&
      mode === "create" &&
      (isProjectPost ? true : _.isUndefined(attachments)) &&
      updatePost({ attachments: [] });

    !isProjectPost && disableGlobalHeader();

    if (_.size(attachments) > maxAttachmentCount && !isProjectPost) {
      !isPortfolioAIEnabledAndIsJournalRoute(userType) &&
        toggleAlert({
          alertMessage: t("journal:max_attachment_limit_reached"),
          params: {
            key: "size",
            value: maxAttachmentCount,
          },
        });
      updatePost({ attachments: _.slice(attachments, 0, maxAttachmentCount) });
    }

    return () => {
      !isProjectPost &&
        (_.isEqual(parentType, "post") ||
          _.isEqual(parentType, "STUDENT_GOAL") ||
          _.isEqual(parentType, "STUDENT_GOAL_TASK")) &&
        isGlobalHeaderOnMultipleScreensEnabled() &&
        enableGlobalHeader();
    };
  }, []);

  useEffect(() => {
    if (
      selectedStudentIdsFromFilter &&
      !isProjectPost &&
      parentType === "post" &&
      isPortfolioParityEnabledAndIsJournalRoute() &&
      isCurrentAcademicYearSelected &&
      mode === "create"
    ) {
      updatePost({
        isPrivate: false,
        isHiddenFromStudents: false,
        students: {
          edges: studentEdges,
        },
      });
    }
  }, [studentEdges]);

  useEffect(() => {
    if (
      (!isGlobalHeaderVisiblePrevRef?.current || isGlobalHeaderVisible) &&
      isGlobalHeaderOnMultipleScreensEnabled()
    ) {
      disableGlobalHeader();
    }
  }, [isGlobalHeaderVisible]);

  useEffect(() => {
    updatePost({ academicTerm: { id: currentActiveTerm?.key } });
  }, [currentActiveTerm]);

  useEffect(() => {
    isPortfolioAIEnabledAndIsJournalRoute(userType) &&
      textInputRef?.domElm?.focus();
  }, [textInputRef]);

  useEffect(() => {
    if (parentType == "post") {
      if (userType == "student") {
        updatePost({
          isPrivate: false,
          isHiddenFromStudents: false,
          students: {
            edges: [
              {
                node: getUserBasicDetailsFromCache({
                  id: _.get(user, "id"),
                  type: _.get(user, "userEntityType"),
                }),
                __typename: "StudentsEdge",
              },
            ],
          },
        });
      } else {
        if (isAddLEToJournal) {
          const studentToTag = _.get(students, "0.node", {});
          if (
            !_.isEmpty(studentToTag) &&
            !(isPrivate || isHiddenFromStudents)
          ) {
            updatePost({
              isPrivate: false,
              isHiddenFromStudents: false,
              students: {
                edges: students,
              },
            });
          }
        } else {
          if (
            mode == "create" &&
            !_.isEmpty(
              _.get(
                selectedStudentFromFeedFilter,
                "node",
                _.get(students, "0.node", {})
              )
            )
          ) {
            updatePost({
              isPrivate: false,
              isHiddenFromStudents: false,
              students: {
                edges: [
                  {
                    node: _.get(
                      selectedStudentFromFeedFilter,
                      "node",
                      _.get(students, "0.node", {})
                    ),
                  }, // students.0.node is used when single attachment is added to journal by class stream
                ],
              },
            });
          }
        }
      }
    }
  }, [selectedStudentFromFeedFilter, userType]);

  const assesmentData = _.find(
    items,
    item => _.get(item, "itemType", "") === "STUDENT_ASSIGNMENT"
  );
  const assessmentItem = _.get(assesmentData, "item", BLANK_OBJECT);
  const studentData = _.get(assessmentItem, "student", BLANK_OBJECT);
  const isStudentOwnResponse =
    _.get(studentData, "id", "") === _.get(user, "id");

  const StudentResponseData = {
    ...assessmentItem,
    toolResponses,
    ibPYPElementRatings,
  };

  const showTagStudentOption =
    (showTagStudent &&
      userType == "staff" &&
      (isAddLEToJournal == false || isPortfolioParityEnabled()) &&
      isAddAllResponsesToJournal == false) ||
    isPortfolioParityEnabled() ||
    (showTagStudent && isProjectPost);

  const [currentStepDetails, setCurrentStepDetails] = useState({
    currentStep: "",
    showTagModal: false,
    currentElementTag: null, // for project evidence creation
    currentStepIndex: undefined,
  });

  const [description, setDescription] = useState(title);
  const validateDescription = e => {
    const input = _.get(e, "target.value", "");
    setDescription(input);
  };

  const isPortfolioAI =
    isPortfolioAIEnabledAndIsJournalRoute(userType) ||
    (isPortfolioAIEnabled() && isPortfolioReviewSetupEnabledAndIsReviewRoute());

  const saveDescription = () => {
    updatePost({
      title:
        descriptionRef?.current ||
        description ||
        (isPortfolioAI ? textInputRef?.domElm?.textContent : ""),
    });
  };

  const onAttachmentAdded = newAttachments => {
    if (
      _.size(attachments) >= maxAttachmentCount &&
      isPortfolioParityEnabled() &&
      !isProjectPost
    ) {
      return;
    }
    if (_.size(newAttachments, 0) > 0) {
      flushSync(() => {
        updatePost({ attachments: [...attachments, ...newAttachments] });
      });
    }
  };

  const onMultipleAttachmentsAdded = async newAttachments => {
    if (_.size(attachments) + _.size(newAttachments) - 1 > maxAttachmentCount) {
      toggleAlert({
        alertMessage: t("journal:max_attachment_limit_reached"),
        params: {
          key: "size",
          value: maxAttachmentCount,
        },
      });

      return;
    }
  };

  const goToStep = (step, index) => {
    if (!_.isEmpty(step))
      setCurrentStepDetails({
        currentStep: step,
        showTagModal: true,
        currentStepIndex: index,
      });
  };

  const onCloseTagModal = () => {
    setCurrentStepDetails({
      currentStep: "",
      showTagModal: false,
      currentElementTag: null,
    });
  };

  const deleteAttachment = attachmentToRemove => {
    if (_.has(attachmentToRemove, "id")) {
      // attachment is being removed during the edit post
      //deleteAttachments([attachmentToRemove]);
      updatePost({
        attachments: _.filter(
          attachments,
          attachment => !_.isEqual(attachment, attachmentToRemove)
        ),
      });
    } else {
      // attachment is being removed during post creation
      updatePost({
        attachments: _.filter(
          attachments,
          attachment => !_.isEqual(attachment, attachmentToRemove)
        ),
      });
    }
    isPortfolioParityEnabled() &&
      props?.setToastMsg({
        msg: "journal:media_delete_message",
        type: "success",
        locale_params: [
          {
            key: "mediaName",
            value: _.get(attachmentToRemove, "name"),
            isPlainText: true,
          },
        ],
      });
  };

  const setDescriptionValue = (value, callback) => {
    setDescription(cleanupMessage({ message: value }));
    descriptionRef.current = cleanupMessage({ message: value });
    setTimeout(() => {
      callback && callback();
    });
  };

  const handleSelect = e => {
    if (
      isPortfolioAIEnabledAndIsJournalRoute(userType) &&
      e.target === textInputRef?.domElm
    ) {
      aiInputRef?.current?.handleTextSelection(e);
    }
  };

  const updatedTags = useMemo(() => {
    let updatedTagsArray = [];
    if (!_.isNil(attachedTags) && !_.isNil(addedTags)) {
      updatedTagsArray = [...attachedTags, ...addedTags];
      if (!_.isNil(removedTags) && _.size(removedTags, 0) > 0) {
        updatedTagsArray = _.filter(updatedTagsArray, tag =>
          _.isUndefined(
            _.find(removedTags, removedTag => removedTag?.id == tag?.id)
          )
        );
      }
    }
    return updatedTagsArray;
  }, [attachedTags, addedTags, removedTags]);

  const unionCourseUpdateTags = useMemo(() => {
    return _.unionBy(courseTags, updatedTags, tag => tag?.name);
  }, [courseTags, updatedTags]);
  const onConfirmDateChange = ({ date, time }) => {
    const { screenPanelProps = {} } = props;
    const { onPublishClick, updatePost } = screenPanelProps;
    if (
      !_.isNil(date) &&
      !_.isEmpty(date) &&
      !_.isNil(time) &&
      !_.isEmpty(time)
    ) {
      setScheduleDateTimeDetails({ date, time });
      updatePost({
        publishedAt: moment(
          date.format("YYYY-MM-DD") + " " + time.format("HH:mm")
        ),
      });
      setShowPostScheduleModal(false);
    }
  };

  const onClosePostScheduleModal = () => {
    setShowPostScheduleModal(false);
  };

  const dropdownOptions = isProjectPost
    ? PROJECTS_JOURNALS_AND_INTERVIEWS_UPLOAD_OPTIONS
    : DROP_DOWN_OPTIONS;

  const updateDesciptionDebounce = _.debounce(saveDescription, 1000);

  const updateDescription = params => {
    let updatedTitle = _.get(params, "title", "");
    if (isPortfolioAIEnabledAndIsJournalRoute(userType)) {
      updatedTitle = cleanupMessage({
        message: _.get(params, "title", ""),
      });
    }
    setDescription(updatedTitle);
    descriptionRef.current = updatedTitle;
    updateDesciptionDebounce();
  };

  const getTextAreaTitle = () => {
    return descriptionRef?.current || "";
  };

  const syncLocalStateWithRedux = title => {
    if (!_.isNull(description) && !_.isEqual(title, description)) {
      if (updateDesciptionDebounce.cancel) {
        updateDesciptionDebounce.cancel();
      }
      updatePost({ title: description });
    }
  };

  const attachmentsUrlMap = _.map(
    _.filter(attachments, attachment => attachment?.type === "IMAGE"),
    attachment => _.get(attachment, "url", "")
  );

  const getAskAIPromptAction = () => {
    if (description) {
      return ASK_AI_ATTACHMENT_CAPTION_FILLED;
    } else if (_.size(attachments, 0) > 0 && _.size(attachmentsUrlMap, 0) > 0) {
      return ASK_AI_WITHOUT_IMAGE;
    } else {
      return ASK_AI_ATTACHMENT_CAPTION;
    }
  };

  if (
    isPortfolioParityEnabled() &&
    !isProjectPost &&
    !_.find(DROP_DOWN_OPTIONS, { key: "capture_voice" })
  ) {
    DROP_DOWN_OPTIONS.unshift({
      label: "journal:capture_voice",
      key: "capture_voice",
    });
  }

  if (
    isPortfolioParityEnabled() &&
    !isProjectPost &&
    !_.find(DROP_DOWN_OPTIONS, { key: "capture_media" })
  ) {
    DROP_DOWN_OPTIONS.unshift({
      label: "journal:capture_media",
      key: "capture_media",
    });
  }
  const getPostCreatorName = _.memoize(createdBy => {
    return {
      ...createdBy,
      firstName: _.get(
        createdBy,
        isPostCreationModeNew ? "first_name" : "firstName",
        ""
      ),
      lastName: _.get(
        createdBy,
        isPostCreationModeNew ? "last_name" : "lastName",
        ""
      ),
      middleName: _.get(
        createdBy,
        isPostCreationModeNew ? "middle_name" : "middleName",
        ""
      ),
      preferredName: _.get(
        createdBy,
        isPostCreationModeNew ? "preferred_name" : "preferredName",
        ""
      ),
    };
  });

  const isEvidencing = isEvidencingEditRoute();

  const showPortfolioParityCard =
    (isPortfolioParityEnabled() &&
      (isJournalRoute ||
        isAddLEToJournal ||
        isAddStudentAttachmentToJournal ||
        isAddAllResponsesToJournal ||
        isShareEvaluation ||
        isEvidencing)) ||
    isPortfolioReviewSetupEnabledAndIsReviewRoute();

  const onCloseGoalsRemovalWarningModal = () =>
    setGoalsRemovalWarningModal(false);

  const getFilteredElements = (
    elementPYP,
    removeStandards,
    removeGoalsOtherGoals
  ) => {
    // Return early if no filtering is needed
    if (!removeStandards && !removeGoalsOtherGoals) {
      return undefined;
    }

    // Filter based on the flag
    if (removeStandards) {
      return _.filter(
        elementPYP,
        item =>
          !getIsSubjectStandard({
            type: _.get(pypElementMapping, item.fieldUID),
          })
      );
    }

    // Must be removeGoalsOtherGoals case
    return _.filter(elementPYP, item =>
      getIsSubjectStandard({ type: _.get(pypElementMapping, item.fieldUID) })
    );
  };
  const resetLearningGoalsData = (removeLeOrAssessment = false) => {
    removeLeOrAssessment &&
      updatePost({
        unitPlan: null,
        postTaggedEntity: null,
        resourceItem: null,
        resourceType: null,
      });

    updatePost({
      // clear main properties of learning goals
      isResourceSkipped: false,
      resourceId: null,
      elementPYP:
        (isStandardsRevampEnabled || showNewStandardsUIInV1) &&
        !isUnitPlanOrAssessmentTagged(postTaggedEntity)
          ? getFilteredElements(
              elementPYP,
              isStandardSelected.current,
              !isStandardSelected.current
            )
          : undefined,
      // postTaggedEntity: undefined,
      // Clear properties used for backup
      originalUnitPlan: null,
      originalIsResourceSkipped: false,
      originalResourceId: null,
      originalResourceType: null,
      originalResourceItem: undefined,
      originalElementPYP: undefined,
      selectFromAllPYP:
        isNewGoalTaggingEnabled &&
        isUnitPlanOrAssessmentTagged(postTaggedEntity)
          ? false
          : undefined,
      // clear ratings as well
      ibPYPElementRatings: [],
      originalibPYPElementRatings: [],
      showTagLearningGoalsModal: false,
    });
  };
  const onConfirmRemovalOfGoals = () => {
    resetLearningGoalsData();
    setGoalsRemovalWarningModal(false);
  };

  const onConfirmRemovalOfLE = () => {
    resetLearningGoalsData();
    setChangeLEWarningModal(false);
    if (isNewGoalTaggingEnabled) {
      isAssessmentTagged(postTaggedEntity)
        ? goToStep("TAG_LEARNING_GOALS_FROM_ASSESSMENTS")
        : goToStep("TAG_LEARNING_GOALS_FROM_UNIT");
    } else {
      !_.isNil(resourceItem)
        ? goToStep("TAG_LEARNING_GOALS_FROM_ASSESSMENTS")
        : goToStep("TAG_LEARNING_GOALS_FROM_UNIT");
    }
  };

  const onConfirmDeletionOfLE = () => {
    resetLearningGoalsData(true);
    setDeleteLEWarningModal(false);
  };

  const onManageFolderModalClose = () => {
    setShowManageFoldersModal(false);
  };
  const attachmentType = _.get(attachments[0], "type", "");
  const reduxNoteTitle = _.get(attachments[0], "title", "");
  const type = _.get(_.first(attachments), "type", "");
  const isNote = type === "NOTE";
  const [noteTitle, setNoteTitle] = useState(
    isNote ? _.get(attachments[0], "title", "") : ""
  );
  const isOnlyAudio = attachmentType === "AUDIO" && _.size(attachments) === 1;
  const isLinkOrWorkbook =
    attachmentType === "LINK" || attachmentType === "WORKBOOK";
  const isWorkbook =
    _.size(
      _.find(attachments, attachment => {
        return _.get(attachment, "type") === "WORKBOOK";
      })
    ) > 0;
  const isNoteType = attachmentType === "NOTE";
  const showAttachmentIcons = _.size(attachments) === 10;
  const updateNote = params => {
    const { screenPanelProps: { updatePost, postDetails } = {} } = props;
    const attachment = _.get(postDetails, "attachments[0]", BLANK_OBJECT);

    updatePost({ attachments: [{ ...attachment, ...params }] });
  };
  const updateNoteTextDebounce = _.debounce(updateNote, 1000);
  const syncLocalStateWithReduxNote = (title, reduxNoteTitle) => {
    if (!_.isNull(noteTitle) && !_.isEqual(noteTitle, reduxNoteTitle)) {
      if (updateNoteTextDebounce.cancel) {
        updateNoteTextDebounce.cancel();
      }
      updateNote({ title: noteTitle });
    }
  };
  const updateNoteTextLocally = params => {
    let updatedTitle = _.get(params, "title", "");
    if (isPortfolioAIEnabledAndIsJournalRoute(userType)) {
      updatedTitle = cleanupMessage({
        message: _.get(params, "title", ""),
      });
    }
    noteDescriptionRef.current = updatedTitle;
    setNoteTitle(updatedTitle);
    updateNoteTextDebounce(params);
  };

  const attachmentMap = useMemo(() => {
    return attachments.map((item, index) => ({
      ...item,
      displaySequence: index + 1,
      id: _.get(item, "id", generateRandomId()),
    }));
  }, [attachments]);

  const [postAttachments, setPostAttachments] = useState(attachmentMap);
  useEffect(() => {
    setPostAttachments(attachmentMap);
  }, [attachments]);
  const nonAudioPostAttachments = getNonAudioAttachments(postAttachments);

  const onEditAttachmentModalDoneClick = () => {
    //Note:Push audio attachments to list seperately
    const audioAttachments = _.filter(
      attachments,
      attachment => attachment.type === "AUDIO"
    );
    const updatedAttachments = _.map(postAttachments, (attachment, index) => {
      return { ...attachment, displaySequence: index + 1 };
    });
    updatePost({ attachments: [...updatedAttachments, ...audioAttachments] });
    setEditAttachmentModal(false);
  };
  const onEditAttachmentModalClose = () => {
    setPostAttachments(attachmentMap);
    setEditAttachmentModal(false);
  };

  const renderAttachment = ({
    toggleMediaModalWithIndex,
    setEditAttachmentModal,
  }) => {
    const toggleEditAttachmentModal = () => {
      setEditAttachmentModal(!showEditAttachmentModal);
    };

    return (
      <div
        className={classes.renderAttachment}
        style={{
          overFlow: _.size(postAttachments) === 2 ? "hidden" : "scroll",
        }}
      >
        <ReorderAttachment
          attachments={postAttachments}
          setAttachments={setPostAttachments}
          toggleMediaModalWithIndex={toggleMediaModalWithIndex}
          toggleEditAttachmentModal={toggleEditAttachmentModal}
          updatePost={updatePost}
          reorderTooltip={t("journal:reorder_tooltip")}
          setToastMsg={props.setToastMsg}
          isLoading={props.isLoading}
        />
      </div>
    );
  };

  const onDeleteMedia = activeIndex => {
    const attachmentName = _.get(_.get(postAttachments, activeIndex), "name");
    if (activeIndex + 1 === _.size(postAttachments)) {
      setCurrentAttachmentIndex(activeIndex - 1);
    } else if (activeIndex + 1 <= _.size(postAttachments)) {
      setCurrentAttachmentIndex(activeIndex + 1);
    }
    _.pullAt(postAttachments, activeIndex);
    if (!_.size(postAttachments)) {
      toggleMediaModal(false);
    }

    props?.setToastMsg({
      msg: "journal:media_delete_message",
      type: "success",
      locale_params: [
        {
          key: "mediaName",
          value: attachmentName,
          isPlainText: true,
        },
      ],
    });
    const updatedAttachments = _.map(postAttachments, (attachment, index) => ({
      ...attachment,
      displaySequence: index + 1,
    }));
    setPostAttachments(updatedAttachments);
    updatePost({ attachments: updatedAttachments });
  };

  const isPostCreationModeNew = !_.size(_.keys(createdBy)) > 0;
  const currentUser = isPostCreationModeNew ? user : createdBy;

  const prevCourseUnitPlansRef = useRef();
  const prevCurrentActiveTermRef = useRef();

  useEffect(() => {
    const updateCourseUnitPlans = () => {
      if (
        courseUnitPlans &&
        courseUnitPlans.length > 0 &&
        _.size(_.differenceBy(courseUnitPlans, prevCourseUnitPlansRef, "id"), 0)
      ) {
        updatePost({ courseUnitPlans });
      }
    };
    const updateAcademicTerm = () => {
      const prevActiveTermKey = prevCurrentActiveTermRef?.current?.key;
      const currentActiveTermKey = currentActiveTerm?.key;

      if (prevActiveTermKey !== currentActiveTermKey) {
        updatePost({ academicTerm: { id: currentActiveTermKey } });
      }
    };

    updateCourseUnitPlans();
    updateAcademicTerm();
    prevCourseUnitPlansRef.current = courseUnitPlans;
    prevCurrentActiveTermRef.current = currentActiveTerm;
  }, [courseUnitPlans, currentActiveTerm]);

  useEffect(() => {
    const { removeProgressElement } = props;
    if (!showMediaModal && !_.isEmpty(progressOfUploads)) {
      removeProgressElement({ id: _.keys(progressOfUploads)[0] });
    }
  }, [showMediaModal]);

  const audioFileDownload = attachment => {
    const { downloadFromUrl, removeProgressElement } = props;
    let name = _.get(attachment, "name", "");
    if (_.isEmpty(name)) {
      name = "toddle_audio_" + moment().format("DD-MM-YY_h_mm");
    }

    const id = "Toddle_audio_#123";

    downloadFromUrl({
      name: name,
      attachment: attachment,
      shouldAskForSave: true,
      fileUploadId: id,
    }).then(() => {
      removeProgressElement({ id });
    });
  };
  const showPromptDetail =
    currentDialogAction == "REJECT_POST" ||
    currentDialogAction == "APPROVE_WITH_COMMENT";

  const TagStudentButton = () => {
    const isDisabled = !isCurrentAcademicYearSelected || isArchivedClass;
    const tagStudentButtonClass = classnames(classes.tagStudentButton, {
      disabled: isDisabled,
    });

    const handleKeyDown = e => {
      onEnterOrSpaceKeyDown(e, () => {
        if (!isDisabled) {
          goToStep("TAG_STUDENT");
        }
      });
    };
    return (
      <div
        onClick={() => {
          if (!isDisabled) {
            goToStep("TAG_STUDENT");
          }
        }}
        className={classes.tagStudentButtonContainer}
        data-test-id="journal-postcreation-tagstudent-button"
        tabIndex={isDisabled ? -1 : 0}
        role="button"
        aria-disabled={isDisabled}
        onKeyDown={handleKeyDown}
      >
        <span className={tagStudentButtonClass}>
          <StudentAddOutlined size={"x-small"} disabled={isDisabled} />
        </span>
        <span className={classes.containerText}>
          {t("journal:tag_students")}
        </span>
      </div>
    );
  };

  const TaggedStudentDetails = ({ students }) => {
    const formatStudent = student => {
      return {
        id: _.get(student, "id"),
        value: getFormattedUserName({
          user: student,
        }),
        imageUrl: _.get(student, "profileImage", null),
      };
    };
    const user1 = formatStudent(_.get(_.first(students), "node"));
    let studentTooltip = "";
    _.map(students, student => {
      studentTooltip += `${getFormattedUserName({
        user: _.get(student, "node"),
      })} <br/>`;
    });

    const linkProps = {
      target: "__blank",
      rel: "noopener noreferrer",
      tabindex: "0",
      className: classes.tagStudentTooltip,
    };

    return (
      <div className={classes.taggedStudentContainer}>
        <DualProfile
          user1={formatStudent(_.get(_.first(students), "node"))}
          user2={
            _.size(students) > 1
              ? formatStudent(students[1]?.node)
              : BLANK_OBJECT
          }
          showNewDesign={true}
          cascadeProfileStyle={{ marginTop: "-40px" }}
        />
        {_.size(students) > 1 ? (
          <div
            className={classes.studentNameContainer}
            data-test-id="journal-postcreation-taggedstudentdetails"
          >
            <Trans
              i18nKey={
                _.size(students) > 2
                  ? "journal:tagged_student_and_other_plural"
                  : "journal:tagged_student_and_other"
              }
            >
              <b className={classes.studentNameContainer}>
                {{ student: _.get(user1, "value") }}
              </b>
              <LinkWithTooltip
                tooltip={studentTooltip}
                linkStyles={style.studentToolTipContainer}
                placement={"bottom"}
                linkProps={linkProps}
                trigger={TRIGGER_EVENT_TYPES}
              >
                {{ othersCount: _.size(students) - 1 }}
              </LinkWithTooltip>
            </Trans>
          </div>
        ) : (
          <div
            className={classes.studentNameContainer}
            data-test-id="journal-postcreation-taggedstudentdetails"
          >
            {_.get(user1, "value")}
          </div>
        )}
      </div>
    );
  };

  const noteDescriptionRef = useRef(null);
  const setTextAreaTitle = async (value, callback) => {
    setNoteTitle(cleanupMessage({ message: value }));
    noteDescriptionRef.current = cleanupMessage({ message: value });
    callback && callback();
  };

  const updateDropDownStateWithPermission = mediaStateOptions => {
    const mediaOptions = [];

    // Filter out google_photos if not enabled
    const filteredMediaStateOptions = _.filter(mediaStateOptions, option => {
      if (option.key === "add_google_photos") {
        return enableGooglePhotosPicker();
      }
      return true;
    });

    if (_.isEqual(portfolioType, "senior")) {
      return _.map(filteredMediaStateOptions, media => {
        const { perm, ...updatedMediaObject } = media;
        return updatedMediaObject;
      });
    }
    _.forEach(filteredMediaStateOptions, media => {
      const { perm, ...updatedMediaObject } = media;
      if (perm && !_.isEqual(perm, "MEDIA")) {
        if (_.includes(postPermissionMediaOptions, perm)) {
          mediaOptions.push(updatedMediaObject);
        }
      } else if (
        _.isEqual(perm, "MEDIA") &&
        (_.includes(postPermissionMediaOptions, "PHOTO") ||
          _.includes(postPermissionMediaOptions, "VIDEO"))
      ) {
        mediaOptions.push(updatedMediaObject);
      }
    });
    return mediaOptions;
  };
  const getDropDownOptionsWithState = () => {
    const maxAttachmentLabal = t(
      "journal:max_attachment_limit_warning_permission",
      { size: maxAttachmentCount }
    );
    if (isWorkbook) {
      if (_.size(fetchAudioAttachment()) === 1) {
        return WORKBOOK_DROPDOWNOPTIONS_DISABLED;
      } else return WORKBOOK_DROPDOWNOPTIONS;
    } else if (_.size(attachments) >= maxAttachmentCount) {
      return updateDropDownStateWithPermission(
        DROP_DOWN_OPTIONSV2_DISABLED(maxAttachmentLabal)
      );
    } else if (_.size(fetchAudioAttachment()) === 1) {
      return updateDropDownStateWithPermission(
        DROP_DOWN_OPTIONS_AUDIO_DISABLED
      );
    }
    return updateDropDownStateWithPermission(DROP_DOWN_OPTIONSV2);
  };

  const showCaptionTextArea =
    (attachmentType != "NOTE" &&
      _.get(mediaCreationOptions, "enableCaption")) ||
    isAddLEToJournal;

  const getTitleValue = title => {
    return !(_.isEqual(title, "null") || _.isEqual(title, "undefined"))
      ? title
      : "";
  };

  const formatAttachments = () => {
    const updatedAttachments = _.map(attachments, attachment => {
      if (_.includes(_.get(attachment, "id"), "NEW_")) {
        return _.omit(attachment, ["id", "signedUrl"]);
      } else {
        return attachment;
      }
    });
    updatePost({ attachments: updatedAttachments });
  };

  const isGlobalHeaderEnabled = isGlobalHeaderOnMultipleScreensEnabled();

  const handleShortcuts = pressedKeys => {
    const { code, shiftKey } = _.first(pressedKeys);
    switch (code) {
      case "Enter": {
        if (shiftKey) {
          onPublishClick?.();
          return true;
        }
        return false;
      }
      default: {
        return false;
      }
    }
  };

  const showAiMarketingIcon =
    !isPortfolioAIEnabled() &&
    !isProjectPost &&
    isAIModuleMarketingEnabled(AI_MODULES_FOR_MARKETING.PORTFOLIO);

  const onAIMarketingClick = () => {
    setAiModuleMarketingKey(AI_MODULES_FOR_MARKETING.PORTFOLIO);
  };

  const { areShortcutsEnabled } = useKeyboardShortcutsContext();

  const onElementDeleteClick = () => {
    getIsStandardsRevampEnabled()
      ? _.size(postRatingsOfLearningGoals)
        ? setGoalsRemovalWarningModal(true)
        : onConfirmRemovalOfGoals()
      : setGoalsRemovalWarningModal(true);
  };

  return (
    <KeyboardShortcuts
      handleShortcuts={handleShortcuts}
      areShortcutsEnabled={areShortcutsEnabled}
    >
      <ScreenPanel
        {...screenPanelProps}
        containerStyle={style.screenPanelContainerStyle}
        footerContainerStyle={
          isPortfolioParityEnabled() ? style.footerContainerStyle : BLANK_OBJECT
        }
        showNewHeaderDesign={isPortfolioParityEnabled()}
        titleTextContainerStyle={
          isPortfolioParityEnabled()
            ? style.titleTextContainerStyle
            : BLANK_OBJECT
        }
        scrollContainerStyle={style.scrollContainerStyle}
        footerComponent={
          <FooterComponent
            t={t}
            {...mediaCreationOptions}
            onMediaCreate={onMediaCreate}
            onClickSave={onClickSave}
            onPublishClick={onPublishClick}
            onDraftClick={onDraftClick}
            isAddAllResponsesToJournal={isAddAllResponsesToJournal}
            onAddAllResponsesToJournal={onAddAllResponsesToJournal}
            state={state}
            mode={mode}
            userType={userType}
            onSendForApprovalClick={onSendForApprovalClick}
            isApprovalRequiredForStudentPosts={
              isApprovalRequiredForStudentPosts
            }
            onCloseClick={onCloseClick}
            postDetails={screenPanelProps?.postDetails}
            postDescription={description}
            isStudentTagOptional={isStudentTagOptional}
            isUploadingInProgress={isUploadingInProgress}
            togglePostScheduleModal={value => setShowPostScheduleModal(value)}
            setScheduleDateTimeDetails={details =>
              setScheduleDateTimeDetails(details)
            }
            canScheduleAPost={canScheduleAPost}
            publishedAt={publishedAt}
            createdAt={createdAt}
            scheduleDateTimeDetails={scheduleDateTimeDetails}
            updatePost={updatePost}
            postServerObject={postServerObject}
            parentType={parentType}
            taggedCollections={taggedCollections}
            setToastMsg={props.setToastMsg}
            showPortfolioParityCard={showPortfolioParityCard}
            assesmentData={assesmentData}
            isArchivedClass={isArchivedClass}
            onPostActionClick={onPostActionClick}
            postId={id}
            createdBy={createdBy}
            noteTitle={noteTitle}
            isNote={isNote}
            isProjectPost={isProjectPost}
          />
        }
        parentContainerRef={parentContainerRef}
        headerRightComponent={
          <HeaderRightComponent
            t={t}
            {...mediaCreationOptions}
            onMediaCreate={onMediaCreate}
            onClickSave={onClickSave}
            onPublishClick={onPublishClick}
            onDraftClick={onDraftClick}
            isAddAllResponsesToJournal={isAddAllResponsesToJournal}
            onAddAllResponsesToJournal={onAddAllResponsesToJournal}
            state={state}
            mode={mode}
            userType={userType}
            onSendForApprovalClick={onSendForApprovalClick}
            isApprovalRequiredForStudentPosts={
              isApprovalRequiredForStudentPosts
            }
            onCloseClick={onCloseClick}
            postDetails={screenPanelProps?.postDetails}
            postDescription={description}
            isStudentTagOptional={
              isStudentTagOptional || showTagStudentOption == false
            }
            isUploadingInProgress={isUploadingInProgress}
            togglePostScheduleModal={value => setShowPostScheduleModal(value)}
            setScheduleDateTimeDetails={details =>
              setScheduleDateTimeDetails(details)
            }
            canScheduleAPost={canScheduleAPost}
            publishedAt={publishedAt}
            createdAt={createdAt}
            scheduleDateTimeDetails={scheduleDateTimeDetails}
            updatePost={updatePost}
            postServerObject={postServerObject}
            parentType={parentType}
            taggedCollections={taggedCollections}
            setToastMsg={props.setToastMsg}
            showPortfolioParityCard={showPortfolioParityCard}
            assesmentData={assesmentData}
            isArchivedClass={isArchivedClass}
            onPostActionClick={onPostActionClick}
            postId={id}
            createdBy={createdBy}
            noteTitle={noteTitle}
            isNote={isNote}
            isProjectPost={isProjectPost}
            toggleAlert={toggleAlert}
            isUserAllowedToPublishPost={isUserAllowedToPublishPost}
            isPostCtaDisabled={isPostCtaDisabled}
            maxAttachmentCount={maxAttachmentCount}
            formatAttachments={formatAttachments}
            isGlobalHeaderEnabled={isGlobalHeaderEnabled}
            userId={userId}
          />
        }
        showFooter={!isPortfolioParityEnabled()}
      >
        {showPostScheduleModal == true ? (
          <SchedulePostModal
            onClosePostScheduleModal={onClosePostScheduleModal}
            editDateDetails={scheduleDateTimeDetails}
            onConfirmDateChange={onConfirmDateChange}
            canBackdate={_.includes(
              [
                "PUBLISHED",
                "DRAFT",
                ...(isPortfolioReviewSetupEnabledAndIsReviewRoute()
                  ? ["IN_APPROVAL"]
                  : []),
              ],
              state
            )}
            t={t}
          />
        ) : null}
        {currentStepDetails.showTagModal &&
          (parentType == "projects" ? (
            <ProjectCreatePost
              mode={mode}
              updatePost={updatePost}
              postDetails={_.get(screenPanelProps, "postDetails", BLANK_OBJECT)}
              currentStep={currentStepDetails?.currentStep}
              onClickSave={onPublishClick}
              onClickClose={onCloseTagModal}
              currentElementTag={currentStepDetails?.currentElementTag}
              mediaCreationOptions={mediaCreationOptions}
              isFullScreen={
                _.isNil(currentStepDetails?.currentElementTag)
                  ? false
                  : _.get(
                      PROJECT_TEMPLATE_FIELD_OBJECTS[
                        currentStepDetails.currentElementTag
                      ],
                      "isFullScreen",
                      false
                    )
              }
            />
          ) : (
            <CreatePost
              currentStep={currentStepDetails.currentStep}
              isInnerModal={true}
              onClose={onCloseTagModal}
              currentStepIndex={currentStepDetails.currentStepIndex}
              onDoneClick={onCloseTagModal}
              showNewDesignV2={isPortfolioParityEnabled()}
            />
          ))}
        <div
          className={classes.container}
          style={{ overflowX: isPortfolioParityEnabled() ? "hidden" : "" }}
        >
          {showAlert && (
            <div className={classes.alertContainer}>
              <Alert
                type={"warning"}
                isClosable={true}
                title={alertMessage}
                onClose={toggleAlert}
                style={{
                  boxShadow: ` 1px 1px 4px 0px rgba(0, 46, 57, 0.15)`,
                }}
              />
            </div>
          )}
          {/* Post description and attachments */}
          <div
            className={
              isPortfolioParityEnabled() ? classes.cardV2 : classes.card
            }
            style={
              (!showPostTags || !showTagFolder) && isPortfolioParityEnabled()
                ? { paddingBottom: "20px" }
                : {}
            }
          >
            <div className={classes.attachmentCardContainer}>
              {(isPortfolioParityEnabled() ? !isJuniorFolio : true) ? (
                <div className={classes.userProfileContainer}>
                  <DSProvider dsVersion="2.0">
                    <SingleUserProfile
                      username={
                        isProjectPost
                          ? getFormattedUserName({
                              user: getPostCreatorName(currentUser),
                              type: _.get(
                                currentUser,
                                isPostCreationModeNew ? "user_type" : "type",
                                "type"
                              ),
                            })
                          : getFormattedUserNameWithoutPronoun({
                              user: getPostCreatorName(currentUser),
                              type: _.get(
                                currentUser,
                                isPostCreationModeNew ? "user_type" : "type",
                                "type"
                              ),
                            })
                      }
                      id={_.get(currentUser, "id", "")}
                      profileImageSrc={_.get(
                        currentUser,
                        isPostCreationModeNew
                          ? "profile_image"
                          : "profileImage",
                        ""
                      )}
                      usernameStyle={style.usernameStyle}
                      customUserText={
                        parentType === "learnerPortfolio" ? (
                          <p className={classes.taggedAssesmentMessageText}>
                            {userType === "staff" ? (
                              <Trans i18nKey={"journal:teacher_tagged_student"}>
                                <b
                                  className={
                                    classes.taggedCreatedByTopContainer
                                  }
                                >
                                  {{
                                    teacherName: `${_.get(
                                      user,
                                      "first_name",
                                      ""
                                    )} ${_.get(user, "last_name", "")}`,
                                  }}
                                </b>
                                <b
                                  className={
                                    classes.taggedCreatedByTopContainer
                                  }
                                >
                                  {{
                                    studentName: `${_.get(
                                      students,
                                      "[0].node.firstName",
                                      ""
                                    )} ${_.get(
                                      students,
                                      "[0].node.lastName",
                                      ""
                                    )}`,
                                  }}
                                </b>
                              </Trans>
                            ) : (
                              <b
                                className={classes.taggedCreatedByTopContainer}
                              >
                                {`${_.get(user, "first_name", "")} ${_.get(
                                  user,
                                  "last_name",
                                  ""
                                )}`}
                              </b>
                            )}
                          </p>
                        ) : null
                      }
                    />
                  </DSProvider>
                </div>
              ) : _.get(mediaCreationOptions, "enableTagging") &&
                !isAddAllResponsesToJournal ? (
                <div
                  className={classes.tagListContainer}
                  style={{
                    paddingTop: !_.size(students) ? "32px" : "28px",
                    paddingBottom: _.size(students) ? "28px" : "",
                  }}
                >
                  {!_.size(students) ? (
                    <TagStudentButton studentSelectionMode={"MULTIPLE"} t={t} />
                  ) : (
                    <TaggedStudentDetails students={students} />
                  )}
                  {_.size(students) ? (
                    <div className={classes.editStudentIcon}>
                      <IconButton
                        dsVersion="2.0"
                        type="plain"
                        size="medium"
                        shouldStopPropagation={true}
                        icon={<PencilLineOutlined />}
                        onClick={() => {
                          isStudentTaggingAllowed && goToStep("TAG_STUDENT");
                        }}
                        disabled={!isStudentTaggingAllowed}
                        testId="journal-postcreation-edittaggedstudents"
                      />
                    </div>
                  ) : null}
                </div>
              ) : null}

              {showCaptionTextArea || isProjectPost ? (
                <div
                  className={classes.descriptionArea}
                  onSelect={handleSelect}
                  style={{
                    marginBottom:
                      isPortfolioParityEnabled() &&
                      (_.size(attachments) > 1 || isOnlyAudio)
                        ? "12px"
                        : "",
                  }}
                >
                  {!isPortfolioAI ||
                  isAddLEToJournal ||
                  isAddAllResponsesToJournal ? (
                    <TextAreaInput
                      dsVersion="2.0"
                      placeholder={
                        isAddAllResponsesToJournal
                          ? t(
                              "journal:write_common_caption_anectode_for_all_responses"
                            )
                          : t("journal:type_your_description_here")
                      }
                      value={getTitleValue(description)}
                      onBlur={saveDescription}
                      onChange={validateDescription}
                      minRows={
                        isPortfolioParityEnabled() && !_.size(attachments)
                          ? 5
                          : 2
                      }
                      className={classes.descriptionInput}
                      testId="journal-postcreation-description"
                    />
                  ) : null}
                  {isPortfolioAI &&
                  !(isAddLEToJournal || isAddAllResponsesToJournal) ? (
                    <UIBaseContentEditable
                      value={getTitleValue(description)}
                      ref={ref => setTextInputRef(ref)}
                      style={{
                        ...style.textArea,
                        ...(isPortfolioParityEnabled() && !_.size(attachments)
                          ? { minHeight: "84px" }
                          : {}),
                      }}
                      mode={"edit"}
                      placeholder={
                        isTablet
                          ? t("journal:type_to_add_description")
                          : t("journal:placeholder_for_ai_caption")
                      }
                      onFocusInputField={() => {
                        textInputRef?.focus();
                        setFocusRef(true);
                      }}
                      onBlurInputField={() => {
                        syncLocalStateWithRedux(title);
                        setTimeout(() => {
                          setFocusRef(false);
                        }, 500);
                      }}
                      updateInputField={updateDescription}
                      updateInputRef={ref => (contentEditableRef.current = ref)}
                      id="text-area-input"
                      name={"title"}
                      shouldParseInPlainText={false}
                      onKeyDown={event => {
                        if (
                          (event.metaKey || event.ctrlKey) &&
                          event.key === "j"
                        ) {
                          event.preventDefault();
                          setShowPromptBoxOverOptions(true);
                          setShowPromptBox(true);
                          aiInputRef?.current?.setDisplayOptionsDefault();
                        }
                      }}
                      shouldPasteAsPlainText={true}
                      styleStripType={"CONTENT_EDITABLE"}
                      editContainerStyle={{
                        height: "fit-content",
                        minHeight: "24px",
                      }}
                      containerStyle={{
                        height: "fit-content",
                        minHeight: "24px",
                      }}
                    />
                  ) : null}
                </div>
              ) : null}

              {attachmentType == "NOTE" && !isAddLEToJournal ? (
                <div className={classes.noteContainer}>
                  {!isPortfolioAI ? (
                    <Note
                      value={noteTitle}
                      updateNote={updateNoteTextLocally}
                      placeholder={t("common:text_placeholder")}
                      noteName={"title"}
                      noteTextAreaStyles={style.noteTextAreaStyles}
                      onBlur={() => {
                        syncLocalStateWithReduxNote(title, reduxNoteTitle);
                      }}
                      linesContainerStyles={style.noteLinesContainerStyles}
                      testId="journal-postcreation-note"
                      showAIIcon={showAiMarketingIcon}
                      onAIIconClick={
                        showAiMarketingIcon ? onAIMarketingClick : _.noop
                      }
                    />
                  ) : (
                    <NoteV2
                      value={noteTitle}
                      updateNote={updateNoteTextLocally}
                      placeholder={
                        isTablet
                          ? t("journal:type_to_add_description")
                          : isWindows()
                          ? t("journal:placeholder_for_ai_caption_note_windows")
                          : t("journal:placeholder_for_ai_caption_note")
                      }
                      noteName={"title"}
                      noteTextAreaStyles={style.noteTextAreaStyles}
                      onBlur={() => {
                        syncLocalStateWithReduxNote(title, reduxNoteTitle);
                      }}
                      contentEditableRef={contentEditableRef}
                      textInputRef={textInputRef}
                      showPromptBox={showPromptBox}
                      setShowPromptBox={setShowPromptBox}
                      showPromptBoxOverOptions={showPromptBoxOverOptions}
                      setShowPromptBoxOverOptions={setShowPromptBoxOverOptions}
                      getTextAreaTitle={() => {
                        return noteDescriptionRef.current;
                      }}
                      setTextAreaTitle={setTextAreaTitle}
                      setTextInputRef={setTextInputRef}
                      parentContainerRef={parentContainerRef}
                      isAIResponseGenerating={isAIResponseGenerating}
                      testId="journal-postcreation-note"
                      configureAIVoiceProps={configureAIVoiceProps}
                    />
                  )}
                </div>
              ) : null}

              {isPortfolioParityEnabled()
                ? _.map(fetchAudioAttachment(), (attachment, index) => (
                    <div
                      className={classes.audioCard}
                      style={{
                        marginTop:
                          index !== 0
                            ? "8px"
                            : _.isEqual(
                                parentType,
                                "STUDENT_ASSIGNMENT_SUBMISSION"
                              )
                            ? "32px"
                            : "",
                        ...style.audioCardStyle(isJuniorFolio),
                        marginBottom: isOnlyAudio
                          ? isPortfolioAI
                            ? "16px"
                            : "32px"
                          : "",
                      }}
                    >
                      <AudioWaveformPlayer
                        attachment={attachment}
                        audioLoaded={_.noop}
                      />
                      <span
                        style={{
                          alignSelf: "center",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <IconButton
                          dsVersion="2.0"
                          icon={<DeleteOutlined />}
                          variant="neutral"
                          type="plain"
                          size="small"
                          onClick={() => {
                            deleteAttachment(attachment);
                          }}
                        />
                        <IconButton
                          dsVersion="2.0"
                          icon={<DownloadOutlined />}
                          variant="neutral"
                          type="plain"
                          size="small"
                          onClick={() => {
                            audioFileDownload(attachment);
                          }}
                        />
                      </span>
                    </div>
                  ))
                : null}
              {!isAddLEToJournal && !isAddAllResponsesToJournal && !isNote ? (
                (
                  isPortfolioParityEnabled()
                    ? _.size(attachments) - _.size(fetchAudioAttachment()) === 1
                    : true
                ) ? (
                  // Used willChange for safari overflow & flickering issue
                  <div
                    className={classes.attachmentsListContainer}
                    style={
                      isSafari()
                        ? {
                            willChange: "transform",
                            display: isJuniorFolio && isOnlyAudio ? "none" : "",
                          }
                        : {
                            display: isJuniorFolio && isOnlyAudio ? "none" : "",
                          }
                    }
                  >
                    <MultipleAttachmentsSlider
                      attachments={
                        showPortfolioParityCard
                          ? nonAudioAttachments
                          : attachments
                      }
                      mode={"edit"}
                      showDeleteIcon={
                        isPortfolioParityEnabled()
                          ? _.get(mediaCreationOptions, "enableTagging") ||
                            isProjectPost
                          : true
                      }
                      deleteAttachment={deleteAttachment}
                      slidesToShow={3}
                      slidesToScroll={3}
                      shouldClickOnMedia={true}
                      showAttachmentAsMediaCard={false}
                      showTheatreViewByParent={showAttachmentPreview}
                      setShowTheatreViewInParent={setShowAttachmentPreview}
                      showAttachmentsUsingScrollableCarousel={isPortfolioParityEnabled()}
                      attachmentCardStyle={{
                        ...(isPortfolioParityEnabled()
                          ? { width: 564, height: 410 }
                          : BLANK_OBJECT),
                      }}
                      deleteButtonVariant={
                        isPortfolioParityEnabled() ? "small" : "x-small"
                      }
                      extensionTagSize={
                        isPortfolioParityEnabled() ? "small" : "x-small"
                      }
                      customDeleteButtonStyle={
                        isPortfolioParityEnabled()
                          ? style.customDeleteButtonStyle
                          : BLANK_OBJECT
                      }
                      showCarouselV2={true}
                      showIconCardsWithExtension={true}
                      scrollableCarouselWrapperStyle={
                        isPortfolioParityEnabled()
                          ? style.scrollableCarouselWrapperStyle
                          : BLANK_OBJECT
                      }
                      setEditAttachmentModal={setEditAttachmentModal}
                      setWorkbookMode={isWorkbook ? setWorkbookMode : undefined}
                      isWorkbook={isWorkbook}
                      removeAttachmentStyle={isPortfolioParityEnabled()}
                      onDeleteMedia={
                        isPortfolioParityEnabled() ? onDeleteMedia : undefined
                      }
                      showDeleteAttachmentIcon={
                        isPortfolioParityEnabled() &&
                        _.includes(["edit", "create"], mode) &&
                        !isWorkbook
                      }
                      showEditIcon={isPortfolioParityEnabled() && isWorkbook}
                      parentType={parentType}
                    />
                  </div>
                ) : _.size(attachments) > 1 ? (
                  <div>
                    <ConditionalWrapper
                      condition={_.size(attachments) > 2}
                      wrapper={
                        <ScrollableCarousel
                          scrollAmount={280} // card width + padding
                          showActiveControlDot={
                            prevAttachmentCount.current !==
                              _.size(attachments) &&
                            prevAttachmentCount.current <= maxAttachmentCount
                          }
                          activeControlDotValue={_.size(attachments)}
                        />
                      }
                      type={"wrapperAsElement"}
                    >
                      {renderAttachment({
                        toggleMediaModalWithIndex,
                        setEditAttachmentModal,
                      })}
                    </ConditionalWrapper>
                  </div>
                ) : null
              ) : null}

              {!isPortfolioAI || isAddLEToJournal ? (
                <div
                  className={
                    isPortfolioParityEnabled()
                      ? classes.attachmentCardFooterV2
                      : classes.attachmentCardFooter
                  }
                  style={
                    isAddLEToJournal
                      ? { flexDirection: "column" }
                      : {
                          marginTop: isJuniorFolio && isOnlyAudio ? "0px" : "",
                          marginBottom:
                            isProjectPost && !isPortfolioParityEnabled()
                              ? "32px"
                              : "",
                        }
                  }
                >
                  {!isAddLEToJournal &&
                    !isAddAllResponsesToJournal &&
                    !isNote &&
                    !isAddStudentAttachmentToJournal &&
                    !isShareEvaluation &&
                    (!isProjectPost
                      ? _.get(mediaCreationOptions, "enableTagging")
                      : isProjectPost) && (
                      <ConditionalWrapper
                        type={"wrapperAsElement"}
                        condition={showAiMarketingIcon}
                        wrapper={
                          <div className={classes.aiOptionWithAttachment}></div>
                        }
                      >
                        <>
                          <CreateDropDown
                            dropDownOptions={
                              isPortfolioParityEnabled() && !isProjectPost
                                ? getDropDownOptionsWithState()
                                : dropdownOptions
                            }
                            onMultipleFilesUploaded={
                              isPortfolioParityEnabled() && !isProjectPost
                                ? onMultipleAttachmentsAdded
                                : _.noop
                            }
                            parentId={"SUBJECT_JOURNAL_FILES_UPLOAD"}
                            parentType={"POST"}
                            multiple={true}
                            addAttachment={onAttachmentAdded}
                            updateLoadingState={setUploadingStatus}
                            isShowIconsInBar={true}
                            showV2Icons={true}
                            iconButtonVariant={
                              isPortfolioParityEnabled()
                                ? "plain"
                                : "outlined-subtle"
                            }
                            showCaptureVoiceIcon={
                              isProjectPost ||
                              isPortfolioParityEnabledAndIsJournalRoute()
                            }
                            disableAllOptions={
                              isPortfolioParityEnabled() &&
                              !isProjectPost &&
                              (isWorkbook
                                ? _.size(fetchAudioAttachment()) === 1
                                : _.size(attachments) >= maxAttachmentCount)
                            }
                            isAudioDisabled={
                              isPortfolioParityEnabled() &&
                              !isProjectPost &&
                              _.size(fetchAudioAttachment()) === 1
                            }
                            reduceSpacingBetweenIcons={isPortfolioParityEnabled()}
                            showPlaceholderFileIcon={isPortfolioParityEnabled()}
                            showNewDesignForCaptureOptions={isPortfolioParityEnabledAndIsJournalRoute()}
                            testId="journal-postcreation-attachmentdropdown"
                          />
                          {showAiMarketingIcon ? (
                            <IconButton
                              size={"small"}
                              dsVersion={"2.0"}
                              variant={"neutral"}
                              className={classes.aiOutline}
                              type={"fill"}
                              id="toddle-ai"
                              shouldStopPropagation
                              icon={<AiOutlined variant={"link"} />}
                              onClick={onAIMarketingClick}
                            />
                          ) : null}
                        </>
                      </ConditionalWrapper>
                    )}
                  {isAddLEToJournal && (
                    <StudentResponseV2
                      item={StudentResponseData}
                      showSeeMore={true}
                      containerStyle={style.containerStyle}
                      mediaPlaceholderContainerStyle={
                        style.mediaPlaceholderContainerStyle
                      }
                      attachmentCardWidth={194}
                      showFullWidthItems={false}
                      evaluationCardStyle={style.evaluationCardStyle}
                      scrollButtonsContainerStyle={
                        style.scrollButtonsContainerStyle
                      }
                      showEvaluation={true}
                      onClickResponse={_.noop}
                      isPreviewCard={true}
                      isSidePaneContent={false}
                      iconSize={"x-small"}
                      assessmentToolTextStyle={style.assessmentToolTextStyle}
                      canAddWorksheetResponseToPost={_.get(
                        screenPanelProps,
                        "canAddWorksheetResponseToPost",
                        false
                      )}
                    />
                  )}
                </div>
              ) : null}

              {isPortfolioAI && !isAddLEToJournal && !isNote ? (
                <div
                  className={
                    isPortfolioParityEnabled()
                      ? classes.attachmentCardFooterV2
                      : classes.attachmentCardFooter
                  }
                  style={
                    isAddLEToJournal
                      ? { flexDirection: "column" }
                      : {
                          marginTop: isJuniorFolio && isOnlyAudio ? "0px" : "",
                          marginBottom: isProjectPost ? "32px" : "",
                        }
                  }
                >
                  {!isAddLEToJournal &&
                  !isAddAllResponsesToJournal &&
                  !showPromptBox &&
                  !isAddStudentAttachmentToJournal &&
                  !isShareEvaluation &&
                  !isNote &&
                  (!isProjectPost
                    ? _.get(mediaCreationOptions, "enableTagging")
                    : isProjectPost) ? (
                    <CreateDropDown
                      dropDownOptions={
                        isPortfolioParityEnabled() && !isProjectPost
                          ? getDropDownOptionsWithState()
                          : dropdownOptions
                      }
                      onMultipleFilesUploaded={
                        isPortfolioParityEnabled() && !isProjectPost
                          ? onMultipleAttachmentsAdded
                          : _.noop
                      }
                      parentId={"SUBJECT_JOURNAL_FILES_UPLOAD"}
                      parentType={"POST"}
                      multiple={true}
                      addAttachment={onAttachmentAdded}
                      updateLoadingState={setUploadingStatus}
                      isShowIconsInBar={true}
                      showV2Icons={true}
                      iconButtonVariant={
                        isPortfolioParityEnabled() ? "plain" : "outlined-subtle"
                      }
                      showCaptureVoiceIcon={
                        isProjectPost ||
                        isPortfolioParityEnabledAndIsJournalRoute()
                      }
                      disableAllOptions={
                        isPortfolioParityEnabled() &&
                        !isProjectPost &&
                        (isWorkbook
                          ? _.size(fetchAudioAttachment()) === 1
                          : _.size(attachments) >= maxAttachmentCount)
                      }
                      isAudioDisabled={
                        isPortfolioParityEnabled() &&
                        !isProjectPost &&
                        _.size(fetchAudioAttachment()) === 1
                      }
                      reduceSpacingBetweenIcons={isPortfolioParityEnabled()}
                      showPlaceholderFileIcon={isPortfolioParityEnabled()}
                      showNewDesignForCaptureOptions={isPortfolioParityEnabledAndIsJournalRoute()}
                      testId="journal-postcreation-attachmentdropdown"
                    />
                  ) : null}
                  <div
                    className={classes.promptBoxContainer}
                    style={{
                      width:
                        showPromptBox || showPromptBoxOverOptions ? "92%" : "",
                      position:
                        showPromptBox || showPromptBoxOverOptions
                          ? "absolute"
                          : "",
                      top:
                        showPromptBox || showPromptBoxOverOptions
                          ? isPortfolioParityEnabled()
                            ? "132px"
                            : "92px"
                          : "",
                      marginLeft: isWorkbook ? "auto" : "",
                      zIndex: 100,
                    }}
                  >
                    <AIInputBox
                      showPromptBox={showPromptBox}
                      setShowPromptBox={setShowPromptBox}
                      showPromptBoxOverOptions={showPromptBoxOverOptions}
                      setShowPromptBoxOverOptions={setShowPromptBoxOverOptions}
                      aiInputRef={aiInputRef}
                      textAreaTitle={getTitleValue(description)}
                      setTextAreaTitle={setDescriptionValue}
                      updateTextAreaInputLocally={updateDescription}
                      enableChatGPTPoweredTextFeatures={true}
                      isFocussedRef={isFocussedRef}
                      textInputRef={textInputRef}
                      contentEditableRef={contentEditableRef}
                      getTextAreaTitle={getTextAreaTitle}
                      placeholder={
                        isTablet
                          ? t("journal:describe_post_tablet")
                          : t("journal:describe_post")
                      }
                      askAIPromptAction={getAskAIPromptAction()}
                      aiIconSize={"medium"}
                      uploadAttachmentPrePostCreation={isPortfolioParityEnabled()}
                      isLeTaggingRequired={
                        isPortfolioParityEnabled() ? true : false
                      }
                      parentContainerRef={parentContainerRef}
                      responseStyle={style.responseStyle}
                      promptIconStyles={style.promptIconStyles}
                      isDP={true}
                      isImageUploading={isUploadingInProgress}
                      subjectNames={subjectNames}
                      showMagicWand={
                        !isNote &&
                        !isWorkbook &&
                        (isPortfolioParityEnabled()
                          ? true
                          : !isDPSubjectJournalEnabled(curriculumProgramType))
                      }
                      magicWandIconSize={"xx-small"}
                      goToStep={goToStep}
                      goToPreviousStep={goToPreviousStep}
                      aiIconVariant="neutral"
                      configureAIVoiceProps={configureAIVoiceProps}
                    />
                  </div>
                </div>
              ) : null}
              {(!isPortfolioParityEnabled()
                ? showPostTags
                : showTagFolder &&
                  _.get(mediaCreationOptions, "enableTagging")) && (
                <div
                  className={
                    isPortfolioParityEnabled()
                      ? classes.tagsInputContainerV2
                      : classes.tagsInputContainer
                  }
                  style={{
                    marginTop: isNote
                      ? "0px"
                      : !isPortfolioAI && isPortfolioParityEnabled()
                      ? "16px"
                      : "",
                  }}
                >
                  {/*Add Custom tags Card */}
                  <CustomTagsCard
                    tags={unionCourseUpdateTags}
                    updateFolderArray={updateFolderArray}
                    updateFolderInArrayByName={updateFolderInArrayByName}
                    attachedTags={updatedTags}
                    t={t}
                    showManageFoldersModal={showManageFoldersModal}
                    setShowManageFoldersModal={setShowManageFoldersModal}
                    setCreateFolderOnModalOpen={setCreateFolderOnModalOpen}
                    userType={userType}
                    showTagPYPElements={showTagPYPElements}
                    isTablet={isTablet}
                  />
                </div>
              )}
            </div>
          </div>
          {/* Tag student card */}
          {(isPortfolioParityEnabled()
            ? _.get(mediaCreationOptions, "enableTagging") &&
              !isJuniorFolio &&
              isStudentTaggingAllowed &&
              !isAddAllResponsesToJournal
            : showTagStudentOption) && (
            <TagStudentCard
              students={students}
              goToStep={goToStep}
              studentSelectionMode={studentSelectionMode}
              updatePost={updatePost}
              t={t}
              customOnTagStudentClick={customOnTagStudentClick}
              excludeSelfFromStudentDetails={excludeSelfFromStudentDetails}
              user={user}
              showTaggedDetails={false}
              isPromptBoxContentPresent={isPromptBoxContentPresent}
              isAIResponseGenerating={isAIResponseGenerating}
              isPromptBoxTextPresent={isPromptBoxTextPresent}
              createdBy={createdBy}
              isAddLEToJournal={isAddLEToJournal}
              isAddStudentAttachmentToJournal={isAddStudentAttachmentToJournal}
              getPostCreatorName={getPostCreatorName}
              isShareEvaluation={isShareEvaluation}
            />
          )}
          {showTagCollections ? (
            <TagCollectionsCard
              t={t}
              taggedCollections={taggedCollections}
              customOnTagCollectionsClick={customOnTagCollectionsClick}
            />
          ) : null}

          {/* Tag CAS learning Outcomes */}
          {showTagProjectElements && (
            <TagProjectElements
              t={t}
              projectGroupType={_.get(props, "projectGroupType", null)}
              elementPYP={_.get(
                screenPanelProps,
                "postDetails.elementPYP",
                BLANK_ARRAY
              )}
              onAddOrEditClick={projectElement =>
                setCurrentStepDetails({
                  showTagModal: true,
                  currentStep: "TAG_PROJECT_ELEMENT",
                  currentElementTag: projectElement,
                })
              }
              updatePost={updatePost}
            />
          )}
          {isSnpV2Enabled &&
          totalNewSnpCycles > 0 &&
          _.get(mediaCreationOptions, "enableTagging") ? (
            <TagCard
              items={_.get(
                _.first(taggedPractices),
                "taggedPractice",
                BLANK_ARRAY
              )}
              leftIcon={<ScopeAndSequenceOutlined size="xx-small" />}
              leftTitle={t("journal:tag_standards_and_practices")}
              onAddClick={() => goToStep("TAG_PRACTICES_V2")}
              onEditClick={() => goToStep("TAG_PRACTICES_V2")}
              onCardClick={() => goToStep("TAG_PRACTICES_V2")}
              expandedContent={
                <TaggedPracticesV2
                  taggedPractices={taggedPractices}
                  postTitle={title}
                />
              }
              count={_.get(taggedPractices, "[0].taggedPractice.length")}
              showCountBadge={showPortfolioParityCard ? true : false}
              taggedDetails={
                !_.isEmpty(taggedPractices) && !showPortfolioParityCard
                  ? t("journal:count_practice", {
                      count: _.get(
                        taggedPractices,
                        "[0].taggedPractice.length"
                      ),
                    })
                  : ""
              }
              onDeleteClick={
                showPortfolioParityCard
                  ? () => updatePost({ taggedPractices: [] })
                  : () => {}
              }
              showDeleteIcon={showPortfolioParityCard}
              isAddLEToJournal={isAddLEToJournal}
              isAddStudentAttachmentToJournal={isAddStudentAttachmentToJournal}
              isShareEvaluation={isShareEvaluation}
              t={t}
            />
          ) : null}
          {showPortfolioParityCard && showTagPYPElements ? (
            <PYPElementTag
              t={t}
              updatePost={updatePost}
              showTagLearningGoalsModal={showTagLearningGoalsModal}
              goToStep={goToStep}
              elementPYP={elementPYP}
              unitPlan={unitPlan}
              postTaggedEntity={postTaggedEntity}
              resourceItem={resourceItem}
              resourceType={resourceType}
              elementData={elementData}
              selectFromAllPYP={selectFromAllPYP}
              onDeleteClick={onElementDeleteClick}
              showPortfolioParityCard={showPortfolioParityCard}
              {...props}
              learningGoalsCount={learningGoalsCount}
              isAddLEToJournal={isAddLEToJournal}
              isAddStudentAttachmentToJournal={isAddStudentAttachmentToJournal}
              isExpanded={
                learningGoalsCount !== prevLearningGoalsCount ||
                !_.isEqual(
                  _.get(oldPostDetails, "unitPlan.id"),
                  _.get(unitPlan, "id")
                ) ||
                !_.isEqual(
                  _.get(oldPostDetails, "resourceItem.id"),
                  _.get(resourceItem, "id")
                )
              }
              setChangeLEWarningModal={setChangeLEWarningModal}
              setDeleteLEWarningModal={setDeleteLEWarningModal}
              showPypElements={true}
              showCardActionButtons={false}
              allowClickOnCard={false}
              showCountBadge={false}
              id={"tagLearningElements"}
              onConfirmDeletionOfLE={onConfirmDeletionOfLE}
              isAddAllResponsesToJournal={isAddAllResponsesToJournal}
              disabled={!isCurrentAcademicYearSelected || isArchivedClass}
              showAccordian={false}
              isShareEvaluation={isShareEvaluation}
              mode={mode}
              userType={userType}
              isNewGradingSetupEnabled={isNewGradingSetupEnabled}
              setShowStandardsModal={setShowStandardsModal}
              showStandardsModal={showStandardsModal}
              setIsStandardSelected={setIsStandardSelected}
              isStandardSelected={isStandardSelected}
              standardLabel={standardLabel}
              isStandardsRevampEnabled={
                isStandardsRevampEnabled || showNewStandardsUIInV1
              }
              showNewStandardsUIInV1={showNewStandardsUIInV1}
              canAddWorksheetResponseToPost={
                _.get(
                  screenPanelProps,
                  "canAddWorksheetResponseToPost",
                  false
                ) || isWorksheetSelected
              }
            />
          ) : null}
          {showStandardsModal ? (
            <StandardSetSelectionModal
              isOpen={showStandardsModal}
              setShowStandardsModal={setShowStandardsModal}
              updatePost={updatePost}
              showNewStandardsUIInV1={showNewStandardsUIInV1}
              courseId={courseId}
            />
          ) : null}
          {showPortfolioParityCard &&
          showRateonLearingGoals &&
          _.isEqual(userType, "staff") ? (
            <RateonLearningGoals
              t={t}
              disabled={
                _.isEmpty(students) || _.isEmpty(elementPYP) || isDisabledInMyp
              }
              openRatingEditor={() => {
                setShowLearningGoalsEditor(true);
                updatePost({
                  academicTerm: { id: currentActiveTerm?.key },
                });
              }}
              setShowPostRatingsModal={setShowPostRatingsModal}
              showPostRatingsModal={showPostRatingsModal}
              postRatingsOfLearningGoals={postRatingsOfLearningGoals}
              onCardClick={() => {
                !_.size(postRatingsOfLearningGoals) &&
                  setShowLearningGoalsEditor(true);
              }}
              isAddLEToJournal={isAddLEToJournal}
              isAddStudentAttachmentToJournal={isAddStudentAttachmentToJournal}
              studentsCount={_.size(students, 0)}
              learningGoalsCount={learningGoalsCount}
              isDisabledInMyp={isDisabledInMyp}
              toggleAlert={toggleAlert}
              isShareEvaluation={isShareEvaluation}
            />
          ) : null}
          {/* curriculumProgramType={curriculumProgramType || CURRICULUM_TYPE_DP} */}
          {showPortfolioParityCard
            ? (showLearningGoalsEditor || showPostRatingsModal) &&
              (enableTermRestriction() && !_.size(currentActiveTerms, 0) ? (
                <NoGradesConfiguredModal
                  onClose={() => {
                    setShowLearningGoalsEditor(false);
                    setShowPostRatingsModal(false);
                  }}
                />
              ) : (
                <PostRateonLearningGoals
                  students={students}
                  elementPYP={elementPYP}
                  curriculumProgramType={curriculumProgramType}
                  showLearningGoalsEditor={showLearningGoalsEditor}
                  onCloseClick={() => {
                    setShowLearningGoalsEditor(false);
                    setShowPostRatingsModal(false);
                  }}
                  mode={mode}
                  showLearningGoalsPreview={showPostRatingsModal}
                  setShowPostRatingsModal={setShowPostRatingsModal}
                  propsIbPypElementRatings={postRatingsOfLearningGoals}
                  originalibPYPElementRatings={originalibPYPElementRatings}
                  currentActiveTerms={currentActiveTerms}
                  currentActiveTerm={currentActiveTerm}
                />
              ))
            : null}

          {!isProjectPost && userType == "staff" && showPortfolioParityCard ? (
            <SharedWithCard
              isAddAllResponsesToJournal={isAddAllResponsesToJournal}
              t={t}
              students={students}
              toggleAlert={toggleAlert}
              goToStep={goToStep}
              hideActionButtons={true}
              isPrivate={isPrivate}
              isHiddenFromStudents={isHiddenFromStudents}
              isAddLEToJournal={isAddLEToJournal}
              isAddStudentAttachmentToJournal={isAddStudentAttachmentToJournal}
              isShareEvaluation={isShareEvaluation}
            />
          ) : null}
        </div>
        {showGoalsRemovalWarningModal && (
          <Modal
            dsVersion="2.0"
            isOpen={showGoalsRemovalWarningModal}
            onClose={onCloseGoalsRemovalWarningModal}
            size="medium"
            height="fit-content"
            width="416px"
          >
            <Modal.Header
              title={t(
                isStandardSelected?.current
                  ? "journal:remove_tagged_standards"
                  : "journal:remove_tagged_learning_goals"
              )}
              isClosable={true}
            />
            <Modal.Body style={{ paddingBlock: "0px" }}>
              <div className={classes.warningModalBody}>
                {t(
                  isStandardSelected?.current
                    ? "journal:remove_tagged_standards_confirmation"
                    : "journal:remove_learning_goals_warning_count",
                  {
                    count:
                      isStandardsRevampEnabled && selectFromAllPYP
                        ? isStandardSelected?.current
                          ? standardsCount
                          : learningGoalsCount - standardsCount
                        : learningGoalsCount,
                  }
                )}
              </div>
            </Modal.Body>
            <Modal.Footer>
              <div className={classes.warningModalFooter}>
                <Button
                  dsVersion="2.0"
                  size="medium"
                  variant="neutral"
                  type="outlined"
                  onClick={onCloseGoalsRemovalWarningModal}
                  className={classes.keepButton}
                >
                  {t("common:keep")}
                </Button>
                <Button
                  dsVersion="2.0"
                  size="medium"
                  variant="destructive"
                  onClick={onConfirmRemovalOfGoals}
                >
                  {t("common:remove")}
                </Button>
              </div>
            </Modal.Footer>
          </Modal>
        )}

        {showChangeLEWarningModal ? (
          <DialogueBoxV3
            modalTitle={`${
              isNewGoalTaggingEnabled
                ? isAssessmentTagged(postTaggedEntity)
                  ? t("journal:retag_learning_experience")
                  : t("journal:edit_unit")
                : !_.isNil(resourceItem)
                ? t("journal:retag_learning_experience")
                : t("journal:change_unit")
            }?`}
            showModal={true}
            onClickButton1={() => {
              setChangeLEWarningModal(false);
            }}
            onClickButton2={onConfirmRemovalOfLE}
            modalBody={
              isNewGoalTaggingEnabled
                ? isAssessmentTagged(postTaggedEntity)
                  ? t("journal:retag_le_warning_message")
                  : t("journal:edit_units_warning")
                : !_.isNil(resourceItem)
                ? t("journal:retag_le_warning_message")
                : t("journal:change_unit_warning_message")
            }
            toggleDialogueBoxDisplay={() => {
              setChangeLEWarningModal(false);
            }}
            button2={
              isNewGoalTaggingEnabled
                ? isAssessmentTagged(postTaggedEntity)
                  ? t("journal:retag")
                  : t("journal:discard_and_startover")
                : !_.isNil(resourceItem)
                ? t("journal:retag")
                : t("journal:change_unit")
            }
            button1={
              isNewGoalTaggingEnabled && !isAssessmentTagged(postTaggedEntity)
                ? t("common:keep")
                : t("common:cancel")
            }
            modalBodyStyle={style.leUnitModalDialogStyle}
            button2Props={
              isNewGoalTaggingEnabled
                ? leOrAssessmentButtonPropsV2.button2Props
                : leOrAssessmentButtonProps.button2Props
            }
            button1Props={
              isNewGoalTaggingEnabled
                ? leOrAssessmentButtonPropsV2.button1Props
                : leOrAssessmentButtonProps.button1Props
            }
          />
        ) : null}
        {showDeleteLEWarningModal ? (
          <DialogueBoxV3
            modalTitle={`${
              isNewGoalTaggingEnabled
                ? isAssessmentTagged(postTaggedEntity)
                  ? t("journal:delete_le_assessment")
                  : t("journal:discard_unit")
                : !_.isNil(resourceItem)
                ? t("journal:delete_le_assessment")
                : t("journal:delete_unit")
            }?`}
            showModal={true}
            onClickButton1={() => {
              setDeleteLEWarningModal(false);
            }}
            onClickButton2={onConfirmDeletionOfLE}
            modalBody={
              isNewGoalTaggingEnabled
                ? isAssessmentTagged(postTaggedEntity)
                  ? t("journal:delete_le_warning_message")
                  : t("journal:discard_unit_warning")
                : !_.isNil(resourceItem)
                ? t("journal:delete_le_assessment_warning_message")
                : t("journal:delete_unit_warning_message")
            }
            toggleDialogueBoxDisplay={() => {
              setDeleteLEWarningModal(false);
            }}
            button2={
              isNewGoalTaggingEnabled ? t("common:discard") : t("common:delete")
            }
            button1={t("common:cancel")}
            modalBodyStyle={style.leUnitModalDialogStyle}
            button2Props={
              isNewGoalTaggingEnabled
                ? leOrAssessmentButtonPropsV2.button2Props
                : leOrAssessmentButtonProps.button2Props
            }
            button1Props={
              isNewGoalTaggingEnabled
                ? leOrAssessmentButtonPropsV2.button1Props
                : leOrAssessmentButtonProps.button1Props
            }
          />
        ) : null}
        <ManageFoldersModal
          onClose={onManageFolderModalClose}
          courseFolders={courseTags}
          isOpen={showManageFoldersModal}
          setCreateFolderOnModalOpen={setCreateFolderOnModalOpen}
          createFolderOnModalOpen={createFolderOnModalOpen}
          courseIdFromParent={courseId}
        />
        {showEditAttachmentModal ? (
          <EditAttachmentModal
            attachments={nonAudioPostAttachments}
            updatePost={updatePost}
            setToastMsg={setToastMsg}
            onClose={onEditAttachmentModalClose}
            onDoneClick={onEditAttachmentModalDoneClick}
            setPostAttachments={setPostAttachments}
            showEditAttachmentModal={showEditAttachmentModal}
          />
        ) : null}
        {showMediaModal &&
        _.size(
          _.filter(attachments, attachment => attachment.type !== "AUDIO")
        ) ? (
          <TheatreModeV2
            mediaAttachments={{
              attachments: nonAudioAttachments,
            }}
            activeAttachmentIndex={currentAttachmentIndex}
            toggleTheatreMode={toggleMediaModal}
            iframeIdSelector={"workbook-iframe-dp-journal"}
            onDiscardDirectly={() => toggleMediaModal(false)}
            onReorderClick={setEditAttachmentModal}
            onDeleteMedia={onDeleteMedia}
            showReorderAndDeleteAttachmentIcon={!isWorkbook}
            toolbarHeaderStyle={{ gridTemplateColumns: `repeat(3,33%)` }}
            showAttachmentCounter={true}
            reorderButtonTooltip={t("journal:reorder_tooltip")}
            setCurrentAttachmentIndex={setCurrentAttachmentIndex}
          />
        ) : null}
        {!!currentDialogAction && isPortfolioParityEnabled() ? (
          <DialogueBoxV3
            modalTitle={t(DIALOGS_INFO[currentDialogAction].title)}
            showModal={true}
            onClickButton2={comment => onDialogConfirmClick(comment)}
            modalBody={t(DIALOGS_INFO[currentDialogAction].message)}
            modalTitleSubText={
              showPromptDetail
                ? DIALOGS_INFO[currentDialogAction].titleSubText({
                    t,
                    name: currentDialogPostCreatorName,
                  })
                : ""
            }
            toggleDialogueBoxDisplay={OnToggleDialogueClick}
            button1={
              t(DIALOGS_INFO[currentDialogAction].cancelButtonText) ||
              t("common:cancel")
            }
            button2={t(DIALOGS_INFO[currentDialogAction].confirmButtonText)}
            isPromptBox={DIALOGS_INFO[currentDialogAction].isPromptBox}
            promptBoxType={DIALOGS_INFO[currentDialogAction].promptBoxType}
            promptDetail={
              showPromptDetail
                ? DIALOGS_INFO[currentDialogAction].promptDetail({ t })
                : DIALOGS_INFO[currentDialogAction].promptDetail
            }
            warningText={
              showPromptDetail &&
              _.has(DIALOGS_INFO[currentDialogAction], "warningText")
                ? DIALOGS_INFO[currentDialogAction].warningText({
                    t,
                    name: currentDialogPostCreatorName,
                  })
                : null
            }
            size={DIALOGS_INFO[currentDialogAction].size}
            button1Props={DIALOGS_INFO[currentDialogAction].button1Props}
            button2Props={DIALOGS_INFO[currentDialogAction].button2Props}
            warningTextStyles={
              DIALOGS_INFO[currentDialogAction].warningTextStyles
            }
            headerStyles={{
              padding: "24px 24px 0px 32px",
              ..._.get(DIALOGS_INFO[currentDialogAction], "headerStyles", {}),
            }}
            modalBodyStyle={
              _.isEqual(currentDialogAction, "REJECT_POST")
                ? { padding: "0px 32px" }
                : { padding: "16px 32px" }
            }
            textAreaRows={_.get(
              DIALOGS_INFO[currentDialogAction],
              "textAreaRows",
              3
            )}
            showAlert={_.isEqual(currentDialogAction, "APPROVE_WITH_COMMENT")}
            showLabel={!_.isEqual(currentDialogAction, "REJECT_POST")}
          />
        ) : null}
      </ScreenPanel>
    </KeyboardShortcuts>
  );
});

const getCurrentActiveTerm = _.memoize(
  ({ selectedActiveTerm, currentActiveTerm }) => {
    const getFormatDate = date => moment(date).format("Do MMM YYYY");
    return {
      label: selectedActiveTerm
        ? selectedActiveTerm?.label
        : `${currentActiveTerm?.label} (${getFormatDate(
            currentActiveTerm?.startDate
          )} - ${getFormatDate(currentActiveTerm?.endDate)})`,
      key: selectedActiveTerm ? selectedActiveTerm?.key : currentActiveTerm?.id,
    };
  },
  ({ selectedActiveTerm, currentActiveTerm }) => {
    return JSON.stringify({
      selectedActiveTerm: _.get(selectedActiveTerm, "key"),
      currentActiveTerm: _.get(currentActiveTerm, "id"),
    });
  }
);

const formatCurrentActiveTerms = getMemoizedLangFunction(
  ({ t, currentActiveTerms }) => {
    const getFormatDate = date => moment(date).format("Do MMM YYYY");
    return _.map(currentActiveTerms, term => {
      const isGradingPeriodUnlocked = getIsGradingPeriodUnlocked(term);

      return {
        label: `${term.label} (${getFormatDate(
          term.startDate
        )} - ${getFormatDate(term.endDate)})`,
        key: term.id,
        disabled: !isGradingPeriodUnlocked,
        disabledTooltip: t(
          "academicSetup:you_cannot_add_ratings_or_observations_since_locked"
        ),
        isGradingPeriodUnlocked,
      };
    });
  },
  ({ currentActiveTerms }) =>
    _.map(currentActiveTerms, term => `${term.id}-${term.lockingStatus}`).join(
      ","
    )
);

const getUnitPlans = _.memoize(
  ({ courseUnitPlans }) => {
    return _.filter(_.map(courseUnitPlans, "node"), item => !_.isEmpty(item));
  },
  ({ courseUnitPlans }) => {
    const courseUnitPlansIds = _.filter(
      _.map(courseUnitPlans, "node.id"),
      item => !_.isEmpty(item)
    );
    return _.join(courseUnitPlansIds, "|");
  }
);

const getOrganizationAcademicYears = _.memoize(
  ({ orgId, curriculumProgramId }) => {
    return {
      id: orgId,
      termsFilters: {
        curriculumProgramIds: curriculumProgramId
          ? [curriculumProgramId]
          : undefined,
      },
    };
  },
  ({ orgId, curriculumProgramId }) => {
    return JSON.stringify({ orgId, curriculumProgramId });
  }
);

const getPostFilters = _.memoize(
  ({ userEntityType, studentIDs }) => {
    return {
      state: "PUBLISHED",
      showPrivate: true,
      isShowHiddenFromStudents: userEntityType === "STAFF",
      unTagged: false,
      orderBy: "PUBLISHED_AT",
      onlyLearningGoalTaggedPost: true,
      studentIds: studentIDs,
      feedTypes: ["PORTFOLIO"],
    };
  },
  ({ userEntityType, studentIDs }) =>
    `${userEntityType}-${_.size(studentIDs) > 0 ? studentIDs.join("|") : ""}`
);

const getStudentFilters = _.memoize(
  ({ filters, selectedStudentIdsFromFilter }) => {
    return {
      ...filters,
      studentIds: [selectedStudentIdsFromFilter],
    };
  },
  ({ filters, selectedStudentIdsFromFilter }) => {
    return JSON.stringify({
      studentId: selectedStudentIdsFromFilter,
      academicYearId: _.get(filters, "academicYear"),
    });
  }
);

const mapStateToProps = (state, ownProps) => {
  const { t } = ownProps;
  const userInfo = getUserInfo();
  const userType = state.login.userInfo.user_type;
  const curriculumProgramType = _.get(
    state,
    "platform.currentCurriculumProgram.type",
    "IB_PYP"
  );
  const curriculumProgramId = state.platform.currentCurriculumProgram.id;
  const postDetails = ownProps?.screenPanelProps?.postDetails;
  const postTaggedEntity = _.get(postDetails, "postTaggedEntity", BLANK_ARRAY);
  const isApprovalRequiredForStudentPosts =
    getSettingValue({
      name: "EnablePostApprovalRequiredForNewStudents",
      courseId: state.teacher.selected_class.selected_course,
      organizationId: state.login.userInfo.org_id,
      userId: state.login.userInfo.id,
      userEntityType: state.login.userInfo.userEntityType,
    }) || userType != "student";

  const user = state.login.userInfo;
  const courseIdFromParent = _.get(
    ownProps,
    "screenPanelProps.postDetails.courseId"
  );
  const courseId = courseIdFromParent
    ? courseIdFromParent
    : state.teacher.selected_class.selected_course;

  const assesmentData = _.find(
    _.get(ownProps, "screenPanelProps.postDetails.items", BLANK_ARRAY),
    item => _.get(item, "itemType", "") === "STUDENT_ASSIGNMENT"
  );
  const isAddLEToJournal =
    _.get(ownProps, "screenPanelProps.isAddLEToJournal", false) ||
    !_.isNil(assesmentData);
  const postParentType = _.get(ownProps, "screenPanelProps.parentType", "");
  const learnerPortfolioId = _.get(ownProps, "params.learnerPortfolioId", null);

  let projectGroupType = null;
  if (_.get(ownProps, "params.projectGroup", undefined) != undefined) {
    projectGroupType = _.get(
      getCurrentProjectGroupDetails({
        state,
      }),
      "type"
    );
  }

  const canScheduleAPost =
    userType == "staff" &&
    _.get(ownProps, "screenPanelProps.mode", "") == "create" &&
    _.get(ownProps, "screenPanelProps.canScheduleAPost", false) == true;

  const organizationAcademicYearsVariables = getOrganizationAcademicYears({
    orgId: userInfo.org_id,
    curriculumProgramId,
  });

  const postCount = 5;
  const typeForPostQuery = "COURSE";
  const userId = _.get(userInfo, "id");
  const userEntityType = _.get(userInfo, "userEntityType");
  const studentIDs = [];
  if (userEntityType === "STUDENT") {
    studentIDs.push(userId);
  }

  const postFilters = getPostFilters({ userEntityType, studentIDs });

  const { unitPlan = {}, elementPYP = [], studentIds = [] } = postDetails;
  const plannerElementSets = _.get(
    state,
    "platform.currentPlannerElementSets",
    []
  );

  let selectFromAllPYP = postDetails?.selectFromAllPYP;
  if (
    !selectFromAllPYP &&
    !_.isEmpty(elementPYP) &&
    _.isEmpty(unitPlan) &&
    _.isEmpty(_.get(postDetails, "resourceItem", {})) &&
    (getIsNewGoalTaggingEnabled()
      ? isUnitPlanOrAssessmentTagged(postTaggedEntity)
      : true)
  )
    selectFromAllPYP = true;
  const activeTermId = state?.post?.postDetails?.academicTerm?.id;

  const currentAcademicYear = getCurrentAcademicYear({
    organizationId: state.login.userInfo.org_id,
  });

  const courseDetails = getCourseDetailsFromCache({
    id: courseId || courseIdFromParent,
    courseGradeFilters: {
      academicYearId: _.get(currentAcademicYear, "id", undefined),
    },
  });

  const courseSubjects = _.get(courseDetails, "subjects", []);
  const subjectNames = _.map(courseSubjects, subject => subject?.name);

  const isUploadingInProgress = !_.isEmpty(
    _.get(state, "app_services.progressOfUploads", {})
  );

  const isAIResponseGenerating = _.get(
    state,
    "post.postDetails.isAIResponseGenerating",
    false
  );
  const isPromptBoxContentPresent = _.get(
    state,
    "post.postDetails.isPromptBoxContentPresent",
    false
  );
  const isPromptBoxTextPresent = _.get(
    state,
    "post.postDetails.isPromptBoxTextPresent",
    false
  );
  const createdBy = _.get(state, "post.postDetails.createdBy", BLANK_OBJECT);
  const isArchivedClass = _.get(
    state,
    "teacher.selected_class.isArchivedClass",
    false
  );
  const isCurrentAcademicYearSelected =
    _.get(state, "platform.academicYearSelected.isCurrentAcademicYear", true) ||
    getSettingValue({
      name: "EnablePreviousAYPostCreation",
      userId: userInfo.id,
      readFromUserAndOrgLevel: true,
    });

  const showRateonLearingGoals =
    userType === "staff" &&
    getSettingValue({
      name: "EnablePostRatingOnLearningGoals",
      courseId: state?.teacher?.selected_class?.selected_course,
      organizationId: userInfo?.org_id,
      userId: userInfo?.id,
      userEntityType: userInfo?.userEntityType,
    }) &&
    !_.get(
      ownProps,
      "screenPanelProps.postDetails.isAddAllResponsesToJournal",
      false
    );

  const showTagPYPElements =
    getSettingValue({
      name: "EnablePYPElementsTaggingInPostByStudents",
      courseId: state.teacher.selected_class.selected_course,
      organizationId: userInfo.org_id,
      userId: userInfo.id,
      userEntityType: userInfo.userEntityType,
    }) || userType != "student";

  const showTagFolder =
    getSettingValue({
      name: "EnableTaggingFolderInPostByStudents",
      courseId: state.teacher.selected_class.selected_course,
      organizationId: userInfo.org_id,
      userId: userInfo.id,
      userEntityType: userInfo.userEntityType,
    }) || userType !== "student";

  const defaultNameSortPreference = getDefaultNameSortPreference(state);

  const translationFilter = getPostTranslationFilter({
    userInfo,
    shouldTranslate: false,
    handleTranslation: hasTranslationPermission(),
  });

  const oldPostDetails = getPostDetailsFromCache({
    postId: _.get(postDetails, "id", null),
    translationFilter: translationFilter,
  });

  const defaultStudentNameOrderPreference = getDefaultStudentNameOrderPreference(
    state
  );

  const learningCourseIdFromPost = _.get(
    state,
    "post.postDetails.course.learningCourse[0].id"
  );

  const isStudentTaggingAllowed =
    getSettingValue({
      name: "EnableStudentTaggingInPostCreationForStudents",
      courseId: state.teacher.selected_class.selected_course,
      organizationId: userInfo.org_id,
      userId: userInfo.id,
      userEntityType: userInfo.userEntityType,
    }) || userType !== "student";

  const progressOfUploads = _.get(state, "app_services.progressOfUploads");
  const isLearningCourseEnabled =
    getIsLearningCoursesEnabled(state) && _.isEqual(userType, "staff");
  const learningCourseId =
    getSelectedLearningCourseId(state) || learningCourseIdFromPost;

  const postPermissionData = getSettingValue({
    name:
      userType === "student"
        ? "GradeWisePortfolioAttachmentTypesStudent"
        : "GradeWisePortfolioAttachmentTypesEducator",
    ...(isLearningCourseEnabled
      ? { learningCourseId }
      : { courseId: state.teacher.selected_class.selected_course }),
  });

  const postPermissionMediaOptions = [];
  _.forEach(_.get(postPermissionData, "data"), (key, value) => {
    const parsedKey = JSON.parse(key);
    if (_.includes(["food", "nap", "toilet"], value)) {
      parsedKey &&
        postPermissionMediaOptions.push(`ACTIVITY_${_.toUpper(value)}`);
    } else if (value === "audio" && parsedKey) {
      postPermissionMediaOptions.push("VOICE");
    } else
      parsedKey &&
        value !== "collage" &&
        postPermissionMediaOptions.push(_.toUpper(value));
  });
  const portfolioType = _.get(postPermissionData, "type");
  const isGlobalHeaderVisible = _.get(
    state,
    "login.globalHeader.isVisible",
    false
  );
  const defaultGrade = _.get(
    state,
    "post.postDetails.course.primaryGrade.id",
    null
  );

  const maxAttachmentCount = getSettingValue({
    name: "PortfolioAttachmentCount",
    organizationId: state.login.userInfo.org_id,
  });

  const selectedStudentIdsFromFilter = _.get(
    state,
    "journal.filters.studentIds",
    BLANK_STRING
  );

  const isNewGradingSetupEnabled = getIsNewGradingSetupEnabled();
  const isStandardsRevampEnabled =
    getIsStandardsRevampEnabled() && getIsLearningCoursesEnabled(state);

  const standardLabel = _.get(
    getCurrentPlannerElementSetFromState(
      _.get(
        plannerElementFieldUidMap,
        _.get(STANDARD_UIDS, curriculumProgramType)
      )
    )(state),
    "label",
    "Standards"
  );

  const showNewStandardsUIInV1 =
    !learningCourseId && !isUnitPlanOrAssessmentTagged(postTaggedEntity);
  return {
    userType,
    courseId,
    isLearningCourseEnabled,
    learningCourseId,
    isAddLEToJournal,
    projectGroupType,
    canScheduleAPost,
    postParentType,
    learnerPortfolioId,
    organizationId: userInfo.org_id,
    organizationAcademicYearsVariables,
    postCount,
    typeForPostQuery,
    postFilters,
    elementData: getElementData({
      isPost: true,
      elements: elementPYP,
      field_list: getFieldList({ curriculumProgramType }),
      unitPlanFields: getIsNewGoalTaggingEnabled()
        ? getUnitPlanFields(postTaggedEntity)
        : _.get(unitPlan, "fields", {}),
      deriveSubjectIdsFromNodes: true,
      skipRemoveSubjectCheck: getIsNewGradingSetupEnabled(),
      t,
      shouldGenerateParentChildRelation:
        showNewStandardsUIInV1 && curriculumProgramType === CURRICULUM_TYPE_DP,
    }),
    taggableElements: getTaggableElements({
      curriculumProgramType,
      unitPlan,
      plannerElementSets,
    }),
    selectFromAllPYP,
    postRatingsOfLearningGoals: _.get(postDetails, "ibPYPElementRatings", []),
    originalibPYPElementRatings: _.get(
      postDetails,
      "originalibPYPElementRatings",
      []
    ),
    activeTermId,
    subjectNames,
    isUploadingInProgress,
    isAIResponseGenerating,
    isPromptBoxContentPresent,
    isPromptBoxTextPresent,
    createdBy,
    isArchivedClass,
    showRateonLearingGoals,
    showTagPYPElements,
    showTagFolder,
    defaultNameSortPreference,
    oldPostDetails,
    defaultStudentNameOrderPreference,
    isStudentTaggingAllowed,
    progressOfUploads,
    user,
    isApprovalRequiredForStudentPosts,
    isCurrentAcademicYearSelected,
    postPermissionMediaOptions,
    portfolioType,
    isGlobalHeaderVisible,
    defaultGrade,
    maxAttachmentCount,
    selectedStudentIdsFromFilter,
    filters: getStudentFilters({
      filters: _.merge(_.get(state, "post.studentListFilters", {}), {
        academicYear: getSelectedAcademicYearId(state),
      }),
      selectedStudentIdsFromFilter,
    }),
    postId: _.get(postDetails, "id", null),
    userId,
    academicYearId: _.get(currentAcademicYear, "id", undefined),
    curriculumProgramType,
    isNewGradingSetupEnabled,
    isStandardsRevampEnabled,
    standardLabel,
    showNewStandardsUIInV1,
  };
};
const mapActionCreators = {
  deleteAttachments,
  setToastMsg,
  updatePostStatus,
  downloadFromUrl,
  removeProgressElement,
  updatePostStatusV2,
  enableGlobalHeader,
  disableGlobalHeader,
  isAIModuleMarketingEnabled,
  setAiModuleMarketingKey,
};

export default compose(
  withRouter,
  I18nHOC({ resource: ["common", "journal", "academicSetup", "project"] }),
  connect(mapStateToProps, mapActionCreators),
  // -- WE WILL USE FOLDERS STRUCTURE AS A CUSTOM TAGS FROM POST --
  graphql(getStudentAssignmentDetailsQuery, {
    skip: ({
      screenPanelProps: {
        isAddLEToJournal,
        isAddAllResponsesToJournal,
        mode,
        parentType,
        postDetails,
      },
    }) =>
      mode === "edit" ||
      !isAddLEToJournal ||
      isAddAllResponsesToJournal ||
      parentType === "projects" ||
      !_.get(postDetails, "studentAssignmentId"),
    name: "getStudentAssignmentDetails",
    options: ({
      screenPanelProps: {
        postDetails: { studentAssignmentId, isSharedWithStudent },
      },
      userType,
    }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        id: studentAssignmentId,
        showOnlySubmitted: false,
        userFilter: getToolResponseUserFilter(userType, isSharedWithStudent),
        entityEventsFilter: {
          orderBy: "EVENT_TIME",
          orderByDir: "ASC",
        },
      },
    }),
    props({ getStudentAssignmentDetails }) {
      const studentAssignmentData = getStudentAssignmentDetailsFromCache(
        getStudentAssignmentDetails.variables
      );

      const toolResponses = _.get(
        studentAssignmentData,
        "toolResponses",
        BLANK_OBJECT
      );
      const ibPYPElementRatings = _.get(
        studentAssignmentData,
        "ibPYPElementRatings",
        BLANK_ARRAY
      );
      return {
        toolResponses,
        ibPYPElementRatings,
      };
    },
  }),
  graphql(getCourseFolders, {
    name: "getCourseFolders",
    skip: ({ courseId, showPostTags, postParentType }) =>
      _.isNil(courseId) ||
      _.isEmpty(courseId) ||
      _.isEqual(showPostTags, false) ||
      _.isEqual(postParentType, "learnerPortfolio"),
    options: ({ courseId }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        courseId: courseId,
      },
    }),
    props({ getCourseFolders, ownProps: { courseId } }) {
      const data = getCourseFoldersFromCache(courseId);

      return {
        isData: !_.isEmpty(data),
        courseTags: _.get(data, "folders", BLANK_ARRAY),
        networkStatus: getCourseFolders.networkStatus,
        isLoading:
          getCourseFolders["networkStatus"] == 1 ||
          getCourseFolders["networkStatus"] == 2,
      };
    },
  }),
  // Fetch tags for learner portfolio
  graphql(getLearnerPortfolioTagsQuery, {
    name: "getLearnerPortfolioTags",
    skip: ({ learnerPortfolioId, showPostTags, postParentType }) =>
      _.isNil(learnerPortfolioId) ||
      _.isEmpty(learnerPortfolioId) ||
      _.isEqual(showPostTags, false) ||
      !_.isEqual(postParentType, "learnerPortfolio"),
    options: ({ learnerPortfolioId }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        id: learnerPortfolioId,
        filters: {
          tagDataSet: "STUDENT_LEARNER_PORTFOLIO",
        },
      },
    }),
    props({ getLearnerPortfolioTags, ownProps: { learnerPortfolioId } }) {
      const data = getLearnerPortfolioTagsFromCache({
        id: learnerPortfolioId,
        filters: {
          tagDataSet: "STUDENT_LEARNER_PORTFOLIO",
        },
      });

      return {
        isData: !_.isEmpty(data),
        courseTags: _.get(data, "node.tags", BLANK_ARRAY),
        networkStatus: getLearnerPortfolioTags.networkStatus,
        isLoading:
          getLearnerPortfolioTags["networkStatus"] == 1 ||
          getLearnerPortfolioTags["networkStatus"] == 2,
      };
    },
  }),
  graphql(getCourseUnitQuery, {
    name: "getCourseUnit",
    skip: ({ courseId, isLearningCourseEnabled }) =>
      isLearningCourseEnabled ||
      _.isNil(courseId) ||
      _.isEmpty(courseId) ||
      (!isPortfolioParityEnabledAndIsJournalRoute() &&
        !isPortfolioReviewSetupEnabledAndIsReviewRoute()),
    options: ({ courseId, userType }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        filters: {
          searchText: "",
        },
        id: courseId,
      },
    }),
    props({ getCourseUnit, ownProps: { courseId } }) {
      const courseDetail = getCourseUnitFromCache({
        filters: {
          searchText: "",
        },
        id: courseId,
      });
      return {
        courseUnitPlans: getUnitPlans({
          courseUnitPlans: _.get(
            courseDetail,
            "flatUnitPlans.edges",
            BLANK_ARRAY
          ),
        }),
        isData: !_.isEmpty(courseDetail),
        isLoading:
          getCourseUnit["networkStatus"] == 1 ||
          getCourseUnit["networkStatus"] == 2,
      };
    },
  }),
  graphql(getOrganizationAcademicYearsQuery, {
    name: "getOrganizationAcademicYears",
    skip: ({ organizationId }) =>
      !organizationId || !isPortfolioParityEnabled(),
    options: ({ organizationAcademicYearsVariables }) => ({
      fetchPolicy: "cache-and-network",
      variables: organizationAcademicYearsVariables,
    }),
    props({
      getOrganizationAcademicYears,
      ownProps: { t, organizationAcademicYearsVariables, activeTermId, isData },
    }) {
      const data = getOrganizationAcademicYearsFromCache(
        organizationAcademicYearsVariables
      );
      const currentAcademicYear = _.filter(
        _.get(data, "node.academicYears", []),
        item => item?.isCurrentAcademicYear
      );
      let currentActiveTerms = [];
      _.forEach(currentAcademicYear, item => {
        !_.isNil(item.terms) && currentActiveTerms.push(...item.terms);
      });
      const getFormatDate = date => moment(date).format("Do MMM YYYY");
      const currentActiveTerm = getCurrentTerm({ terms: currentActiveTerms });
      currentActiveTerms = formatCurrentActiveTerms({ t, currentActiveTerms });
      const _selectedActiveTerm = _.find(
        currentActiveTerms,
        term =>
          term.key === (activeTermId ? activeTermId : currentActiveTerm?.id)
      );
      const selectedActiveTerm = _.get(
        _selectedActiveTerm,
        "isGradingPeriodUnlocked"
      )
        ? _selectedActiveTerm
        : getNextUnlockedTerm({
            termsOptions: currentActiveTerms,
            selectedTerm: _selectedActiveTerm,
          });
      // Note:This will either select the current active term or the term which is selected by the user.
      return {
        currentActiveTerms,
        currentActiveTerm: getCurrentActiveTerm({
          selectedActiveTerm,
          currentActiveTerm,
        }),
        isData: !_.isEmpty(currentActiveTerms) || isData,
        isLoading:
          getOrganizationAcademicYears["networkStatus"] == 1 ||
          getOrganizationAcademicYears["networkStatus"] == 2,
      };
    },
  }),
  graphql(getPostsHavingTaggedGoalsQuery, {
    name: "getPostsHavingTaggedGoals",
    skip: ({ courseId }) => !courseId || !isPortfolioParityEnabled(),
    options: ({ courseId, postCount, postFilters, typeForPostQuery }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        id: courseId,
        last: postCount,
        filters: postFilters,
        type: typeForPostQuery,
      },
    }),
    props: ({
      getPostsHavingTaggedGoals,
      ownProps: {
        courseId,
        postCount,
        postFilters,
        typeForPostQuery,
        isData,
        isLoading,
      },
    }) => {
      const postsData = getPostsHavingTaggedGoalsQueryFromCache({
        courseId,
        postCount,
        postFilters,
        typeForPostQuery,
      });
      const postsWithGoals = _.get(postsData, "node.posts", []);
      return {
        postsWithGoals: postsWithGoals,
        isRecentPost: _.size(_.get(postsWithGoals, "edges", [])) > 0,
        getPostsHavingTaggedGoals,
        isLoading:
          getPostsHavingTaggedGoals.networkStatus === 1 ||
          getPostsHavingTaggedGoals.networkStatus === 2 ||
          isLoading,
      };
    },
  }),
  graphql(getCourseFilteredStudentQuery, {
    name: "getCourseFilteredStudent",
    skip: ({
      selectedStudentIdsFromFilter,
      user,
      isProjectPost,
      courseId,
      isCurrentAcademicYearSelected,
    }) =>
      !selectedStudentIdsFromFilter ||
      !isPortfolioParityEnabled() ||
      user.user_type === "student" ||
      isProjectPost ||
      !courseId ||
      !isCurrentAcademicYearSelected,
    options: ({
      courseId,
      filters,
      postId,
      defaultNameSortPreference,
      academicYearId,
    }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        id: courseId,
        filters: getUpdatedArchivedFilters(filters, {
          entityType: "JOURNAL",
          entityId: postId,
        }),
        orderBy: defaultNameSortPreference,
        orderByDirection: ASC,
        userArchivedFilters: { academicYearId },
      },
    }),
    props({
      getCourseFilteredStudent,
      ownProps: {
        courseId,
        filters,
        postId,
        defaultNameSortPreference,
        academicYearId,
      },
    }) {
      const data = getCourseFilteredStudentFromCache({
        courseId,
        filters: getUpdatedArchivedFilters(filters, {
          entityType: "JOURNAL",
          entityId: postId,
        }),
        orderBy: defaultNameSortPreference,
        orderByDirection: ASC,
        userArchivedFilters: { academicYearId },
      });
      return {
        isData: !_.isEmpty(data),
        studentEdges: _.get(data, "students.edges", BLANK_ARRAY),
        networkStatus: getCourseFilteredStudent.networkStatus,
        isLoading:
          getCourseFilteredStudent["networkStatus"] == 1 ||
          getCourseFilteredStudent["networkStatus"] == 2,
      };
    },
  }),
  graphql(getConfigurationQuery, {
    name: "getConfigurationQuery",
    skip: ({ defaultGrade }) =>
      !isPortfolioReviewSetupEnabledAndIsReviewRoute() || !defaultGrade,
    options: ({ defaultGrade }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        configurationEntityGroupFilters: createConfigurationFilters([
          defaultGrade,
        ]),
        isAdminPage: true,
        isSettingsPage: false,
      },
    }),
    props: ({
      getConfigurationQuery,
      ownProps: { isLoading, isData, defaultGrade },
    }) => {
      const postPermissionData = JSON.parse(
        _.get(
          getConfigurationQuery,
          "platform.configuration[0].configurations[1].value"
        ) || "{}"
      );

      const postPermissionMediaOptions = [];
      _.forEach(_.get(postPermissionData, "data"), (key, value) => {
        const parsedKey = JSON.parse(key);
        if (_.includes(["food", "nap", "toilet"], value)) {
          parsedKey &&
            postPermissionMediaOptions.push(`ACTIVITY_${_.toUpper(value)}`);
        } else if (value === "audio" && parsedKey) {
          postPermissionMediaOptions.push("VOICE");
        } else
          parsedKey &&
            value !== "collage" &&
            postPermissionMediaOptions.push(_.toUpper(value));
      });
      const portfolioType = _.get(postPermissionData, "type");
      return {
        isData,
        isLoading:
          getConfigurationQuery["networkStatus"] == 1 ||
          getConfigurationQuery["networkStatus"] == 2 ||
          isLoading,
        postPermissionMediaOptions,
        portfolioType,
      };
    },
  })
)(ManageSubjectJournalPost);
ManageSubjectJournalPost.displayName = "ManageSubjectJournalPost";
CustomTagsCard.displayName = "CustomTagsCard";
